// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

/**
 * ActivityActorResponse
 */
export const zActivityActorResponse = z.object({
    uuid: z.uuid(),
    name: z.string(),
    avatar: z.string().nullable()
});

/**
 * ActivityAggregatesResponse
 */
export const zActivityAggregatesResponse = z.object({
    total_count: z.int(),
    category: z.record(z.string(), z.int()),
    object_type: z.record(z.string(), z.int()),
    actor: z.record(z.string(), z.int())
});

/**
 * ActivityCategory
 */
export const zActivityCategory = z.enum([
    'contratos',
    'reserva_y_cuota',
    'pagos',
    'fiscal',
    'documentos',
    'cambios',
    'registro'
]);

/**
 * AdminDashboardStats
 *
 * Dashboard statistics response for platform admin.
 */
export const zAdminDashboardStats = z.object({
    total_organizations: z.int(),
    total_users: z.int(),
    active_users: z.int(),
    inactive_users: z.int()
});

/**
 * AssignPendingItemRequest
 *
 * Assign the item to an internal member, or ``null`` to leave it unassigned.
 */
export const zAssignPendingItemRequest = z.object({
    assignee_uuid: z.uuid().nullish()
});

/**
 * AttachmentBlockPreviewResponse
 */
export const zAttachmentBlockPreviewResponse = z.object({
    kind: z.literal('attachment')
});

/**
 * AuditState
 *
 * Where the expense audit of a quota stands (``scratch:auditoria-gasto.tsx:873-886``).
 *
 * Derived, never stored, and derived in exactly one place — the quota entity —
 * so the page, the rail and the card of the quota cannot disagree. Orthogonal
 * to ``FiscalQuotaState``: that one is the phase a person chose, this one is
 * what the audit actually holds.
 */
export const zAuditState = z.enum([
    'no_documents',
    'in_progress',
    'consolidated'
]);

/**
 * AuthChangePasswordRequest
 *
 * Request model for password change
 */
export const zAuthChangePasswordRequest = z.object({
    old_password: z.string(),
    new_password: z.string().min(8)
});

/**
 * AuthConfirmEmailChangeRequest
 *
 * The token the link in the email carries. Public: confirming needs no session.
 */
export const zAuthConfirmEmailChangeRequest = z.object({
    token: z.string()
});

/**
 * AuthForgotPasswordRequest
 *
 * Request model for password reset
 */
export const zAuthForgotPasswordRequest = z.object({
    token: z.string(),
    new_password: z.string().min(8)
});

/**
 * AuthLoginRequest
 *
 * Request model for user login
 */
export const zAuthLoginRequest = z.object({
    email: z.email(),
    password: z.string()
});

/**
 * AuthLogoutRequest
 *
 * Request model for user logout
 */
export const zAuthLogoutRequest = z.object({
    refresh_token: z.string()
});

/**
 * AuthRefreshRequest
 *
 * Request model for token refresh
 */
export const zAuthRefreshRequest = z.object({
    refresh_token: z.string()
});

/**
 * AuthResetPasswordRequest
 *
 * Request model for password reset
 */
export const zAuthResetPasswordRequest = z.object({
    email: z.email()
});

/**
 * AuthRevokeOtherSessionsRequest
 *
 * «Cerrar el resto de sesiones»: the session that stays open names itself.
 *
 * An access token carries no ``jti``, so the only thing the caller holds that
 * names *this* session rather than the whole account is its refresh token.
 */
export const zAuthRevokeOtherSessionsRequest = z.object({
    refresh_token: z.string()
});

/**
 * AuthRevokeOtherSessionsResponse
 *
 * How many sessions were closed.
 */
export const zAuthRevokeOtherSessionsResponse = z.object({
    revoked: z.int()
});

/**
 * AuthSwitchOrganizationRequest
 *
 * Request model for organization switching
 */
export const zAuthSwitchOrganizationRequest = z.object({
    organization_uuid: z.uuid()
});

/**
 * AuthTokenResponse
 *
 * Response model for authentication tokens
 */
export const zAuthTokenResponse = z.object({
    access_token: z.string(),
    refresh_token: z.string(),
    expires_in: z.int(),
    token_type: z.string()
});

/**
 * AuthVerifyEmailRequest
 *
 * Request model for email verification
 */
export const zAuthVerifyEmailRequest = z.object({
    token: z.string()
});

/**
 * BeneficiaryBankAccountCreateRequest
 *
 * Request model for creating a bank account
 */
export const zBeneficiaryBankAccountCreateRequest = z.object({
    bank_name: z.string().nullish(),
    iban: z.string(),
    swift: z.string().nullish(),
    is_primary: z.boolean().optional().default(false)
});

/**
 * BeneficiaryBankAccountResponse
 *
 * Response model for bank account data
 */
export const zBeneficiaryBankAccountResponse = z.object({
    uuid: z.uuid(),
    bank_name: z.string().nullable(),
    iban: z.string(),
    swift: z.string().nullable(),
    has_certificate: z.boolean(),
    is_primary: z.boolean(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * BeneficiaryBankAccountUpdateRequest
 *
 * Request model for updating a bank account
 */
export const zBeneficiaryBankAccountUpdateRequest = z.object({
    bank_name: z.string().nullish(),
    iban: z.string().nullish(),
    swift: z.string().nullish(),
    is_primary: z.boolean().nullish()
});

/**
 * BeneficiaryLegalRepresentativeCreateRequest
 *
 * Request model for creating a legal representative
 */
export const zBeneficiaryLegalRepresentativeCreateRequest = z.object({
    first_name: z.string(),
    last_name: z.string(),
    dni: z.string(),
    position: z.string().nullish(),
    phone: z.string().nullish(),
    email: z.string().nullish(),
    is_primary: z.boolean().optional().default(true),
    is_signer: z.boolean().optional().default(true)
});

/**
 * BeneficiaryLegalRepresentativeResponse
 *
 * Response model for legal representative data
 */
export const zBeneficiaryLegalRepresentativeResponse = z.object({
    uuid: z.uuid(),
    first_name: z.string(),
    last_name: z.string(),
    full_name: z.string(),
    dni: z.string(),
    position: z.string().nullable(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    is_primary: z.boolean(),
    is_signer: z.boolean(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * BeneficiaryLegalRepresentativeUpdateRequest
 *
 * Request model for updating a legal representative
 */
export const zBeneficiaryLegalRepresentativeUpdateRequest = z.object({
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    dni: z.string().nullish(),
    position: z.string().nullish(),
    phone: z.string().nullish(),
    email: z.string().nullish(),
    is_primary: z.boolean().nullish(),
    is_signer: z.boolean().nullish()
});

/**
 * BeneficiaryPrimaryContactResponse
 *
 * Primary legal representative of a beneficiary, as the list row shows it
 */
export const zBeneficiaryPrimaryContactResponse = z.object({
    uuid: z.uuid(),
    full_name: z.string(),
    position: z.string().nullish()
});

/**
 * BeneficiaryStatusBreakdownResponse
 *
 * Response model for beneficiary status breakdown.
 */
export const zBeneficiaryStatusBreakdownResponse = z.object({
    active: z.int(),
    inactive: z.int()
});

/**
 * BeneficiaryMetricsResponse
 *
 * Response model for aggregated beneficiary metrics.
 * Used for the /beneficiaries/metrics endpoint to provide summary KPIs.
 */
export const zBeneficiaryMetricsResponse = z.object({
    total_count: z.int(),
    by_status: zBeneficiaryStatusBreakdownResponse,
    total_capacity: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    available: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    reserved: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    completed: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/)
});

/**
 * BlockVariantResponse
 *
 * Response schema for a single block variant.
 */
export const zBlockVariantResponse = z.object({
    key: z.string(),
    label: z.string(),
    description: z.string()
});

/**
 * Body_add_project_poster
 */
export const zBodyAddProjectPoster = z.object({
    poster_file: z.string()
});

/**
 * Body_create_project_poster
 */
export const zBodyCreateProjectPoster = z.object({
    poster_file: z.string()
});

/**
 * Body_upload_investment_document
 */
export const zBodyUploadInvestmentDocument = z.object({
    document: z.string()
});

/**
 * Body_upload_payment_receipt
 */
export const zBodyUploadPaymentReceipt = z.object({
    file: z.string()
});

/**
 * BoundContractStatus
 *
 * How far a binding contract went: sent to its signers, signed, or uploaded already signed outside the platform.
 */
export const zBoundContractStatus = z.enum([
    'sent',
    'signed',
    'uploaded'
]);

/**
 * BulkAssignPendingItemsRequest
 *
 * Assign each item to the same member, or to nobody.
 */
export const zBulkAssignPendingItemsRequest = z.object({
    pending_item_codes: z.array(z.string()).min(1).max(200),
    data: zAssignPendingItemRequest.optional()
});

/**
 * BulkBeneficiariesRequest
 *
 * The beneficiaries a bulk action applies to.
 */
export const zBulkBeneficiariesRequest = z.object({
    beneficiary_uuids: z.array(z.uuid()).min(1).max(200)
});

/**
 * BulkClassificationsRequest
 *
 * The classifications a bulk action applies to.
 */
export const zBulkClassificationsRequest = z.object({
    classification_uuids: z.array(z.uuid()).min(1).max(200)
});

/**
 * BulkContractsRequest
 *
 * The contracts a bulk action applies to.
 */
export const zBulkContractsRequest = z.object({
    contract_uuids: z.array(z.uuid()).min(1).max(200)
});

/**
 * BulkFailure
 *
 * An item the action refused.
 */
export const zBulkFailure = z.object({
    id: z.string(),
    error_code: z.string(),
    message: z.string()
});

/**
 * BulkActionResponse
 *
 * What a bulk action did to each item: applied, or refused with the reason.
 */
export const zBulkActionResponse = z.object({
    succeeded: z.array(z.string()),
    failed: z.array(zBulkFailure)
});

/**
 * BulkFiscalQuotasRequest
 *
 * The fiscal quotas a bulk action applies to.
 */
export const zBulkFiscalQuotasRequest = z.object({
    fiscal_quota_uuids: z.array(z.uuid()).min(1).max(200)
});

/**
 * BulkInvestorsRequest
 *
 * The investors a bulk action applies to.
 */
export const zBulkInvestorsRequest = z.object({
    investor_uuids: z.array(z.uuid()).min(1).max(200)
});

/**
 * BulkPendingItemsRequest
 *
 * The pending items a bulk action applies to, by their ``queue:object_uuid`` code.
 */
export const zBulkPendingItemsRequest = z.object({
    pending_item_codes: z.array(z.string()).min(1).max(200)
});

/**
 * BulkTemplatesRequest
 *
 * The templates a bulk action applies to.
 */
export const zBulkTemplatesRequest = z.object({
    template_uuids: z.array(z.uuid()).min(1).max(200)
});

/**
 * CategorizationData
 *
 * Categorization result from the expense categorizer stage.
 */
export const zCategorizationData = z.object({
    category_id: z.string().nullish(),
    category_name: z.string().nullish(),
    subcategory_id: z.string().nullish(),
    subcategory_name: z.string().nullish(),
    confidence: z.number().nullish(),
    method: z.string().nullish(),
    flags: z.array(z.string()).optional()
});

/**
 * CategoryBreakdownResponse
 *
 * Net (without VAT) expense breakdown for one fiscal_category.
 *
 * `eligible_amount` is the figure the UI surfaces prominently — spend
 * declarable under Art. 36 LIS, i.e. ``eligibility = DEDUCIBLE``.
 * CONDICIONAL rows are *not* counted here; they live in
 * ``FinancialMetricsResponse.conditional_spend``. `total` is the full
 * bucket aggregate (DEDUCIBLE + CONDICIONAL) so the UI can show a
 * "% deducible" ratio without an extra payload.
 */
export const zCategoryBreakdownResponse = z.object({
    fiscal_category: z.string(),
    fiscal_category_name: z.string(),
    total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    percentage: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    eligible_count: z.int(),
    eligible_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    total_count: z.int()
});

/**
 * CertificateFields
 *
 * Extracted fields for certificates (certificado).
 */
export const zCertificateFields = z.object({
    issuing_authority: z.string().nullable(),
    certificate_type: z.string().nullable(),
    modelo_number: z.string().nullable(),
    tax_period: z.string().nullable(),
    amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    currency: z.string().nullable(),
    subject_tax_id: z.string().nullable(),
    subject_name: z.string().nullable()
});

/**
 * ClassificationDisposition
 *
 * Human decision over a classification's content (#313) — orthogonal to
 * the machine-owned processing state in ``status``.
 *
 * Values are UPPERCASE to match the ``classification_disposition`` PG enum
 * (same convention as ``Eligibility``). Only review flows write it:
 * - NONE: no terminal human decision yet (field corrections don't count).
 * - VALIDATED: reviewer approved the row's content.
 * - REJECTED: reviewer rejected the row's content.
 * - DISCARDED: removed in favour of another copy (duplicate resolution).
 */
export const zClassificationDisposition = z.enum([
    'NONE',
    'VALIDATED',
    'REJECTED',
    'DISCARDED'
]);

/**
 * ClassificationStatus
 *
 * Lifecycle status of a document classification record.
 *
 * The classifier moves a row through queued → processing → classified |
 * needs_review | duplicate_detected | skipped | failed | expired | split; the
 * API review flows add rejected and discarded. A multi-payroll PDF ends in
 * split: its pages are re-issued as child documents and the parent carries
 * no fiscal data. Same values as the ``classification_status`` column type
 * in ``hulahoop_pro_db.models.enums``.
 */
export const zClassificationStatus = z.enum([
    'queued',
    'processing',
    'classified',
    'needs_review',
    'duplicate_detected',
    'skipped',
    'failed',
    'rejected',
    'discarded',
    'expired',
    'split'
]);

/**
 * CommentBodyRequest
 */
export const zCommentBodyRequest = z.object({
    body: z.string().min(1).max(4000)
});

/**
 * CommentPersonResponse
 */
export const zCommentPersonResponse = z.object({
    uuid: z.uuid(),
    name: z.string(),
    avatar: z.string().nullable()
});

/**
 * AuditResponse
 */
export const zAuditResponse = z.object({
    uuid: z.uuid(),
    state: zAuditState,
    opened_at: z.iso.datetime().nullable(),
    consolidated_at: z.iso.datetime().nullable(),
    reopened_at: z.iso.datetime().nullable(),
    auditor: zCommentPersonResponse.nullable(),
    signed_at: z.iso.datetime().nullable()
});

/**
 * CommentReactionRequest
 */
export const zCommentReactionRequest = z.object({
    emoji: z.string().min(1).max(16)
});

/**
 * CommentReactionResponse
 */
export const zCommentReactionResponse = z.object({
    emoji: z.string(),
    count: z.int(),
    me: z.boolean()
});

/**
 * CommentMessageResponse
 */
export const zCommentMessageResponse = z.object({
    uuid: z.uuid(),
    author: zCommentPersonResponse.nullable(),
    body: z.string(),
    created_at: z.iso.datetime(),
    edited_at: z.iso.datetime().nullable(),
    deleted_at: z.iso.datetime().nullable(),
    mentions: z.array(zCommentPersonResponse),
    reactions: z.array(zCommentReactionResponse)
});

/**
 * CommentSummaryResponse
 */
export const zCommentSummaryResponse = z.object({
    open_count: z.int(),
    unread_count: z.int()
});

/**
 * CompanyType
 */
export const zCompanyType = z.enum([
    'freelancer',
    'limited_company',
    'public_company',
    'association',
    'foundation',
    'cooperative',
    'other'
]);

/**
 * CompatibilityAction
 *
 * Document-generating acts a template can be checked against.
 */
export const zCompatibilityAction = z.enum([
    'financing',
    'reservation',
    'communication',
    'expense_audit'
]);

/**
 * ConciliationMetricsResponse
 */
export const zConciliationMetricsResponse = z.object({
    invoices_count: z.int(),
    invoices_total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    payment_proofs_count: z.int(),
    payment_proofs_total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
});

/**
 * ConsolidationBlockingResponse
 *
 * What holds consolidating back, one count per reason (A3).
 */
export const zConsolidationBlockingResponse = z.object({
    failed: z.int().default(0),
    requires_review: z.int().default(0),
    duplicates: z.int().default(0),
    total: z.int().default(0)
});

/**
 * ConsolidationBucketPreviewResponse
 *
 * One bucket row in the sync modal.
 *
 * Both amounts are GROSS EXPENSE — apples-to-apples with the quota's
 * cost_breakdown so estimated vs consolidated are directly comparable.
 * Deduction figures are surfaced at the aggregate level below.
 */
export const zConsolidationBucketPreviewResponse = z.object({
    bucket: z.string(),
    estimated_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    consolidated_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    classification_count: z.int(),
    classification_ids: z.array(z.int())
});

/**
 * ConsolidationCommitRequest
 *
 * POST /beneficiaries/{uuid}/fiscal-quotas/{fiscal_quota_uuid}/consolidate body.
 */
export const zConsolidationCommitRequest = z.object({
    breakdown_overrides: z.record(z.string(), z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ])).nullish(),
    comment: z.string().max(1000).nullish()
});

/**
 * ContractDisplayStatus
 *
 * Contract list status — a merge of the signature and review workflows.
 *
 * A contract row shows its signature status, except that a signed document
 * whose review was approved collapses to APPROVED. Rows without a signature
 * fall back to their review status. The union of both enums is therefore the
 * real domain of this field; SignatureStatus alone is not.
 */
export const zContractDisplayStatus = z.enum([
    'pending',
    'sent',
    'signed',
    'declined',
    'voided',
    'failed',
    'approved',
    'rejected'
]);

/**
 * ContractFields
 *
 * Extracted fields for contract documents (contrato).
 */
export const zContractFields = z.object({
    parties: z.array(z.string()),
    service_description: z.string().nullable(),
    total_fee: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    currency: z.string().nullable(),
    start_date: z.string().nullable(),
    end_date: z.string().nullable(),
    payment_terms: z.string().nullable()
});

/**
 * ContractPartySummary
 *
 * A party of a contract: the investor (with ``city``) or the promoter (with ``primary_contact``).
 */
export const zContractPartySummary = z.object({
    uuid: z.uuid(),
    name: z.string(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    city: z.string().nullable(),
    primary_contact: zBeneficiaryPrimaryContactResponse.nullable()
});

/**
 * ContractStatsResponse
 *
 * Contract statistics response.
 */
export const zContractStatsResponse = z.object({
    total_contracts: z.int(),
    by_status: z.record(z.string(), z.int()),
    by_type: z.record(z.string(), z.int())
});

/**
 * ContractType
 *
 * The three contract documents an investment can carry.
 *
 * The slug the API exposes for the ``doc_type`` of a contract document,
 * read from it through ``CONTRACT_TYPE_OF_DOCUMENT``.
 */
export const zContractType = z.enum([
    'reservation',
    'financing',
    'communication'
]);

/**
 * BoundContractResponse
 *
 * A contract sent or signed with the investment's current terms.
 */
export const zBoundContractResponse = z.object({
    document_uuid: z.uuid(),
    contract_type: zContractType,
    status: zBoundContractStatus
});

/**
 * ContractsMetricsResponse
 *
 * Response model for contracts metrics.
 */
export const zContractsMetricsResponse = z.object({
    total: z.int(),
    sent: z.int(),
    pending_signatures: z.int(),
    completed: z.int()
});

/**
 * CreateUploadSessionRequest
 *
 * Request to create a bulk upload session with signed URLs.
 */
export const zCreateUploadSessionRequest = z.object({
    filenames: z.array(z.string()).min(1).max(10000),
    fiscal_quota_uuid: z.uuid(),
    deferred: z.boolean().optional().default(false)
});

/**
 * DeductionByIncentiveResponse
 */
export const zDeductionByIncentiveResponse = z.object({
    performing_arts_music: z.string(),
    film_audiovisual: z.string()
});

/**
 * DescriptionBlockPreviewResponse
 */
export const zDescriptionBlockPreviewResponse = z.object({
    kind: z.literal('description'),
    title: z.string(),
    subtitle: z.string(),
    description: z.string(),
    rows: z.array(z.tuple([z.string(), z.string()]))
});

/**
 * Destinatario
 *
 * Recipient of the invoice line (who the cost is for). 9 closed values.
 *
 * Source-of-truth lives in
 * `services/classifier/app/domain/eligibility/destinatario.py`. This is a
 * mirror copy — the contract test pins they stay in sync.
 */
export const zDestinatario = z.enum([
    'artista_nombrado',
    'artistas_genericos',
    'crew',
    'agencia_management',
    'proveedor_externo',
    'estructura_admin',
    'local_explotacion',
    'invitado_promocional',
    'publico'
]);

/**
 * DocumentDownloadResponse
 *
 * Signed URL delivery — used by all download endpoints.
 */
export const zDocumentDownloadResponse = z.object({
    signed_url: z.string(),
    filename: z.string(),
    content_type: z.string(),
    size_bytes: z.int()
});

/**
 * DocumentStatus
 *
 * Document status — only tracks the file lifecycle.
 * Signature, review, and classification statuses live in their satellite domains.
 */
export const zDocumentStatus = z.enum(['active', 'archived']);

/**
 * DocumentUploader
 *
 * Who uploaded a document: only what any member of the organization may see.
 */
export const zDocumentUploader = z.object({
    uuid: z.uuid(),
    full_name: z.string()
});

/**
 * DownloadAeatDocumentsRequest
 *
 * Request model for downloading AEAT documents as ZIP
 */
export const zDownloadAeatDocumentsRequest = z.object({
    include_certificate: z.boolean().optional().default(false),
    certificate_type: z.enum(['inaem', 'icaa']).nullish(),
    include_communication_contract: z.boolean().optional().default(true),
    include_financing_contract: z.boolean().optional().default(true)
});

/**
 * DuplicateMatchData
 *
 * A single duplicate match reference.
 */
export const zDuplicateMatchData = z.object({
    classification_uuid: z.string(),
    match_type: z.string(),
    matched_fields: z.array(z.string()).optional()
});

/**
 * DuplicateDetectionData
 *
 * Duplicate detection results from the classifier pipeline.
 */
export const zDuplicateDetectionData = z.object({
    has_duplicates: z.boolean().optional().default(false),
    matches: z.array(zDuplicateMatchData).optional()
});

/**
 * DuplicateTemplateRequest
 *
 * Request schema for duplicating an existing template.
 */
export const zDuplicateTemplateRequest = z.object({
    name: z.string().nullish(),
    description: z.string().nullish()
});

/**
 * BulkDuplicateTemplatesRequest
 *
 * Duplicate each template; ``data`` is applied to every copy.
 */
export const zBulkDuplicateTemplatesRequest = z.object({
    template_uuids: z.array(z.uuid()).min(1).max(200),
    data: zDuplicateTemplateRequest.optional()
});

/**
 * Eligibility
 *
 * F3 deterministic resolver output — the 3-state headline decision.
 *
 * Values are UPPERCASE to match the `document_classifications.eligibility`
 * PG enum (`eligibility_3state` type). The classifier writes
 * `Eligibility.<name>` from `services/classifier/app/domain/eligibility/`
 * into this column; the API reads it back as-is.
 *
 * The API cannot import the classifier's enum directly (services/A cannot
 * import services/B per CLAUDE.md). The contract test in
 * `tests/integration/test_classifier_api_contract.py` pins that the two
 * sides stay in sync.
 */
export const zEligibility = z.enum([
    'DEDUCIBLE',
    'CONDICIONAL',
    'NO_DEDUCIBLE'
]);

/**
 * EligibilityDecisionResponse
 *
 * F3 deterministic resolver output, surfaced alongside the legacy
 * `qualification` block until F5 contract phase drops the JSONB mirror.
 *
 * All fields except `eligibility` are nullable — the resolver does not
 * always have enough context to populate every column (e.g. fallback
 * decisions skip the rule_id / rationale path).
 */
export const zEligibilityDecisionResponse = z.object({
    eligibility: zEligibility,
    operational_category: z.string().nullish(),
    destinatario: zDestinatario.nullish(),
    destinatario_state: z.enum([
        'confident',
        'uncertain',
        'unknown'
    ]).nullish(),
    destinatario_candidates: z.array(zDestinatario).optional(),
    destinatario_confidence: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullish(),
    fiscal_category: z.string().nullish(),
    fiscal_subcategory: z.string().nullish(),
    rule_id: z.string().nullish(),
    rationale: z.string().nullish(),
    review_question: z.string().nullish(),
    missing_evidences: z.array(z.string()).optional(),
    evidence_context: z.record(z.string(), z.unknown()).nullish(),
    deductible_base_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullish(),
    ruleset_version: z.string().nullish(),
    llm_explanation: z.string().nullish()
});

/**
 * EligibilityType
 *
 * How an expense qualifies for fiscal deduction.
 *
 * Legacy F0/F1/F2 enum kept until F5 contract phase drops the JSONB
 * qualification mirror. New code reads `Eligibility` (F3 3-state) instead.
 */
export const zEligibilityType = z.enum([
    'automatic',
    'conditional',
    'never'
]);

/**
 * EmailChangeAcceptedResponse
 *
 * The one answer the request gives, whether or not the address was free.
 *
 * Identical in both cases on purpose: telling them apart would turn this
 * endpoint into a way of finding out who has an account.
 */
export const zEmailChangeAcceptedResponse = z.object({
    detail: z.string().default('If the address can be used, a confirmation link has been sent to it.')
});

/**
 * EmailChangeRequestBody
 *
 * Ask for a new sign-in address. The current password is mandatory.
 */
export const zEmailChangeRequestBody = z.object({
    new_email: z.email(),
    current_password: z.string().min(1)
});

/**
 * EntityStatus
 */
export const zEntityStatus = z.enum([
    'active',
    'inactive',
    'archived'
]);

/**
 * EntityTagsUpdateRequest
 *
 * The record's tags, whole: what is not in the list stops being a tag of it.
 */
export const zEntityTagsUpdateRequest = z.object({
    tag_uuids: z.array(z.uuid()).max(50).optional()
});

/**
 * EntityType
 *
 * Entity types that can have documents - used for unified documents table
 */
export const zEntityType = z.enum([
    'investment',
    'investor',
    'project',
    'organization',
    'beneficiary',
    'beneficiary_bank_account',
    'beneficiary_legal_representative',
    'user',
    'classification',
    'fiscal_quota',
    'document',
    'template',
    'investment_proposal',
    'audit'
]);

/**
 * CommentThreadCreateRequest
 */
export const zCommentThreadCreateRequest = z.object({
    body: z.string().min(1).max(4000),
    subject_type: zEntityType,
    subject_uuid: z.uuid()
});

/**
 * EntityRefResponse
 */
export const zEntityRefResponse = z.object({
    entity_type: zEntityType,
    entity_uuid: z.uuid()
});

/**
 * ErrorResponse
 */
export const zErrorResponse = z.object({
    error: z.string(),
    message: z.string(),
    trace_id: z.string().nullish(),
    request_id: z.string().nullish(),
    details: z.record(z.string(), z.unknown()).nullish()
});

/**
 * ExportColumnResponse
 *
 * One selectable column surfaced to the export modal.
 */
export const zExportColumnResponse = z.object({
    key: z.string(),
    label: z.string(),
    default_selected: z.boolean()
});

/**
 * ExportFilterChipResponse
 *
 * One active filter rendered as a chip in the modal.
 */
export const zExportFilterChipResponse = z.object({
    key: z.string(),
    label: z.string(),
    value: z.string(),
    value_label: z.string()
});

/**
 * ExportFormat
 *
 * Supported export file formats.
 */
export const zExportFormat = z.enum([
    'csv',
    'xlsx',
    'json'
]);

/**
 * ExportPreviewResponse
 *
 * Snapshot returned to the export modal before the user confirms.
 */
export const zExportPreviewResponse = z.object({
    count: z.int().gte(0),
    columns: z.array(zExportColumnResponse),
    filters: z.array(zExportFilterChipResponse),
    available_formats: z.array(zExportFormat)
});

/**
 * ExtendReservationRequest
 *
 * Request model for extending investment reservation
 */
export const zExtendReservationRequest = z.object({
    new_expires_at: z.iso.datetime()
});

/**
 * ExtendReservationResponse
 *
 * Response model for extend reservation action
 */
export const zExtendReservationResponse = z.object({
    extension_granted: z.boolean(),
    new_expires_at: z.iso.datetime(),
    extended_at: z.iso.datetime()
});

/**
 * FieldLockInput
 *
 * One ground-truth lock the user asserts for a reprocess.
 */
export const zFieldLockInput = z.object({
    field_key: z.string().max(50),
    value: z.string().min(1).max(200)
});

/**
 * FieldLockResponse
 *
 * A sticky ground-truth lock currently set on a classification field.
 */
export const zFieldLockResponse = z.object({
    field_key: z.string(),
    value: z.string(),
    created_by_id: z.int().nullish(),
    created_at: z.iso.datetime().nullish()
});

/**
 * FieldResponse
 *
 * Response schema for a single scalar field.
 */
export const zFieldResponse = z.object({
    key: z.string(),
    description: z.string(),
    example: z.string(),
    data_type: z.enum([
        'string',
        'currency',
        'currency_with_words',
        'date',
        'number',
        'percentage'
    ]).default('string')
});

/**
 * FieldGroupResponse
 *
 * Response schema for a group of fields.
 */
export const zFieldGroupResponse = z.object({
    group: z.string(),
    items: z.array(zFieldResponse)
});

/**
 * FiltersAppliedResponse
 *
 * Response model for filters applied.
 */
export const zFiltersAppliedResponse = z.object({
    beneficiary_uuid: z.uuid().nullish(),
    beneficiary_name: z.string().nullish(),
    fiscal_year: z.int()
});

/**
 * DashboardMetadataResponse
 *
 * Response model for dashboard metadata.
 */
export const zDashboardMetadataResponse = z.object({
    filters_applied: zFiltersAppliedResponse,
    generated_at: z.iso.datetime()
});

/**
 * FinancialMetricsResponse
 */
export const zFinancialMetricsResponse = z.object({
    total_spend: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    deductible_spend: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    non_deductible_spend: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    conditional_spend: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    conditional_count: z.int(),
    estimated_savings: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
});

/**
 * FindingResolution
 *
 * What a person answers to one finding (A14).
 *
 * ``confirmed`` vouches for what the document says, so the reading it
 * questioned becomes ground truth. ``corrected`` closes it because the
 * condition no longer holds — the values were already changed, and pinned, by
 * the edit that changed them.
 */
export const zFindingResolution = z.enum(['confirmed', 'corrected']);

/**
 * FiscalQuotaAggregateValuesResponse
 *
 * The requested ``field:function`` pairs, and only those.
 *
 * Counts are integers; money is a decimal string with 2 decimals; the
 * utilization ratio has 4; a statistic over an empty set is null. A
 * distribution is a count per value.
 */
export const zFiscalQuotaAggregateValuesResponse = z.object({
    'money.deduction.estimated:sum': z.string().nullish(),
    'money.deduction.estimated:avg': z.string().nullish(),
    'money.deduction.estimated:min': z.string().nullish(),
    'money.deduction.estimated:max': z.string().nullish(),
    'money.deduction.reserved:sum': z.string().nullish(),
    'money.deduction.reserved:avg': z.string().nullish(),
    'money.deduction.reserved:min': z.string().nullish(),
    'money.deduction.reserved:max': z.string().nullish(),
    'money.deduction.completed:sum': z.string().nullish(),
    'money.deduction.completed:avg': z.string().nullish(),
    'money.deduction.completed:min': z.string().nullish(),
    'money.deduction.completed:max': z.string().nullish(),
    'money.deduction.used:sum': z.string().nullish(),
    'money.deduction.used:avg': z.string().nullish(),
    'money.deduction.used:min': z.string().nullish(),
    'money.deduction.used:max': z.string().nullish(),
    'money.deduction.available:sum': z.string().nullish(),
    'money.deduction.available:avg': z.string().nullish(),
    'money.deduction.available:min': z.string().nullish(),
    'money.deduction.available:max': z.string().nullish(),
    'money.investment.reserved:sum': z.string().nullish(),
    'money.investment.reserved:avg': z.string().nullish(),
    'money.investment.reserved:min': z.string().nullish(),
    'money.investment.reserved:max': z.string().nullish(),
    'money.investment.completed:sum': z.string().nullish(),
    'money.investment.completed:avg': z.string().nullish(),
    'money.investment.completed:min': z.string().nullish(),
    'money.investment.completed:max': z.string().nullish(),
    'money.investment.confirmed:sum': z.string().nullish(),
    'money.investment.confirmed:avg': z.string().nullish(),
    'money.investment.confirmed:min': z.string().nullish(),
    'money.investment.confirmed:max': z.string().nullish(),
    'money.investment.committed:sum': z.string().nullish(),
    'money.investment.committed:avg': z.string().nullish(),
    'money.investment.committed:min': z.string().nullish(),
    'money.investment.committed:max': z.string().nullish(),
    'money.estimate.capacity:sum': z.string().nullish(),
    'money.estimate.capacity:avg': z.string().nullish(),
    'money.estimate.capacity:min': z.string().nullish(),
    'money.estimate.capacity:max': z.string().nullish(),
    'money.estimate.available:sum': z.string().nullish(),
    'money.estimate.available:avg': z.string().nullish(),
    'money.estimate.available:min': z.string().nullish(),
    'money.estimate.available:max': z.string().nullish(),
    'money.deduction.utilization:ratio': z.string().nullish(),
    'investments_count:sum': z.int().nullish(),
    'state:distribution': z.record(z.string(), z.int()).nullish(),
    'beneficiary:unique': z.int().nullish(),
    'fiscal_year:distribution': z.record(z.string(), z.int()).nullish()
});

/**
 * FiscalQuotaAggregatesResponse
 *
 * Footer aggregates of the quotas list, computed over the whole filtered set.
 */
export const zFiscalQuotaAggregatesResponse = z.object({
    aggregates: zFiscalQuotaAggregateValuesResponse
});

/**
 * FiscalQuotaBeneficiarySummary
 *
 * The promoter a quota belongs to, as the row's identity cell shows it.
 */
export const zFiscalQuotaBeneficiarySummary = z.object({
    uuid: z.uuid(),
    name: z.string()
});

/**
 * FiscalQuotaCreateRequest
 *
 * Request model for creating a fiscal quota
 */
export const zFiscalQuotaCreateRequest = z.object({
    fiscal_year: z.int(),
    estimated_deduction: z.string(),
    default_profitability_percentage: z.string(),
    deduction_rate: z.string().nullish(),
    cost_breakdown: z.record(z.string(), z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ])).nullish(),
    total_budget: z.string().nullish(),
    total_eligible_cost: z.string().nullish(),
    deduction_base: z.string().nullish(),
    total_generated_deduction: z.string().nullish(),
    own_contribution: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    subsidies: z.array(z.record(z.string(), z.unknown())).nullish()
});

/**
 * FiscalQuotaDeductionMoneyResponse
 *
 * Deduction €, real: the quota's counters.
 */
export const zFiscalQuotaDeductionMoneyResponse = z.object({
    estimated: z.string(),
    reserved: z.string(),
    completed: z.string(),
    used: z.string(),
    available: z.string(),
    utilization: z.string()
});

/**
 * FiscalQuotaEstimateMoneyResponse
 *
 * Investment €, stored, at the quota's default return.
 */
export const zFiscalQuotaEstimateMoneyResponse = z.object({
    default_return_percentage: z.string(),
    capacity: z.string(),
    available: z.string()
});

/**
 * FiscalQuotaInvestmentMoneyResponse
 *
 * Investment €, real: Σ investments.amount by role.
 */
export const zFiscalQuotaInvestmentMoneyResponse = z.object({
    reserved: z.string(),
    completed: z.string(),
    confirmed: z.string(),
    committed: z.string()
});

/**
 * FiscalQuotaMoneyResponse
 */
export const zFiscalQuotaMoneyResponse = z.object({
    deduction: zFiscalQuotaDeductionMoneyResponse,
    investment: zFiscalQuotaInvestmentMoneyResponse,
    estimate: zFiscalQuotaEstimateMoneyResponse
});

/**
 * FiscalQuotaState
 *
 * The five phases of a fiscal quota.
 *
 * A person moves it; nothing is derived. The only automatic write is
 * consolidating, which leaves ``CONSOLIDATED``. Quotas are never archived,
 * so there is no ``ARCHIVED`` value and no archived filter.
 */
export const zFiscalQuotaState = z.enum([
    'estimated',
    'fundraising',
    'auditing',
    'consolidated',
    'closed'
]);

/**
 * FiscalQuotaUpdateRequest
 *
 * Request model for updating a fiscal quota
 */
export const zFiscalQuotaUpdateRequest = z.object({
    estimated_deduction: z.string().nullish(),
    default_profitability_percentage: z.string().nullish(),
    deduction_rate: z.string().nullish(),
    state: zFiscalQuotaState.nullish(),
    cost_breakdown: z.record(z.string(), z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ])).nullish(),
    total_budget: z.string().nullish(),
    total_eligible_cost: z.string().nullish(),
    deduction_base: z.string().nullish(),
    total_generated_deduction: z.string().nullish(),
    own_contribution: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    subsidies: z.array(z.record(z.string(), z.unknown())).nullish()
});

/**
 * FiscalYearAggregateResponse
 *
 * Aggregate metrics across all fiscal quotas for a given (beneficiary, year).
 */
export const zFiscalYearAggregateResponse = z.object({
    total_estimated_deduction: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    total_reserved: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    total_completed: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    total_used: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    total_available: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    utilization_percentage: z.number(),
    reserved_investment: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    completed_investment: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    total_used_investment: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    available_estimate_investment: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    capacity_estimate_investment: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_budget: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_eligible_cost: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_deduction_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_generated_deduction: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_own_contribution: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable()
});

/**
 * GenerateExpenseAuditRequest
 *
 * Body for ``POST /fiscal-quotas/{uuid}/actions/generate-expense-audit``.
 */
export const zGenerateExpenseAuditRequest = z.object({
    template_uuid: z.uuid()
});

/**
 * HubBankInfoResponse
 *
 * Bank info for payment.
 */
export const zHubBankInfoResponse = z.object({
    iban: z.string(),
    bank_name: z.string().nullable(),
    has_certificate: z.boolean().default(false),
    certificate_url: z.string().nullable()
});

/**
 * HubExpiringReservationResponse
 *
 * Reservation expiring soon.
 */
export const zHubExpiringReservationResponse = z.object({
    investment_uuid: z.uuid(),
    beneficiary_name: z.string(),
    amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    expires_at: z.iso.datetime(),
    days_remaining: z.int()
});

/**
 * HubPendingContractResponse
 *
 * Contract pending investor signature.
 */
export const zHubPendingContractResponse = z.object({
    investment_uuid: z.uuid(),
    beneficiary_name: z.string(),
    amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    contract_type: z.enum([
        'reservation',
        'financing',
        'communication'
    ]),
    document_uuid: z.uuid(),
    sent_at: z.iso.datetime().nullable()
});

/**
 * HubPendingPaymentResponse
 *
 * Investment pending payment upload.
 */
export const zHubPendingPaymentResponse = z.object({
    investment_uuid: z.uuid(),
    beneficiary_name: z.string(),
    amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    bank_info: zHubBankInfoResponse
});

/**
 * HubPendingActionsResponse
 *
 * All pending actions for an investor.
 */
export const zHubPendingActionsResponse = z.object({
    contracts_to_sign: z.array(zHubPendingContractResponse).default([]),
    pending_payments: z.array(zHubPendingPaymentResponse).default([]),
    expiring_reservations: z.array(zHubExpiringReservationResponse).default([]),
    total_count: z.int().default(0),
    has_actions: z.boolean().default(false)
});

/**
 * HubSigningUrlRequest
 *
 * Request for embedded signing URL.
 */
export const zHubSigningUrlRequest = z.object({
    return_url: z.string()
});

/**
 * HubSigningUrlResponse
 *
 * Response with signing URL (redirect-based or embeddable).
 */
export const zHubSigningUrlResponse = z.object({
    signing_url: z.string().nullable(),
    embed_src: z.string().nullable(),
    expires_in_seconds: z.int().default(300)
});

/**
 * HubStatus
 *
 * Hub access status for an investor.
 * - none: No invitation sent, no hub access
 * - pending: Invitation sent, waiting for investor to accept
 * - active: Investor has accepted invitation and has hub access
 */
export const zHubStatus = z.enum([
    'none',
    'pending',
    'active'
]);

/**
 * ImageBlockPreviewResponse
 */
export const zImageBlockPreviewResponse = z.object({
    kind: z.literal('image')
});

/**
 * InvestmentAggregateValuesResponse
 *
 * The footer aggregates of the investments list, one key per ``field:function`` asked for.
 *
 * Only the requested keys are present. Averages and percentages are rounded to
 * 2 decimals; a statistic over an empty set is null. Text ``empty`` counts null
 * or blank values and ``unique`` ignores them.
 */
export const zInvestmentAggregateValuesResponse = z.object({
    'amount:sum': z.string().nullish(),
    'amount:avg': z.string().nullish(),
    'amount:min': z.string().nullish(),
    'amount:max': z.string().nullish(),
    'return_percentage:avg': z.string().nullish(),
    'return_percentage:min': z.string().nullish(),
    'return_percentage:max': z.string().nullish(),
    'state:prospect': z.int().nullish(),
    'state:reserved': z.int().nullish(),
    'state:financing': z.int().nullish(),
    'state:funded': z.int().nullish(),
    'state:declared': z.int().nullish(),
    'state:cancelled': z.int().nullish(),
    'state:expired': z.int().nullish(),
    'state:rejected': z.int().nullish(),
    'state:pct_funded': z.string().nullish(),
    'beneficiary:filled': z.int().nullish(),
    'beneficiary:empty': z.int().nullish(),
    'beneficiary:unique': z.int().nullish(),
    'investor:filled': z.int().nullish(),
    'investor:empty': z.int().nullish(),
    'investor:unique': z.int().nullish(),
    'fiscal_quota:filled': z.int().nullish(),
    'fiscal_quota:empty': z.int().nullish(),
    'fiscal_quota:unique': z.int().nullish()
});

/**
 * InvestmentAggregatesResponse
 *
 * Footer aggregates of the investments list, computed over the whole filtered set.
 */
export const zInvestmentAggregatesResponse = z.object({
    aggregates: zInvestmentAggregateValuesResponse
});

/**
 * InvestmentBindingResponse
 *
 * What stands in the way of changing amount, return or quota, from the investment's documents.
 *
 * A registered payment and a contract uploaded already signed refuse the change; the other contracts
 * refuse it unless the change voids them.
 */
export const zInvestmentBindingResponse = z.object({
    payment_registered: z.boolean(),
    contracts: z.array(zBoundContractResponse)
});

/**
 * InvestmentCapacityMetricsResponse
 *
 * Response model for investment capacity metrics from beneficiary perspective.
 */
export const zInvestmentCapacityMetricsResponse = z.object({
    estimated_total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).nullish(),
    reserved: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    completed: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    estimated_available: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).nullish()
});

/**
 * InvestmentEventType
 *
 * Investment event types - actions/events that occur during lifecycle
 */
export const zInvestmentEventType = z.enum([
    'created',
    'proposal_sent',
    'reservation_contract_sent',
    'financing_contract_sent',
    'communication_contract_sent',
    'contract_signed',
    'invoice_sent',
    'reservation_created',
    'reservation_extended',
    'reservation_expiry_set',
    'reservation_released',
    'reservation_expired',
    'quota_reserved',
    'quota_released',
    'quota_expired',
    'payment_received',
    'payment_confirmed',
    'payment_reversed',
    'tax_submitted',
    'tax_accepted',
    'tax_rejected',
    'document_uploaded',
    'document_downloaded',
    'document_approved',
    'document_rejected',
    'contract_voided',
    'contract_declined',
    'contract_delivery_failed',
    'state_changed',
    'amount_updated',
    'notes_updated',
    'beneficiary_changed',
    'return_percentage_updated',
    'cancelled',
    'rejected'
]);

/**
 * InvestmentMetricsResponse
 *
 * Response model for investment metrics
 */
export const zInvestmentMetricsResponse = z.object({
    reserved: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    completed: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    total_used: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    available_estimate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).nullable(),
    capacity_estimate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).nullable()
});

/**
 * InvestmentProposalCreateRequest
 *
 * Request model for creating a new investment proposal
 */
export const zInvestmentProposalCreateRequest = z.object({
    investor_uuid: z.uuid(),
    fiscal_year: z.int(),
    taxable_base: z.string(),
    tax_rate: z.union([
        z.number().gt(0).lte(100),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]),
    expires_at: z.iso.datetime().nullish()
});

/**
 * InvestmentProposalDisplayStatus
 *
 * What the API serves: the stored answer, with ``sent`` and ``expired`` in place of ``pending``.
 */
export const zInvestmentProposalDisplayStatus = z.enum([
    'sent',
    'expired',
    'accepted',
    'rejected'
]);

/**
 * InvestmentProposalStatus
 *
 * What a proposal stores: the investor's answer, or its absence.
 *
 * Expiry is **not** one of these — it is derived from ``expires_at``
 * (``domain/investments/proposals.py``) and served as
 * :class:`InvestmentProposalDisplayStatus`.
 */
export const zInvestmentProposalStatus = z.enum([
    'pending',
    'accepted',
    'rejected'
]);

/**
 * InvestmentState
 *
 * Investment state enum - represents current state of investment
 */
export const zInvestmentState = z.enum([
    'prospect',
    'reserved',
    'financing',
    'funded',
    'declared',
    'cancelled',
    'expired',
    'rejected'
]);

/**
 * HubInvestmentDetailResponse
 *
 * Detailed Hub investment view.
 */
export const zHubInvestmentDetailResponse = z.object({
    uuid: z.uuid(),
    amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    return_percentage: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    currency: z.string().default('EUR'),
    state: zInvestmentState,
    beneficiary_name: z.string(),
    project_name: z.string().nullable(),
    created_at: z.iso.datetime().nullable(),
    updated_at: z.iso.datetime().nullable()
});

/**
 * HubInvestmentResponse
 *
 * Investment for Hub - excludes notes, audit fields, internal IDs.
 */
export const zHubInvestmentResponse = z.object({
    uuid: z.uuid(),
    amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    return_percentage: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    currency: z.string().default('EUR'),
    state: zInvestmentState,
    beneficiary_name: z.string(),
    project_name: z.string().nullable()
});

/**
 * HubDashboardSummary
 *
 * Dashboard summary for Hub - investment statistics + recent activity.
 */
export const zHubDashboardSummary = z.object({
    total_investments: z.int().default(0),
    total_invested_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).default('0.00'),
    pending_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).default('0.00'),
    confirmed_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).default('0.00'),
    recent_investments: z.array(zHubInvestmentResponse).default([])
});

/**
 * InvestmentCreateRequest
 *
 * Request model for creating a new investment
 */
export const zInvestmentCreateRequest = z.object({
    fiscal_quota_uuid: z.uuid(),
    amount: z.string(),
    return_percentage: z.string(),
    state: zInvestmentState.optional().default('prospect'),
    investor_uuid: z.uuid()
});

/**
 * InvestmentTermsRequest
 *
 * What an investment is made of, whoever its investor is
 */
export const zInvestmentTermsRequest = z.object({
    fiscal_quota_uuid: z.uuid(),
    amount: z.string(),
    return_percentage: z.string(),
    state: zInvestmentState.optional().default('prospect')
});

/**
 * InvestmentUpdateRequest
 *
 * Request model for updating investment via PATCH
 */
export const zInvestmentUpdateRequest = z.object({
    amount: z.string().nullish(),
    return_percentage: z.string().nullish(),
    fiscal_quota_uuid: z.uuid().nullish(),
    state: zInvestmentState.nullish(),
    rejection_reason: z.string().max(1000).nullish(),
    void_contracts: z.boolean().optional().default(false)
});

/**
 * BulkUpdateInvestmentsRequest
 *
 * The same PATCH applied to each investment, e.g. ``{state: rejected, rejection_reason}``.
 */
export const zBulkUpdateInvestmentsRequest = z.object({
    investment_uuids: z.array(z.uuid()).min(1).max(200),
    data: zInvestmentUpdateRequest
});

/**
 * InvestmentWarningResponse
 *
 * An advisory warning of the write: it never refuses it.
 */
export const zInvestmentWarningResponse = z.object({
    code: z.string(),
    context: z.record(z.string(), z.union([
        z.string(),
        z.int()
    ]))
});

/**
 * InvestmentsSummaryResponse
 *
 * Response model for investments summary.
 */
export const zInvestmentsSummaryResponse = z.object({
    total_count: z.int(),
    total_volume: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/)
});

/**
 * InvestorDeductionMoneyResponse
 *
 * Deduction €, real: Σ stored investments.deduction of the committed investments of the fiscal year.
 */
export const zInvestorDeductionMoneyResponse = z.object({
    committed: z.string(),
    by_incentive: zDeductionByIncentiveResponse
});

/**
 * InvestorHubRegistrationData
 *
 * Simplified registration for investor hub invitations.
 * Only password required - all other user data (name, language) is pulled
 * from the Investor record automatically.
 */
export const zInvestorHubRegistrationData = z.object({
    type: z.literal('investor_hub_registration'),
    password: z.string().min(8)
});

/**
 * InvestorInvestmentMoneyResponse
 *
 * Investment €, real: Σ investments.amount of the fiscal year by role.
 */
export const zInvestorInvestmentMoneyResponse = z.object({
    reserved: z.string(),
    completed: z.string(),
    confirmed: z.string(),
    committed: z.string()
});

/**
 * InvestorLegalRepresentativeCreateRequest
 *
 * Request model for creating an investor legal representative
 */
export const zInvestorLegalRepresentativeCreateRequest = z.object({
    first_name: z.string().max(120),
    last_name: z.string().max(160),
    dni: z.string().max(20),
    position: z.string().max(160).nullish(),
    phone: z.string().max(50).nullish(),
    email: z.email().nullish(),
    is_primary: z.boolean().optional().default(true),
    is_signer: z.boolean().optional().default(true)
});

/**
 * InvestorLegalRepresentativeResponse
 *
 * Response model for investor legal representative data
 */
export const zInvestorLegalRepresentativeResponse = z.object({
    uuid: z.uuid(),
    first_name: z.string(),
    last_name: z.string(),
    full_name: z.string(),
    dni: z.string(),
    position: z.string().nullable(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    is_primary: z.boolean(),
    is_signer: z.boolean(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * InvestorLegalRepresentativeUpdateRequest
 *
 * Request model for updating an investor legal representative
 */
export const zInvestorLegalRepresentativeUpdateRequest = z.object({
    first_name: z.string().max(120).nullish(),
    last_name: z.string().max(160).nullish(),
    dni: z.string().max(20).nullish(),
    position: z.string().max(160).nullish(),
    phone: z.string().max(50).nullish(),
    email: z.email().nullish(),
    is_primary: z.boolean().nullish(),
    is_signer: z.boolean().nullish()
});

/**
 * InvestorMoneyResponse
 *
 * The investor's money of one fiscal year.
 */
export const zInvestorMoneyResponse = z.object({
    potential: z.string().nullable(),
    investment: zInvestorInvestmentMoneyResponse,
    available: z.string().nullable(),
    deduction: zInvestorDeductionMoneyResponse
});

/**
 * InvestorMusicDeductionSummaryResponse
 *
 * Response for /investors/{uuid}/music-deduction-summary.
 *
 * Amount invested and deduction already transferred to the investor across
 * music quotas of the fiscal year. Art. 36.3 LIS caps the music deduction at
 * 500.000 € per contribuyente and período impositivo — the platform only sees
 * its own investments, so the FE renders this as an advisory warning, never
 * a block.
 */
export const zInvestorMusicDeductionSummaryResponse = z.object({
    fiscal_year: z.int(),
    invested_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    transferred_deduction: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    legal_cap: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/)
});

/**
 * InvestorType
 *
 * Investor type enum for domain layer
 */
export const zInvestorType = z.enum(['individual', 'company']);

/**
 * HubInvestorProfileSummary
 *
 * Lightweight investor profile for profile switcher.
 * Contains only essential fields needed to identify and select a profile.
 */
export const zHubInvestorProfileSummary = z.object({
    uuid: z.uuid(),
    type: zInvestorType,
    display_name: z.string(),
    email: z.string().nullish()
});

/**
 * HubProfilesResponse
 *
 * Response containing all investor profiles available to the user.
 * Used by the Hub profile switcher.
 */
export const zHubProfilesResponse = z.object({
    profiles: z.array(zHubInvestorProfileSummary),
    count: z.int()
});

/**
 * InvestorAggregateValuesResponse
 *
 * Requested footer aggregates keyed ``field:function``; only the requested keys are present.
 *
 * The ``money.*`` paths are the investor Row's, in euros of the requested fiscal
 * year (``money.potential`` has no year), with 2 decimals rounded half up;
 * ``money.available`` is ``max(potential - committed, 0)`` per investor and ignores
 * investors without potential. Other averages and percentages are rounded to 2
 * decimals; a statistic over an empty set is null. Text ``empty`` counts null or
 * blank values and ``unique`` ignores them.
 */
export const zInvestorAggregateValuesResponse = z.object({
    'number_investments:sum': z.int().nullish(),
    'number_investments:avg': z.string().nullish(),
    'number_investments:min': z.int().nullish(),
    'number_investments:max': z.int().nullish(),
    'money.potential:sum': z.string().nullish(),
    'money.potential:avg': z.string().nullish(),
    'money.potential:min': z.string().nullish(),
    'money.potential:max': z.string().nullish(),
    'money.investment.reserved:sum': z.string().nullish(),
    'money.investment.reserved:avg': z.string().nullish(),
    'money.investment.reserved:min': z.string().nullish(),
    'money.investment.reserved:max': z.string().nullish(),
    'money.investment.completed:sum': z.string().nullish(),
    'money.investment.completed:avg': z.string().nullish(),
    'money.investment.completed:min': z.string().nullish(),
    'money.investment.completed:max': z.string().nullish(),
    'money.investment.confirmed:sum': z.string().nullish(),
    'money.investment.confirmed:avg': z.string().nullish(),
    'money.investment.confirmed:min': z.string().nullish(),
    'money.investment.confirmed:max': z.string().nullish(),
    'money.investment.committed:sum': z.string().nullish(),
    'money.investment.committed:avg': z.string().nullish(),
    'money.investment.committed:min': z.string().nullish(),
    'money.investment.committed:max': z.string().nullish(),
    'money.available:sum': z.string().nullish(),
    'money.available:avg': z.string().nullish(),
    'money.available:min': z.string().nullish(),
    'money.available:max': z.string().nullish(),
    'email:filled': z.int().nullish(),
    'email:empty': z.int().nullish(),
    'email:unique': z.int().nullish(),
    'city:filled': z.int().nullish(),
    'city:empty': z.int().nullish(),
    'city:unique': z.int().nullish(),
    'type:distribution': z.record(z.string(), z.int()).nullish(),
    'tag:distribution': z.record(z.string(), z.int()).nullish(),
    'status:active': z.int().nullish(),
    'status:inactive': z.int().nullish(),
    'status:archived': z.int().nullish(),
    'status:pct_active': z.string().nullish()
});

/**
 * InvestorAggregatesResponse
 *
 * Footer aggregates of the investors list, computed over the whole filtered set.
 */
export const zInvestorAggregatesResponse = z.object({
    aggregates: zInvestorAggregateValuesResponse
});

/**
 * InvestorOperationResponse
 *
 * Response for operations that work on both individual and company investors
 */
export const zInvestorOperationResponse = z.object({
    uuid: z.uuid(),
    type: zInvestorType,
    status: zEntityStatus,
    display_name: z.string()
});

/**
 * InvestorProjectSummary
 *
 * Investor summary data specifically for project detail responses.
 * Contains only essential investor info and investment details for the project.
 */
export const zInvestorProjectSummary = z.object({
    uuid: z.uuid(),
    display_name: z.string(),
    type: zInvestorType,
    investment_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    invested_at: z.iso.datetime(),
    status: zInvestmentState
});

/**
 * InvestorSummary
 *
 * Summary investor data for nested responses
 */
export const zInvestorSummary = z.object({
    uuid: z.uuid(),
    type: zInvestorType,
    status: zEntityStatus,
    display_name: z.string(),
    email: z.string().nullable(),
    tax_identifier: z.string().nullable(),
    city: z.string().nullable(),
    phone: z.string().nullable()
});

/**
 * InvestorTypeBreakdownResponse
 *
 * Breakdown of investors by type
 */
export const zInvestorTypeBreakdownResponse = z.object({
    individual: z.int(),
    company: z.int()
});

/**
 * InvestorMetricsResponse
 *
 * Response for /investors/metrics endpoint
 */
export const zInvestorMetricsResponse = z.object({
    total_count: z.int(),
    by_type: zInvestorTypeBreakdownResponse,
    potential_capacity: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    committed: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    available: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    reserved: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    completed: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/)
});

/**
 * InvestorTypeMetricsResponse
 *
 * Response model for investor type metrics.
 */
export const zInvestorTypeMetricsResponse = z.object({
    count: z.int(),
    avg_investment: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/)
});

/**
 * InvestorsByTypeResponse
 *
 * Response model for investor breakdown by type.
 */
export const zInvestorsByTypeResponse = z.object({
    individual: zInvestorTypeMetricsResponse,
    company: zInvestorTypeMetricsResponse
});

/**
 * InvestorBreakdownResponse
 *
 * Response model for investor breakdown.
 */
export const zInvestorBreakdownResponse = z.object({
    total_count: z.int(),
    by_type: zInvestorsByTypeResponse
});

/**
 * InvestorCapacityMetricsResponse
 *
 * Response model for investor capacity metrics.
 * Business concept: "Capacidad de Inversión" (Demand Side)
 */
export const zInvestorCapacityMetricsResponse = z.object({
    potential_total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    committed: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    available: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    investors: zInvestorBreakdownResponse
});

/**
 * InvitationMessageRequest
 *
 * Optional personal message for an invitation email (invite to the Hub, resend).
 *
 * Plain text, shown before the link and escaped in the template. It travels
 * only in the email: it is never stored on the invitation.
 */
export const zInvitationMessageRequest = z.object({
    message: z.string().max(1000).nullish()
});

/**
 * InvitationStatus
 *
 * Invitation status enum
 */
export const zInvitationStatus = z.enum([
    'pending',
    'accepted',
    'rejected',
    'expired',
    'revoked'
]);

/**
 * InvitationType
 *
 * Invitation type enum
 */
export const zInvitationType = z.enum([
    'create_org',
    'join_as_new_user',
    'join_as_existing_user'
]);

/**
 * InvoiceLineItem
 */
export const zInvoiceLineItem = z.object({
    description: z.string().nullish(),
    quantity: z.number().nullish(),
    unit_price: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullish(),
    total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullish()
});

/**
 * IvaBreakdownEntry
 *
 * One IVA rate block of a multi-rate invoice (Base/Tipo/Cuota line).
 */
export const zIvaBreakdownEntry = z.object({
    rate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable()
});

/**
 * InvoiceFields
 *
 * Extracted fields for invoices (factura, proforma, presupuesto, albaran).
 */
export const zInvoiceFields = z.object({
    invoice_number: z.string().nullable(),
    invoice_date: z.string().nullable(),
    due_date: z.string().nullable(),
    supplier_name: z.string().nullable(),
    supplier_tax_id: z.string().nullable(),
    supplier_address: z.string().nullable(),
    receiver_name: z.string().nullable(),
    receiver_tax_id: z.string().nullable(),
    receiver_address: z.string().nullable(),
    subtotal: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    currency: z.string().nullable().default('EUR'),
    iva_rate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    iva_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    iva_breakdown: z.array(zIvaBreakdownEntry),
    irpf_rate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    irpf_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    concept_summary: z.string().nullable(),
    line_items: z.array(zInvoiceLineItem),
    beneficiary_name: z.string().nullable()
});

/**
 * IvaRateBreakdownResponse
 */
export const zIvaRateBreakdownResponse = z.object({
    rate: z.string(),
    taxable_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    invoice_count: z.int()
});

/**
 * LinkedInvestmentResponse
 *
 * The investment created from an accepted proposal, enough to open it.
 */
export const zLinkedInvestmentResponse = z.object({
    uuid: z.uuid(),
    reference: z.string(),
    state: zInvestmentState,
    amount: z.string()
});

/**
 * ListBlockPreviewResponse
 */
export const zListBlockPreviewResponse = z.object({
    kind: z.literal('list'),
    sample_items: z.array(z.string())
});

/**
 * ListResponse[BeneficiaryBankAccountResponse]
 */
export const zListResponseBeneficiaryBankAccountResponse = z.object({
    items: z.array(zBeneficiaryBankAccountResponse),
    total_count: z.int()
});

/**
 * ListResponse[BeneficiaryLegalRepresentativeResponse]
 */
export const zListResponseBeneficiaryLegalRepresentativeResponse = z.object({
    items: z.array(zBeneficiaryLegalRepresentativeResponse),
    total_count: z.int()
});

/**
 * ListResponse[CommentPersonResponse]
 */
export const zListResponseCommentPersonResponse = z.object({
    items: z.array(zCommentPersonResponse),
    total_count: z.int()
});

/**
 * ListResponse[InvestorLegalRepresentativeResponse]
 */
export const zListResponseInvestorLegalRepresentativeResponse = z.object({
    items: z.array(zInvestorLegalRepresentativeResponse),
    total_count: z.int()
});

/**
 * LockableFieldResponse
 *
 * A field the reprocess modal may offer to lock, with its current value.
 */
export const zLockableFieldResponse = z.object({
    field_key: z.string(),
    label: z.string(),
    value_type: z.enum([
        'document_type',
        'amount',
        'date',
        'text'
    ]),
    current_value: z.string().nullable()
});

/**
 * ClassificationLocksResponse
 *
 * Everything the reprocess modal needs: the active locks plus the
 * lockable-field catalogue for this document's type.
 */
export const zClassificationLocksResponse = z.object({
    locks: z.array(zFieldLockResponse),
    lockable_fields: z.array(zLockableFieldResponse)
});

/**
 * MediaItemResponse
 *
 * One image of a gallery.
 *
 * The signed URL travels here, in the list: a gallery cannot ask for a
 * download per image.
 */
export const zMediaItemResponse = z.object({
    document_uuid: z.uuid(),
    url: z.string().nullable(),
    name: z.string(),
    title: z.string().nullable(),
    content_type: z.string(),
    size_bytes: z.int(),
    uploaded_by: z.int().nullable(),
    created_at: z.iso.datetime().nullable(),
    is_cover: z.boolean()
});

/**
 * MediaListResponse
 *
 * A whole gallery, in upload order.
 */
export const zMediaListResponse = z.object({
    items: z.array(zMediaItemResponse)
});

/**
 * MembershipJoinData
 *
 * Completion data for JOIN_AS_EXISTING_USER invitations - creates membership only.
 * For role=INVESTOR, the investor link is created automatically using the
 * investor_uuid embedded in the signed invitation token.
 */
export const zMembershipJoinData = z.object({
    type: z.literal('membership_join')
});

/**
 * MessageResponse
 *
 * Simple message response for admin actions.
 */
export const zMessageResponse = z.object({
    message: z.string()
});

/**
 * ModuleCode
 *
 * Available vendible modules.
 */
export const zModuleCode = z.enum([
    'ai_agent',
    'invoice_classification',
    'signing'
]);

/**
 * ModuleEntitlementResponse
 *
 * Response DTO for a module entitlement.
 */
export const zModuleEntitlementResponse = z.object({
    module_code: z.string(),
    is_active: z.boolean(),
    config: z.record(z.string(), z.unknown()),
    activated_at: z.iso.datetime().nullable(),
    expires_at: z.iso.datetime().nullable()
});

/**
 * ListResponse[ModuleEntitlementResponse]
 */
export const zListResponseModuleEntitlementResponse = z.object({
    items: z.array(zModuleEntitlementResponse),
    total_count: z.int()
});

/**
 * MonthlyBreakdownResponse
 */
export const zMonthlyBreakdownResponse = z.object({
    month: z.int(),
    deductible: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    non_deductible: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
});

/**
 * MostCommonResponse
 *
 * The value a column repeats the most over the filtered set, and how many rows carry it.
 */
export const zMostCommonResponse = z.object({
    value: z.string(),
    count: z.int()
});

/**
 * ContractAggregateValuesResponse
 *
 * The requested ``field:function`` pairs, and only those.
 *
 * Counts are integers; money and percentages are decimal strings rounded to
 * 2 decimals; a statistic over an empty set is null. ``contract_type:distribution``
 * is a count per contract type, and a ``most_common`` is one value with its
 * count.
 */
export const zContractAggregateValuesResponse = z.object({
    'investment_amount:sum': z.string().nullish(),
    'investment_amount:avg': z.string().nullish(),
    'investment_amount:min': z.string().nullish(),
    'investment_amount:max': z.string().nullish(),
    'status:pending': z.int().nullish(),
    'status:sent': z.int().nullish(),
    'status:signed': z.int().nullish(),
    'status:declined': z.int().nullish(),
    'status:voided': z.int().nullish(),
    'status:failed': z.int().nullish(),
    'status:approved': z.int().nullish(),
    'status:rejected': z.int().nullish(),
    'status:completed': z.int().nullish(),
    'status:pct_completed': z.string().nullish(),
    'signatures:pending': z.int().nullish(),
    'signatures:complete': z.int().nullish(),
    'contract_type:distribution': z.record(z.string(), z.int()).nullish(),
    'investor:unique': z.int().nullish(),
    'investor:most_common': zMostCommonResponse.nullish(),
    'beneficiary:unique': z.int().nullish(),
    'beneficiary:most_common': zMostCommonResponse.nullish()
});

/**
 * ContractAggregatesResponse
 *
 * Footer aggregates of the contracts list, computed over the whole filtered set.
 */
export const zContractAggregatesResponse = z.object({
    aggregates: zContractAggregateValuesResponse
});

/**
 * NoteAggregatesResponse
 */
export const zNoteAggregatesResponse = z.object({
    total: z.int()
});

/**
 * NoteConflictResponse
 */
export const zNoteConflictResponse = z.object({
    current_revision: z.int()
});

/**
 * NoteCreateRequest
 */
export const zNoteCreateRequest = z.object({
    holder: zEntityRefResponse
});

/**
 * NoteSaveRequest
 */
export const zNoteSaveRequest = z.object({
    revision: z.int().gte(1),
    title: z.string().max(255).nullish(),
    body: z.record(z.string(), z.unknown()).nullish()
});

/**
 * NoteSavedResponse
 */
export const zNoteSavedResponse = z.object({
    revision: z.int(),
    updated_at: z.iso.datetime(),
    excerpt: z.string(),
    last_edited_by: zCommentPersonResponse.nullable()
});

/**
 * NotificationStatsResponse
 *
 * Schema for notification statistics
 */
export const zNotificationStatsResponse = z.object({
    total_count: z.int(),
    unread_count: z.int(),
    read_count: z.int()
});

/**
 * NotificationType
 */
export const zNotificationType = z.enum([
    'note_mentioned',
    'comment_mentioned',
    'comment_replied',
    'comment_resolved',
    'system',
    'document',
    'investment',
    'project'
]);

/**
 * OrganizationActivityEvent
 */
export const zOrganizationActivityEvent = z.enum([
    'note_created',
    'note_deleted',
    'beneficiary_created',
    'beneficiary_updated',
    'beneficiary_status_changed',
    'beneficiary_representative_added',
    'beneficiary_representative_removed',
    'beneficiary_bank_account_added',
    'beneficiary_bank_account_removed',
    'beneficiary_document_uploaded',
    'beneficiary_document_deleted',
    'beneficiary_document_renamed',
    'beneficiary_document_moved',
    'beneficiary_hub_invited',
    'beneficiary_deleted',
    'investor_created',
    'investor_updated',
    'investor_status_changed',
    'investor_hub_invited',
    'investor_hub_activated',
    'investor_document_uploaded',
    'investor_document_deleted',
    'investor_tags_changed',
    'investor_deleted',
    'fiscal_quota_created',
    'fiscal_quota_updated',
    'fiscal_quota_state_changed',
    'fiscal_quota_consolidated',
    'fiscal_quota_reopened',
    'fiscal_quota_deleted',
    'project_created',
    'project_updated',
    'project_state_changed',
    'project_poster_added',
    'project_poster_removed',
    'project_deleted',
    'audit_batch_uploaded',
    'audit_batch_completed',
    'audit_document_reviewed',
    'audit_document_reprocessed',
    'audit_duplicate_resolved',
    'audit_finding_resolved',
    'audit_document_deleted',
    'audit_report_generated',
    'audit_report_deleted',
    'proposal_resent',
    'proposal_accepted',
    'proposal_rejected',
    'proposal_deleted',
    'template_created',
    'template_updated',
    'template_status_changed',
    'template_duplicated',
    'template_deleted',
    'member_role_changed',
    'member_deactivated',
    'member_reactivated',
    'member_removed',
    'member_invited',
    'invitation_resent',
    'invitation_revoked',
    'invitation_accepted',
    'organization_updated',
    'tag_created',
    'tag_renamed',
    'tag_deleted'
]);

/**
 * OrganizationCreateRequest
 *
 * Request schema for creating an organization
 */
export const zOrganizationCreateRequest = z.object({
    name: z.string().min(1).max(100),
    slug: z.string().min(1).max(100),
    email: z.email().nullish(),
    phone: z.string().max(20).nullish(),
    website: z.string().max(200).nullish(),
    address: z.string().max(200).nullish(),
    city: z.string().max(50).nullish(),
    state: z.string().max(50).nullish(),
    postal_code: z.string().max(20).nullish(),
    country: z.string().max(2).nullish(),
    fiscal_id: z.string().max(50).nullish(),
    tax_advisor_id: z.string().max(50).nullish(),
    legal_rep_first_name: z.string().max(120).nullish(),
    legal_rep_last_name: z.string().max(160).nullish(),
    legal_rep_national_id: z.string().max(32).nullish(),
    legal_rep_email: z.email().nullish(),
    logo: z.string().nullish()
});

/**
 * OrganizationResponse
 *
 * Response schema for organization data
 */
export const zOrganizationResponse = z.object({
    name: z.string().min(1).max(100),
    slug: z.string().min(1).max(100),
    email: z.email().nullish(),
    phone: z.string().max(20).nullish(),
    website: z.string().max(200).nullish(),
    address: z.string().max(200).nullish(),
    city: z.string().max(50).nullish(),
    state: z.string().max(50).nullish(),
    postal_code: z.string().max(20).nullish(),
    country: z.string().max(2).nullish(),
    fiscal_id: z.string().max(50).nullish(),
    tax_advisor_id: z.string().max(50).nullish(),
    legal_rep_first_name: z.string().max(120).nullish(),
    legal_rep_last_name: z.string().max(160).nullish(),
    legal_rep_national_id: z.string().max(32).nullish(),
    legal_rep_email: z.email().nullish(),
    uuid: z.uuid(),
    logo_signed_url: z.string().nullish(),
    is_active: z.boolean(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime().nullish()
});

/**
 * OrganizationRole
 *
 * Organization roles enum
 */
export const zOrganizationRole = z.enum([
    'owner',
    'employee',
    'beneficiary',
    'investor'
]);

/**
 * AdminInvitationCreateRequest
 *
 * Request schema for admin-initiated invitations.
 * The backend resolves 'name' from user record (if exists) and infers invitation type automatically.
 */
export const zAdminInvitationCreateRequest = z.object({
    organization_uuid: z.uuid(),
    email: z.email(),
    role: zOrganizationRole,
    message: z.string().nullish()
});

/**
 * InvitationCreateRequest
 *
 * Request schema for creating an organization invitation
 */
export const zInvitationCreateRequest = z.object({
    email: z.email(),
    name: z.string(),
    role: zOrganizationRole,
    type: zInvitationType
});

/**
 * InvitationResponse
 *
 * Response schema for invitation data
 */
export const zInvitationResponse = z.object({
    uuid: z.uuid(),
    email: z.string(),
    role: zOrganizationRole,
    status: zInvitationStatus,
    invitation_type: zInvitationType,
    expires_at: z.iso.datetime(),
    accepted_at: z.iso.datetime().nullish(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    organization_name: z.string().nullish(),
    investor_name: z.string().nullish(),
    already_completed: z.boolean().optional().default(false)
});

/**
 * ListResponse[InvitationResponse]
 */
export const zListResponseInvitationResponse = z.object({
    items: z.array(zInvitationResponse),
    total_count: z.int()
});

/**
 * MembershipUpdateRequest
 *
 * Request model for updating membership data
 */
export const zMembershipUpdateRequest = z.object({
    role: zOrganizationRole.nullish(),
    is_active: z.boolean().nullish()
});

/**
 * OrganizationSummary
 *
 * Summary organization data for nested responses
 */
export const zOrganizationSummary = z.object({
    uuid: z.uuid(),
    name: z.string(),
    slug: z.string(),
    logo_signed_url: z.string().nullish(),
    is_active: z.boolean()
});

/**
 * InvestmentProposalResponse
 *
 * A proposal as the advisor and the investor's link both read it.
 *
 * ``status`` is **served, not stored**: a proposal nobody answered before its
 * deadline comes back as ``expired`` rather than as an error (B22). The
 * economic breakdown is the pair the proposal stores; ``recommended_investment``
 * is what it asks the investor to put in, to the cent, and where the
 * investment created from it starts.
 */
export const zInvestmentProposalResponse = z.object({
    uuid: z.uuid(),
    investor: zInvestorSummary,
    organization: zOrganizationSummary,
    fiscal_year: z.int(),
    taxable_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    tax_rate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    recommended_investment: z.string(),
    status: zInvestmentProposalDisplayStatus,
    expires_at: z.iso.datetime(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    investment: zLinkedInvestmentResponse.nullable()
});

/**
 * OrganizationUpdateRequest
 *
 * Request schema for updating an organization
 */
export const zOrganizationUpdateRequest = z.object({
    name: z.string().min(1).max(100).nullish(),
    logo: z.string().nullish(),
    email: z.email().nullish(),
    phone: z.string().max(20).nullish(),
    website: z.string().max(200).nullish(),
    address: z.string().max(200).nullish(),
    city: z.string().max(50).nullish(),
    state: z.string().max(50).nullish(),
    postal_code: z.string().max(20).nullish(),
    country: z.string().max(2).nullish(),
    fiscal_id: z.string().max(50).nullish(),
    tax_advisor_id: z.string().max(50).nullish(),
    legal_rep_first_name: z.string().max(120).nullish(),
    legal_rep_last_name: z.string().max(160).nullish(),
    legal_rep_national_id: z.string().max(32).nullish(),
    legal_rep_email: z.email().nullish(),
    is_active: z.boolean().nullish()
});

/**
 * PaginatedResponse[HubInvestmentResponse]
 */
export const zPaginatedResponseHubInvestmentResponse = z.object({
    items: z.array(zHubInvestmentResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int()
});

/**
 * PaginatedResponse[InvestmentProposalResponse]
 */
export const zPaginatedResponseInvestmentProposalResponse = z.object({
    items: z.array(zInvestmentProposalResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int()
});

/**
 * PaymentFields
 *
 * Extracted fields for payment receipts (comprobante_pago).
 */
export const zPaymentFields = z.object({
    amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    currency: z.string().nullable(),
    transfer_date: z.string().nullable(),
    beneficiary_name: z.string().nullable(),
    beneficiary_tax_id: z.string().nullable(),
    ordering_party: z.string().nullable(),
    bank_name: z.string().nullable(),
    invoice_reference: z.string().nullable(),
    transfer_reference: z.string().nullable(),
    concept: z.string().nullable()
});

/**
 * PayrollFields
 *
 * Extracted fields for payroll documents (nomina).
 */
export const zPayrollFields = z.object({
    company_name: z.string().nullable(),
    company_tax_id: z.string().nullable(),
    company_ccc: z.string().nullable(),
    worker_name: z.string().nullable(),
    worker_tax_id: z.string().nullable(),
    worker_nss: z.string().nullable(),
    worker_position: z.string().nullable(),
    worker_category: z.string().nullable(),
    worker_start_date: z.string().nullable(),
    contract_type: z.string().nullable(),
    period_month: z.int().nullable(),
    period_year: z.int().nullable(),
    period_start: z.string().nullable(),
    period_end: z.string().nullable(),
    payroll_type: z.string().nullable(),
    base_salary: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    seniority_bonus: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    extra_payments: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    overtime_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    other_earnings: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_earnings: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    ss_worker_contribution: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    irpf_rate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    irpf_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    other_deductions: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_deductions: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    net_salary: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    ss_employer_contribution: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    coste_empresa: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    currency: z.string().nullable()
});

/**
 * PendingDomain
 *
 * The object a pending item is about — the «Objeto» column of the list.
 */
export const zPendingDomain = z.enum([
    'contracts',
    'investments',
    'audit',
    'investors',
    'promoters',
    'proposals'
]);

/**
 * PendingItemAggregateValuesResponse
 *
 * The requested ``field:function`` pairs, and only those.
 *
 * The distribution of assignees keys the unassigned items as ``none``: a
 * JSON object cannot take a null key.
 */
export const zPendingItemAggregateValuesResponse = z.object({
    'queue:distribution': z.record(z.string(), z.int()).nullish(),
    'domain:distribution': z.record(z.string(), z.int()).nullish(),
    'urgency:distribution': z.record(z.string(), z.int()).nullish(),
    'assignee:distribution': z.record(z.string(), z.int()).nullish(),
    'assignee:filled': z.int().nullish(),
    'assignee:empty': z.int().nullish(),
    'assignee:unique': z.int().nullish(),
    'amount:sum': z.string().nullish(),
    'amount:avg': z.string().nullish(),
    'amount:min': z.string().nullish(),
    'amount:max': z.string().nullish()
});

/**
 * PendingItemAggregatesResponse
 *
 * Footer aggregates of Pendientes, computed over the whole filtered set.
 */
export const zPendingItemAggregatesResponse = z.object({
    aggregates: zPendingItemAggregateValuesResponse
});

/**
 * PendingItemAssigneeResponse
 *
 * The internal member the item is assigned to.
 */
export const zPendingItemAssigneeResponse = z.object({
    uuid: z.uuid(),
    name: z.string(),
    email: z.string()
});

/**
 * PendingObjectType
 *
 * The kind of record a pending item points at.
 *
 * The backend never sends a URL: it sends this plus the uuids of
 * ``PendingItemContext``, and the front builds the destination with
 * ``ROUTES``.
 */
export const zPendingObjectType = z.enum([
    'contract',
    'investment',
    'document',
    'classification',
    'investor',
    'fiscal_quota',
    'investment_proposal'
]);

/**
 * PendingItemObjectResponse
 *
 * What the row is about: its type, its uuid and the label it paints.
 */
export const zPendingItemObjectResponse = z.object({
    type: zPendingObjectType,
    uuid: z.uuid(),
    label: z.string()
});

/**
 * PendingQueue
 *
 * The fifteen queues of today.
 *
 * Adding a queue is adding a member here plus its entry in the registry and
 * its statement in ``infrastructure/repositories/pending_filters.py``. E10
 * added the two proposal ones; «promotores sin tipo de incentivo» died with
 * the plan (§1.1), because the incentive type is mandatory since #633.
 */
export const zPendingQueue = z.enum([
    'fallido',
    'firma',
    'reserva',
    'pago',
    'docs',
    'comunicar',
    'justificante',
    'error',
    'revision',
    'duplicado',
    'condicional',
    'hub',
    'presupuesto',
    'propuesta_caducada',
    'propuesta_aceptada'
]);

/**
 * PendingItemStateResponse
 *
 * What a person said about the item, read back.
 */
export const zPendingItemStateResponse = z.object({
    code: z.string(),
    queue: zPendingQueue,
    object_uuid: z.uuid(),
    assignee_uuid: z.uuid().nullable(),
    snooze_expires_at: z.iso.datetime().nullable(),
    dismissed_at: z.iso.datetime().nullable()
});

/**
 * PendingTone
 *
 * How grave a queue is. A failure queue is urgent whatever its deadline.
 */
export const zPendingTone = z.enum([
    'destructive',
    'warning',
    'neutral'
]);

/**
 * PendingQueueSummaryResponse
 *
 * One queue of the summary: how many items it holds and how many urge.
 */
export const zPendingQueueSummaryResponse = z.object({
    queue: zPendingQueue,
    domain: zPendingDomain,
    tone: zPendingTone,
    total: z.int(),
    urgent: z.int()
});

/**
 * PendingItemsSummaryResponse
 *
 * ``GET /pending-items/summary`` — what the sidebar badge and the dashboard panel read.
 *
 * A breakdown by queue plus the organization's two totals — deliberately not
 * a paginated list, so it does not wear the list envelope. **The badge counts
 * ``urgent_items``, never ``pending_items``.**
 */
export const zPendingItemsSummaryResponse = z.object({
    queues: z.array(zPendingQueueSummaryResponse),
    pending_items: z.int(),
    urgent_items: z.int()
});

/**
 * PendingUrgency
 *
 * One rule, served by the list, the summary and the aggregates.
 */
export const zPendingUrgency = z.enum(['urgent', 'normal']);

/**
 * PipelineErrorData
 *
 * Pipeline error details persisted by the classifier worker.
 */
export const zPipelineErrorData = z.object({
    failed_stage: z.string().nullish(),
    is_retriable: z.boolean().optional().default(false),
    error: z.string().nullish(),
    user_message: z.string().nullish()
});

/**
 * PipelineStateDataResponse
 *
 * Response model for pipeline data by state.
 */
export const zPipelineStateDataResponse = z.object({
    state: zInvestmentState,
    count: z.int(),
    volume: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/)
});

/**
 * InvestmentsMetricsResponse
 *
 * Response model for investments metrics.
 * Business concept: "Inversión" (Transactions)
 */
export const zInvestmentsMetricsResponse = z.object({
    summary: zInvestmentsSummaryResponse,
    pipeline: z.array(zPipelineStateDataResponse)
});

/**
 * PipelineStatusBreakdownResponse
 *
 * Counts of classifications grouped by pipeline status.
 *
 * Powers the operational "Estado de clasificación" panel in the
 * beneficiary overview. Buckets:
 *
 * - ``queued`` — QUEUED, waiting to enter the pipeline (info-only)
 * - ``processing`` — PROCESSING, currently being classified (info-only)
 * - ``failed`` — FAILED (actionable: bulk reprocess)
 * - ``classified`` — CLASSIFIED (info-only)
 * - ``needs_review`` — NEEDS_REVIEW (actionable: review modal)
 * - ``duplicate_detected`` — DUPLICATE_DETECTED (actionable: open
 * listing filtered + comparison modal)
 *
 * SKIPPED / REJECTED / DISCARDED are intentionally omitted: they don't
 * appear in the operational panel and would only add noise.
 */
export const zPipelineStatusBreakdownResponse = z.object({
    queued: z.int(),
    processing: z.int(),
    failed: z.int(),
    classified: z.int(),
    needs_review: z.int(),
    duplicate_detected: z.int()
});

/**
 * PreviewCommunicationContractRequest
 *
 * Request model for previewing communication contract.
 *
 * Mirrors ``SendCommunicationContractRequest``: the template decides
 * which annexes are attached, no request-level toggles.
 */
export const zPreviewCommunicationContractRequest = z.object({
    template_uuid: z.uuid()
});

/**
 * PreviewExpenseAuditRequest
 *
 * Body for ``POST /fiscal-quotas/{uuid}/actions/preview-expense-audit``.
 *
 * Same input as the generate request: the preview renders the exact same
 * PDF, just without persisting Document or uploading to GCS.
 */
export const zPreviewExpenseAuditRequest = z.object({
    template_uuid: z.uuid()
});

/**
 * PreviewFinancingContractRequest
 *
 * Request model for previewing financing contract
 */
export const zPreviewFinancingContractRequest = z.object({
    template_uuid: z.uuid(),
    payment_deadline: z.iso.datetime().nullish()
});

/**
 * PreviewReservationContractRequest
 *
 * Request model for previewing reservation contract
 */
export const zPreviewReservationContractRequest = z.object({
    template_uuid: z.uuid(),
    payment_deadline: z.iso.datetime().nullish()
});

/**
 * ProjectCoverRequest
 *
 * Which poster of the gallery becomes the project's cover.
 */
export const zProjectCoverRequest = z.object({
    document_uuid: z.uuid()
});

/**
 * ProjectState
 *
 * Lifecycle of a project.
 *
 * A person closes and reopens it; nothing is derived from the production end
 * date. ``ProjectStatus`` stays deprecated alongside it and is kept coherent
 * on write (``CLOSED`` ↔ ``INACTIVE``).
 */
export const zProjectState = z.enum(['running', 'closed']);

/**
 * ProjectStatus
 */
export const zProjectStatus = z.enum(['active', 'inactive']);

/**
 * ProjectSubtype
 */
export const zProjectSubtype = z.enum([
    'feature_film',
    'short_film',
    'film',
    'documentary',
    'series',
    'animation',
    'tv_movie',
    'music_video',
    'theatre',
    'dance',
    'opera',
    'musical',
    'music_festival',
    'music_event',
    'tour',
    'concert_hall',
    'nightclub',
    'circus'
]);

/**
 * LinkedProjectSummaryResponse
 *
 * Minimal project info attached to a FiscalQuota for display contexts.
 */
export const zLinkedProjectSummaryResponse = z.object({
    uuid: z.uuid(),
    title: z.string(),
    subtype: zProjectSubtype.nullable(),
    city: z.string().nullable(),
    production_start_date: z.iso.date().nullable(),
    production_end_date: z.iso.date().nullable()
});

/**
 * FiscalQuotaResponse
 *
 * Response model for fiscal quota data with nested metrics
 */
export const zFiscalQuotaResponse = z.object({
    uuid: z.uuid(),
    fiscal_year: z.int(),
    state: zFiscalQuotaState.default('estimated'),
    comments: z.string().nullable(),
    default_profitability_percentage: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).nullable(),
    deduction_rate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    money: zFiscalQuotaMoneyResponse,
    linked_projects: z.array(zLinkedProjectSummaryResponse).default([]),
    cost_breakdown: z.record(z.string(), z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)).nullable(),
    total_budget: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_eligible_cost: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    deduction_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_generated_deduction: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    own_contribution: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    subsidies: z.array(z.record(z.string(), z.unknown())).nullable(),
    consolidated_breakdown: z.record(z.string(), z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)).nullable(),
    consolidated_total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).nullable(),
    consolidated_at: z.iso.datetime().nullable(),
    consolidated_by_id: z.int().nullable(),
    consolidation_reopened_at: z.iso.datetime().nullable(),
    consolidation_reopened_by_id: z.int().nullable(),
    audit_state: zAuditState.default('in_progress'),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * FiscalYearSummaryResponse
 *
 * Response for GET /beneficiaries/{uuid}/fiscal-year-summary?fiscal_year=N.
 */
export const zFiscalYearSummaryResponse = z.object({
    fiscal_year: z.int(),
    quota_count: z.int(),
    aggregate: zFiscalYearAggregateResponse,
    quotas: z.array(zFiscalQuotaResponse)
});

/**
 * ListResponse[FiscalQuotaResponse]
 */
export const zListResponseFiscalQuotaResponse = z.object({
    items: z.array(zFiscalQuotaResponse),
    total_count: z.int()
});

/**
 * ProjectBulkRow
 *
 * A single row coming from the Excel import wizard.
 *
 * Mirrors the user-editable columns of the template. Fields shared by the
 * whole import (``fiscal_quota_uuid`` and the incentive type) are not on the
 * row — the endpoint resolves the quota once and infers the incentive type
 * from the beneficiary. ``fundraising_date`` is intentionally excluded: it's
 * a back-office field, not something promoters fill in via Excel.
 */
export const zProjectBulkRow = z.object({
    title: z.string().min(1).max(255),
    subtype: zProjectSubtype,
    fiscal_year: z.int().gte(1900).lte(2100).nullish(),
    city: z.string().max(100).nullish(),
    production_start_date: z.iso.date().nullish(),
    production_end_date: z.iso.date().nullish(),
    description: z.string().max(1000).nullish()
});

/**
 * ProjectBulkCreateRequest
 *
 * Wizard payload: one fiscal quota + N project rows.
 *
 * The wizard is rooted in a fiscal quota modal, so ``fiscal_quota_uuid`` is
 * shared across all rows. Submission is atomic on the backend — if any row
 * fails validation or persistence the whole batch is rolled back.
 */
export const zProjectBulkCreateRequest = z.object({
    fiscal_quota_uuid: z.uuid(),
    projects: z.array(zProjectBulkRow).min(1).max(200)
});

/**
 * QualificationData
 *
 * Fiscal qualification result from the qualification stage.
 */
export const zQualificationData = z.object({
    eligible: z.boolean().nullish(),
    eligibility_type: zEligibilityType.nullish(),
    fiscal_category: z.string().nullish(),
    fiscal_subcategory: z.string().nullish(),
    article: z.string().nullish(),
    deduction_rate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullish(),
    reasoning: z.string().nullish()
});

/**
 * ClassificationResultData
 *
 * Combined categorization, qualification, error, and duplicate detection results.
 */
export const zClassificationResultData = z.object({
    categorization: zCategorizationData.nullish(),
    qualification: zQualificationData.nullish(),
    pipeline_error: zPipelineErrorData.nullish(),
    duplicate_detection: zDuplicateDetectionData.nullish()
});

/**
 * QuotaDimension
 *
 * Whether a quota is pooled across the org or applied per user.
 */
export const zQuotaDimension = z.enum(['per_org', 'per_user']);

/**
 * QuotaEnforcement
 *
 * Whether exceeding the quota blocks the action or is only observed.
 */
export const zQuotaEnforcement = z.enum(['monitor', 'enforce']);

/**
 * QuotaUnit
 *
 * Unit the quota limit is expressed in.
 */
export const zQuotaUnit = z.enum([
    'tokens',
    'count',
    'bytes'
]);

/**
 * QuotaWindow
 *
 * Time window a quota's usage is accumulated over.
 */
export const zQuotaWindow = z.enum([
    'day',
    'month',
    'rolling_30d',
    'total'
]);

/**
 * QuotaDescriptorSchema
 *
 * One quota limit on a metric — the shape stored in entitlement config.quotas.
 */
export const zQuotaDescriptorSchema = z.object({
    dimension: zQuotaDimension,
    window: zQuotaWindow,
    unit: zQuotaUnit,
    limit: z.int().gte(0),
    enforcement: zQuotaEnforcement.optional().default('monitor'),
    warning_pct: z.number().gte(0).lte(100).optional().default(80)
});

/**
 * AdminEntitlementCreateRequest
 *
 * Grant a module to an organization (platform admin).
 */
export const zAdminEntitlementCreateRequest = z.object({
    module_code: zModuleCode,
    quotas: z.record(z.string(), zQuotaDescriptorSchema).optional(),
    is_active: z.boolean().optional().default(true),
    expires_at: z.iso.datetime().nullish()
});

/**
 * AdminEntitlementUpdateRequest
 *
 * Patch an entitlement's quotas, activation, or expiry. None leaves a field unchanged.
 */
export const zAdminEntitlementUpdateRequest = z.object({
    quotas: z.record(z.string(), zQuotaDescriptorSchema).nullish(),
    is_active: z.boolean().nullish(),
    expires_at: z.iso.datetime().nullish()
});

/**
 * QuotaStateResponse
 *
 * Evaluated usage vs limit for one quota descriptor.
 */
export const zQuotaStateResponse = z.object({
    metric: z.string(),
    dimension: zQuotaDimension,
    window: zQuotaWindow,
    used: z.int(),
    limit: z.int(),
    pct_used: z.number(),
    exceeded: z.boolean(),
    warning: z.boolean(),
    enforcement: zQuotaEnforcement
});

/**
 * AdminEntitlementResponse
 *
 * Admin view of an entitlement with its evaluated quota states.
 */
export const zAdminEntitlementResponse = z.object({
    uuid: z.string(),
    module_code: z.string(),
    is_active: z.boolean(),
    config: z.record(z.string(), z.unknown()),
    activated_at: z.iso.datetime().nullable(),
    expires_at: z.iso.datetime().nullable(),
    quota_reset_at: z.iso.datetime().nullable(),
    quota_states: z.array(zQuotaStateResponse)
});

/**
 * ReclassifyClassificationRequest
 *
 * Optional body for the single reclassify endpoint.
 *
 * ``locks`` REPLACES the document's full lock set — the modal always shows
 * the true current state, so what it submits is the desired set and an
 * unchecked field is a removed lock. Omit the body entirely to reprocess
 * while preserving existing sticky locks (quick reprocess / bulk path); an
 * empty list clears all locks.
 */
export const zReclassifyClassificationRequest = z.object({
    locks: z.array(zFieldLockInput).max(20).optional()
});

/**
 * RelatedEntityType
 */
export const zRelatedEntityType = z.enum([
    'note',
    'comment_thread',
    'project',
    'investment_proposal',
    'investment',
    'document',
    'contract',
    'beneficiary',
    'fiscal_quota',
    'investor',
    'organization'
]);

/**
 * ReplaceFieldLocksRequest
 *
 * PATCH …/classifications/{uuid}/locks — replaces the set, no reprocess.
 */
export const zReplaceFieldLocksRequest = z.object({
    locks: z.array(zFieldLockInput).optional()
});

/**
 * ResendDocumentResponse
 *
 * Response model for resend document action
 */
export const zResendDocumentResponse = z.object({
    resent: z.boolean(),
    envelope_id: z.string().nullable(),
    pending_signers: z.array(z.record(z.string(), z.unknown())).nullable(),
    resent_at: z.iso.datetime().nullable()
});

/**
 * ResolveDuplicateRequest
 *
 * Request to resolve a duplicate — keep one, discard the other.
 */
export const zResolveDuplicateRequest = z.object({
    keep_uuid: z.uuid(),
    discard_uuid: z.uuid()
});

/**
 * ResolveReviewFlagRequest
 *
 * POST …/classifications/{uuid}/review-flags/{flag_uuid}/actions/resolve.
 */
export const zResolveReviewFlagRequest = z.object({
    resolution: zFindingResolution
});

/**
 * ReviewAction
 *
 * Actions an assessor can take when reviewing a classification.
 *
 * Legacy mirror of ``ClassificationDisposition`` (#313): VALIDATED/REJECTED
 * duplicate the disposition; CORRECTED is a field-edit audit mark, not a
 * disposition. Kept dual-written until the contraction phase drops it.
 */
export const zReviewAction = z.enum([
    'validated',
    'corrected',
    'rejected'
]);

/**
 * ReviewClassificationRequest
 *
 * Request to review a classification (validate or reject).
 */
export const zReviewClassificationRequest = z.object({
    action: zReviewAction
});

/**
 * ReviewFlagResolution
 *
 * How an open review flag was closed. UPPERCASE — stored verbatim in
 * the ``review_flag_resolution`` PG enum.
 */
export const zReviewFlagResolution = z.enum([
    'ACCEPTED',
    'RESOLVED',
    'SUPERSEDED'
]);

/**
 * ReviewFlagSeverity
 *
 * Declarative severity per code — derived from its tier, never stored.
 * UPPERCASE to match the DB enum convention of the repo.
 */
export const zReviewFlagSeverity = z.enum(['BLOCKING', 'ADVISORY']);

/**
 * ReviewReason
 *
 * F4+ tagged-union review reason. `extra='allow'` so the API tolerates
 * a future param key the frontend has not yet seen — the JSONB is
 * forward-compatible across deploys.
 */
export const zReviewReason = z.object({
    code: z.string(),
    params: z.record(z.string(), z.unknown()).optional()
});

/**
 * ReviewStatus
 *
 * Human review workflow status.
 */
export const zReviewStatus = z.enum([
    'pending',
    'approved',
    'rejected'
]);

/**
 * ReviewBlock
 *
 * Human approval workflow — always present on reviewable documents.
 */
export const zReviewBlock = z.object({
    status: zReviewStatus,
    reviewed_by_uuid: z.uuid().nullish(),
    reviewed_at: z.iso.datetime().nullish(),
    notes: z.string().nullish()
});

/**
 * ReviewTier
 *
 * Level of the review hierarchy a code belongs to. Members are declared
 * in review order: ``rank`` 0 is reviewed first.
 */
export const zReviewTier = z.enum([
    'existence',
    'integrity',
    'judgement'
]);

/**
 * ReviewFlagResponse
 *
 * A review finding with its lifecycle (#313). `tier`, `severity` and
 * `is_open` are derived server-side so the frontend orders and renders the
 * findings without re-deriving the catalogue.
 */
export const zReviewFlagResponse = z.object({
    uuid: z.uuid().nullish(),
    code: z.string(),
    params: z.record(z.string(), z.unknown()),
    tier: zReviewTier,
    severity: zReviewFlagSeverity,
    is_open: z.boolean(),
    raised_at: z.iso.datetime(),
    resolved_at: z.iso.datetime().nullable(),
    resolution: zReviewFlagResolution.nullable(),
    resolved_by_id: z.int().nullable(),
    targets: z.array(z.string()).optional()
});

/**
 * ReviewUpdateRequest
 *
 * Request body for PATCH /{entity}/{id}/documents/{doc_id}/review.
 */
export const zReviewUpdateRequest = z.object({
    status: z.enum(['approved', 'rejected']),
    notes: z.string().nullish()
});

/**
 * RuleIdCount
 *
 * One entry in the rule-ids dropdown options. Used by the async filter
 * in the review queue to render dropdown items with usage frequency.
 */
export const zRuleIdCount = z.object({
    rule_id: z.string(),
    count: z.int()
});

/**
 * RuleIdsResponse
 *
 * Response for the `/rule-ids` endpoint — distinct rule_ids seen in
 * a beneficiary's classifications, sorted by count desc (most-used first).
 */
export const zRuleIdsResponse = z.object({
    rule_ids: z.array(zRuleIdCount)
});

/**
 * SendCommunicationContractRequest
 *
 * Request model for sending communication contract (AEAT communication).
 *
 * Attachments (signed financing contract, INAEM/ICAA certificate) are no
 * longer opt-in: the chosen template's ``pdfAttachmentBlock`` nodes
 * declare exactly which annexes the final document must contain. Pick
 * the template that matches the flow (with or without annexes).
 */
export const zSendCommunicationContractRequest = z.object({
    template_uuid: z.uuid(),
    message: z.string().max(2000).nullish()
});

/**
 * SendFinancingContractRequest
 *
 * Request model for sending financing contract
 */
export const zSendFinancingContractRequest = z.object({
    template_uuid: z.uuid(),
    payment_deadline: z.iso.datetime().nullish(),
    message: z.string().max(2000).nullish()
});

/**
 * SendReservationContractRequest
 *
 * Request model for sending reservation contract
 */
export const zSendReservationContractRequest = z.object({
    template_uuid: z.uuid(),
    payment_deadline: z.iso.datetime().nullish(),
    message: z.string().max(2000).nullish()
});

/**
 * SetDefaultOrganizationRequest
 *
 * Request model for setting the default organization
 */
export const zSetDefaultOrganizationRequest = z.object({
    organization_uuid: z.uuid()
});

/**
 * SignUploadBatchRequest
 *
 * Request to sign upload URLs for a batch of a deferred session's files.
 */
export const zSignUploadBatchRequest = z.object({
    classification_uuids: z.array(z.uuid()).min(1).max(500)
});

/**
 * SignatureBlockPreviewResponse
 */
export const zSignatureBlockPreviewResponse = z.object({
    kind: z.literal('signature'),
    heading_by_identity: z.record(z.string(), z.string()),
    mock_name: z.string(),
    mock_title: z.string(),
    mock_date_label: z.string()
});

/**
 * SignatureProgress
 *
 * Signing progress metrics.
 */
export const zSignatureProgress = z.object({
    total: z.int(),
    signed: z.int(),
    pending: z.int(),
    percentage: z.number()
});

/**
 * SignatureRegime
 *
 * Signing regime of a party's legal representation.
 *
 * SOLE — one representative signs alone.
 * JOINT — joint administrators ("administradores mancomunados"): every
 * representative flagged as signer must sign the contract.
 */
export const zSignatureRegime = z.enum(['sole', 'joint']);

/**
 * SignatureStatus
 *
 * Digital signature workflow status.
 *
 * Providers handle expiry differently: some auto-void expired envelopes
 * (arriving here as VOIDED), others fire a dedicated expired event.
 */
export const zSignatureStatus = z.enum([
    'pending',
    'sent',
    'signed',
    'declined',
    'voided',
    'failed'
]);

/**
 * RetryContractDispatchResponse
 *
 * Response model for retrying a failed contract dispatch.
 *
 * Same shape as the send-contract responses — the retry path runs the
 * same background dispatch and reports the same status fields back.
 */
export const zRetryContractDispatchResponse = z.object({
    contract_dispatched: z.boolean(),
    document_uuid: z.string(),
    signature_status: zSignatureStatus,
    dispatched_at: z.iso.datetime()
});

/**
 * SendCommunicationContractResponse
 *
 * Response model for send communication contract action.
 *
 * See :class:`SendReservationContractResponse` for the async dispatch
 * semantics — same shape, ``202 Accepted`` + background DocuSign call.
 */
export const zSendCommunicationContractResponse = z.object({
    contract_dispatched: z.boolean(),
    document_created: z.boolean(),
    document_uuid: z.string(),
    signature_status: zSignatureStatus,
    docusign_envelope_id: z.string().nullish(),
    dispatched_at: z.iso.datetime()
});

/**
 * SendFinancingContractResponse
 *
 * Response model for send financing contract action.
 *
 * See :class:`SendReservationContractResponse` for the async dispatch
 * semantics — same shape, ``202 Accepted`` + background DocuSign call.
 */
export const zSendFinancingContractResponse = z.object({
    contract_dispatched: z.boolean(),
    document_created: z.boolean(),
    document_uuid: z.string(),
    signature_status: zSignatureStatus,
    docusign_envelope_id: z.string().nullish(),
    dispatched_at: z.iso.datetime()
});

/**
 * SendReservationContractResponse
 *
 * Response model for send reservation contract action.
 *
 * The request returns ``202 Accepted`` as soon as the document and the
 * signature row are persisted. The DocuSign envelope is created in a
 * background task, so ``docusign_envelope_id`` is ``None`` at response
 * time — clients should poll the contract list / detail endpoint to
 * observe the signature transition ``pending → sent`` (typically a few
 * seconds).
 */
export const zSendReservationContractResponse = z.object({
    contract_dispatched: z.boolean(),
    document_created: z.boolean(),
    document_uuid: z.string(),
    signature_status: zSignatureStatus,
    docusign_envelope_id: z.string().nullish(),
    dispatched_at: z.iso.datetime()
});

/**
 * SignedUpload
 *
 * A freshly signed upload URL for one file of a deferred session.
 */
export const zSignedUpload = z.object({
    classification_uuid: z.uuid(),
    upload_url: z.string(),
    content_type: z.string()
});

/**
 * SignUploadBatchResponse
 *
 * Response with signed URLs for a batch of a deferred session.
 */
export const zSignUploadBatchResponse = z.object({
    session_id: z.uuid(),
    expires_at: z.iso.datetime(),
    uploads: z.array(zSignedUpload)
});

/**
 * SignerBlock
 *
 * Individual signer within a signature workflow.
 */
export const zSignerBlock = z.object({
    email: z.string(),
    name: z.string(),
    type: z.string(),
    status: z.string(),
    routing_order: z.int(),
    client_user_id: z.string().nullish(),
    opened_at: z.iso.datetime().nullish(),
    signed_at: z.iso.datetime().nullish(),
    failed_at: z.iso.datetime().nullish()
});

/**
 * SignatureBlock
 *
 * Digital signature workflow — present on contracts/signable documents.
 */
export const zSignatureBlock = z.object({
    status: zSignatureStatus,
    envelope_id: z.string().nullable(),
    signers: z.array(zSignerBlock),
    sent_at: z.iso.datetime().nullable(),
    completed_at: z.iso.datetime().nullable(),
    last_error: z.string().nullable(),
    last_failed_at: z.iso.datetime().nullable()
});

/**
 * SnoozePendingItemRequest
 *
 * Hide the item until a moment. Omitted means a week from now.
 */
export const zSnoozePendingItemRequest = z.object({
    snooze_expires_at: z.iso.datetime().nullish()
});

/**
 * BulkSnoozePendingItemsRequest
 *
 * Hide each item until the same moment — a week from now when omitted.
 */
export const zBulkSnoozePendingItemsRequest = z.object({
    pending_item_codes: z.array(z.string()).min(1).max(200),
    data: zSnoozePendingItemRequest.optional()
});

/**
 * StateAggregationResponse
 *
 * Response model for investment aggregation by state.
 */
export const zStateAggregationResponse = z.object({
    state: zInvestmentState,
    count: z.int(),
    total_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/)
});

/**
 * EntityAggregationResponse
 *
 * Response model for investment aggregation by entity.
 */
export const zEntityAggregationResponse = z.object({
    entity_uuid: z.uuid(),
    entity_name: z.string(),
    count: z.int(),
    total_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    by_state: z.array(zStateAggregationResponse)
});

/**
 * InvestmentAggregationResponse
 *
 * Response model for investment aggregation metrics.
 */
export const zInvestmentAggregationResponse = z.object({
    total_count: z.int(),
    total_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    by_state: z.array(zStateAggregationResponse),
    by_beneficiary: z.array(zEntityAggregationResponse).nullish(),
    by_investor: z.array(zEntityAggregationResponse).nullish(),
    filters_applied: z.record(z.string(), z.unknown())
});

/**
 * SupplierBreakdownResponse
 */
export const zSupplierBreakdownResponse = z.object({
    name: z.string(),
    tax_id: z.string().nullable(),
    invoice_count: z.int(),
    total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
});

/**
 * SuppliersAnalyticsResponse
 */
export const zSuppliersAnalyticsResponse = z.object({
    suppliers: z.array(zSupplierBreakdownResponse),
    total_suppliers: z.int(),
    top3_concentration: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
});

/**
 * TableBlockPreviewResponse
 */
export const zTableBlockPreviewResponse = z.object({
    kind: z.literal('table'),
    columns: z.array(z.string()),
    sample_rows: z.array(z.array(z.string()))
});

/**
 * BlockResponse
 *
 * Response schema for a single compound block.
 */
export const zBlockResponse = z.object({
    key: z.string(),
    description: z.string(),
    preview: z.discriminatedUnion('kind', [
        zListBlockPreviewResponse,
        zTableBlockPreviewResponse,
        zSignatureBlockPreviewResponse,
        zAttachmentBlockPreviewResponse,
        zDescriptionBlockPreviewResponse,
        zImageBlockPreviewResponse
    ]),
    variants: z.array(zBlockVariantResponse)
});

/**
 * BlockGroupResponse
 *
 * Response schema for a group of blocks.
 */
export const zBlockGroupResponse = z.object({
    group: z.string(),
    items: z.array(zBlockResponse)
});

/**
 * CatalogResponse
 *
 * Response schema for the full catalog.
 *
 * Split into two top-level collections:
 * - fields: scalar values substituted inline.
 * - blocks: compound structures with their own editor nodes.
 */
export const zCatalogResponse = z.object({
    fields: z.array(zFieldGroupResponse),
    blocks: z.array(zBlockGroupResponse),
    total_fields: z.int(),
    total_blocks: z.int()
});

/**
 * TagTone
 *
 * The six tones of the design system's ``Tag``.
 *
 * ``default``, ``outline`` and ``selected`` are states of the component, not
 * colours a team picks, so they are not offered here.
 */
export const zTagTone = z.enum([
    'pink',
    'pink-dark',
    'blue-dark',
    'sage',
    'green',
    'lime'
]);

/**
 * TagCreateRequest
 *
 * A tag about to exist. The name is stored as typed and compared normalized.
 */
export const zTagCreateRequest = z.object({
    name: z.string().min(1).max(60),
    tone: zTagTone
});

/**
 * TagRefResponse
 *
 * A tag as a record carries it: the chip a row and a rail paint.
 */
export const zTagRefResponse = z.object({
    uuid: z.uuid(),
    name: z.string(),
    tone: zTagTone
});

/**
 * EntityTagsResponse
 *
 * What the record wears after the replacement, ordered by name.
 */
export const zEntityTagsResponse = z.object({
    tags: z.array(zTagRefResponse)
});

/**
 * TagUpdateRequest
 *
 * A new name, a new tone, or both.
 */
export const zTagUpdateRequest = z.object({
    name: z.string().min(1).max(60).nullish(),
    tone: zTagTone.nullish()
});

/**
 * TagUsageResponse
 *
 * How many records wear a tag: the total, and the breakdown the delete dialog reads.
 */
export const zTagUsageResponse = z.object({
    total: z.int(),
    investor: z.int().default(0),
    beneficiary: z.int().default(0)
});

/**
 * TagResponse
 *
 * One tag of the organization, with its usage.
 */
export const zTagResponse = z.object({
    uuid: z.uuid(),
    name: z.string(),
    tone: zTagTone,
    usage: zTagUsageResponse
});

/**
 * ListResponse[TagResponse]
 */
export const zListResponseTagResponse = z.object({
    items: z.array(zTagResponse),
    total_count: z.int()
});

/**
 * TaxBreakdownAnalyticsResponse
 */
export const zTaxBreakdownAnalyticsResponse = z.object({
    total_iva: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    total_irpf: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    iva_by_rate: z.array(zIvaRateBreakdownResponse)
});

/**
 * TaxIncentiveType
 */
export const zTaxIncentiveType = z.enum(['film_audiovisual', 'performing_arts_music']);

/**
 * BeneficiarySummary
 *
 * Summary model for beneficiary data in other contexts (e.g., project responses)
 */
export const zBeneficiarySummary = z.object({
    uuid: z.uuid(),
    name: z.string(),
    tax_id: z.string(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    incentive_type: zTaxIncentiveType.nullable(),
    primary_contact: zBeneficiaryPrimaryContactResponse.nullable()
});

/**
 * ConsolidationPreviewResponse
 *
 * GET /beneficiaries/{uuid}/fiscal-quotas/{fiscal_quota_uuid}/consolidation-preview.
 */
export const zConsolidationPreviewResponse = z.object({
    fiscal_quota_uuid: z.uuid(),
    incentive_type: zTaxIncentiveType.nullable(),
    buckets: z.array(zConsolidationBucketPreviewResponse),
    consolidated_total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    consolidated_eligible_cost: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    consolidated_deduction_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    consolidated_generated_deduction: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    pending_review_count: z.int(),
    pending_review_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    pending_review_potential_deduction: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    blocking: zConsolidationBlockingResponse,
    is_consolidated: z.boolean().default(false),
    last_consolidated_at: z.iso.datetime().nullable(),
    last_consolidated_by_id: z.int().nullable(),
    new_since_last_sync: z.int().nullable()
});

/**
 * ContractQuotaSummary
 *
 * The parts of the quota's name that a contract row carries.
 *
 * Never the text: the front composes «{title} {year}» for film and
 * «Cuota {year}» for music with its single rule (``E7a.md`` §3).
 */
export const zContractQuotaSummary = z.object({
    uuid: z.uuid(),
    fiscal_year: z.int(),
    incentive_type: zTaxIncentiveType.nullable(),
    project_titles: z.array(z.string())
});

/**
 * ContractSummary
 *
 * Summary of a contract document for list views.
 */
export const zContractSummary = z.object({
    document_uuid: z.uuid(),
    investment_uuid: z.uuid().nullable(),
    contract_type: zContractType,
    status: zContractDisplayStatus,
    envelope_id: z.string().nullable(),
    created_at: z.iso.datetime(),
    sent_at: z.iso.datetime().nullable(),
    completed_at: z.iso.datetime().nullable(),
    voided_at: z.iso.datetime().nullable(),
    signers: z.array(zSignerBlock),
    total_signers: z.int(),
    signed_count: z.int(),
    investor_name: z.string().nullable(),
    beneficiary_name: z.string().nullable(),
    investment_amount: z.string().nullable(),
    fiscal_quota: zContractQuotaSummary.nullable(),
    investor: zContractPartySummary.nullable(),
    beneficiary: zContractPartySummary.nullable()
});

/**
 * EntityRefSummaryResponse
 */
export const zEntityRefSummaryResponse = z.object({
    entity_type: zEntityType,
    entity_uuid: z.uuid(),
    label: z.string(),
    status: z.union([
        zEntityStatus,
        zInvestmentState,
        zInvestmentProposalStatus,
        zFiscalQuotaState,
        zProjectState,
        zClassificationStatus,
        zDocumentStatus,
        z.literal('deleted')
    ]),
    parent: zEntityRefResponse.nullable(),
    fiscal_year: z.int().nullable(),
    incentive_type: zTaxIncentiveType.nullable(),
    project_titles: z.array(z.string())
});

/**
 * ActivityAxesResponse
 */
export const zActivityAxesResponse = z.object({
    beneficiary: zEntityRefSummaryResponse.nullable(),
    investor: zEntityRefSummaryResponse.nullable(),
    fiscal_quota: zEntityRefSummaryResponse.nullable(),
    investment: zEntityRefSummaryResponse.nullable()
});

/**
 * ActivityEventResponse
 */
export const zActivityEventResponse = z.object({
    uuid: z.uuid(),
    event_type: z.union([
        zOrganizationActivityEvent,
        zInvestmentEventType
    ]),
    category: zActivityCategory,
    occurred_at: z.iso.datetime(),
    actor: zActivityActorResponse.nullable(),
    object: zEntityRefSummaryResponse,
    axes: zActivityAxesResponse,
    payload: z.record(z.string(), z.unknown()).nullable(),
    cursor: z.string()
});

/**
 * CommentThreadDetailResponse
 */
export const zCommentThreadDetailResponse = z.object({
    uuid: z.uuid(),
    subject: zEntityRefSummaryResponse,
    author: zCommentPersonResponse.nullable(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    resolved_at: z.iso.datetime().nullable(),
    resolved_by: zCommentPersonResponse.nullable(),
    last_message_at: z.iso.datetime(),
    root_message: zCommentMessageResponse.nullable(),
    reply_count: z.int(),
    participants: z.array(zCommentPersonResponse),
    is_read: z.boolean(),
    muted: z.boolean(),
    messages: z.array(zCommentMessageResponse)
});

/**
 * CommentThreadResponse
 */
export const zCommentThreadResponse = z.object({
    uuid: z.uuid(),
    subject: zEntityRefSummaryResponse,
    author: zCommentPersonResponse.nullable(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    resolved_at: z.iso.datetime().nullable(),
    resolved_by: zCommentPersonResponse.nullable(),
    last_message_at: z.iso.datetime(),
    root_message: zCommentMessageResponse.nullable(),
    reply_count: z.int(),
    participants: z.array(zCommentPersonResponse),
    is_read: z.boolean(),
    muted: z.boolean()
});

/**
 * FilteredPaginatedResponse[ContractSummary]
 */
export const zFilteredPaginatedResponseContractSummary = z.object({
    items: z.array(zContractSummary),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int(),
    total_unfiltered_count: z.int()
});

/**
 * FiscalQuotaDetailResponse
 *
 * ``GET /fiscal-quotas/{uuid}``: the row of the promoter's tab plus the promoter itself.
 *
 * Everything ``GET /beneficiaries/{uuid}/fiscal-quotas`` serves for that
 * quota, with the promoter and the parts of the quota's name, so the detail
 * page needs no second call.
 */
export const zFiscalQuotaDetailResponse = z.object({
    uuid: z.uuid(),
    fiscal_year: z.int(),
    state: zFiscalQuotaState.default('estimated'),
    comments: z.string().nullable(),
    default_profitability_percentage: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).nullable(),
    deduction_rate: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    money: zFiscalQuotaMoneyResponse,
    linked_projects: z.array(zLinkedProjectSummaryResponse).default([]),
    cost_breakdown: z.record(z.string(), z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)).nullable(),
    total_budget: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_eligible_cost: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    deduction_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_generated_deduction: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    own_contribution: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    subsidies: z.array(z.record(z.string(), z.unknown())).nullable(),
    consolidated_breakdown: z.record(z.string(), z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)).nullable(),
    consolidated_total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).nullable(),
    consolidated_at: z.iso.datetime().nullable(),
    consolidated_by_id: z.int().nullable(),
    consolidation_reopened_at: z.iso.datetime().nullable(),
    consolidation_reopened_by_id: z.int().nullable(),
    audit_state: zAuditState.default('in_progress'),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    beneficiary: zBeneficiarySummary,
    incentive_type: zTaxIncentiveType.nullable()
});

/**
 * FiscalQuotaListItemResponse
 *
 * One row of ``GET /fiscal-quotas``.
 *
 * The name of the quota is **not** a text here: the row carries
 * ``linked_projects`` and ``incentive_type``, and the front composes the name
 * with its single rule (film «{title} {year}», music «Cuota {year}»).
 *
 * ``money`` is the same object the quota's detail serves.
 */
export const zFiscalQuotaListItemResponse = z.object({
    uuid: z.uuid(),
    fiscal_year: z.int(),
    state: zFiscalQuotaState,
    beneficiary: zFiscalQuotaBeneficiarySummary,
    incentive_type: zTaxIncentiveType.nullable(),
    linked_projects: z.array(zLinkedProjectSummaryResponse).default([]),
    investments_count: z.int(),
    money: zFiscalQuotaMoneyResponse
});

/**
 * FilteredPaginatedResponse[FiscalQuotaListItemResponse]
 */
export const zFilteredPaginatedResponseFiscalQuotaListItemResponse = z.object({
    items: z.array(zFiscalQuotaListItemResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int(),
    total_unfiltered_count: z.int()
});

/**
 * FiscalQuotaSummary
 *
 * Summary model for beneficiary fiscal quota data
 */
export const zFiscalQuotaSummary = z.object({
    uuid: z.uuid(),
    fiscal_year: z.int(),
    state: zFiscalQuotaState.default('estimated'),
    estimated_deduction: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    reserved_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    completed_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    utilization_percentage: z.number(),
    incentive_type: zTaxIncentiveType.nullable(),
    linked_projects: z.array(zLinkedProjectSummaryResponse).default([]),
    cost_breakdown: z.record(z.string(), z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)).nullable(),
    total_budget: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_eligible_cost: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    deduction_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_generated_deduction: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    own_contribution: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    subsidies: z.array(z.record(z.string(), z.unknown())).nullable()
});

/**
 * ContractInvestmentContext
 *
 * Investment context embedded in contract detail response.
 */
export const zContractInvestmentContext = z.object({
    uuid: z.uuid(),
    state: zInvestmentState,
    investor: zContractPartySummary.nullable(),
    beneficiary: zContractPartySummary.nullable(),
    quota: zFiscalQuotaSummary.nullish()
});

/**
 * ListResponse[ActivityEventResponse]
 */
export const zListResponseActivityEventResponse = z.object({
    items: z.array(zActivityEventResponse),
    total_count: z.int()
});

/**
 * NoteMentionPayload
 */
export const zNoteMentionPayload = z.object({
    kind: z.literal('note_mentioned'),
    note_uuid: z.uuid(),
    holder: zEntityRefSummaryResponse,
    actor: zCommentPersonResponse.nullable()
});

/**
 * NoteResponse
 */
export const zNoteResponse = z.object({
    uuid: z.uuid(),
    title: z.string(),
    excerpt: z.string(),
    holder: zEntityRefSummaryResponse,
    author: zCommentPersonResponse.nullable(),
    last_edited_by: zCommentPersonResponse.nullable(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    revision: z.int(),
    body: z.record(z.string(), z.unknown())
});

/**
 * NoteSummaryResponse
 */
export const zNoteSummaryResponse = z.object({
    uuid: z.uuid(),
    title: z.string(),
    excerpt: z.string(),
    holder: zEntityRefSummaryResponse,
    author: zCommentPersonResponse.nullable(),
    last_edited_by: zCommentPersonResponse.nullable(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    revision: z.int()
});

/**
 * NoteListResponse
 */
export const zNoteListResponse = z.object({
    items: z.array(zNoteSummaryResponse),
    next_cursor: z.string().nullable()
});

/**
 * NotificationResponse
 *
 * Schema for notification responses
 */
export const zNotificationResponse = z.object({
    title: z.string().min(1).max(255),
    body: z.string().max(1000).nullish(),
    type: zNotificationType,
    related_entity_type: zRelatedEntityType.nullish(),
    related_entity_uuid: z.uuid().nullish(),
    related_context: z.record(z.string(), z.string()).nullish(),
    payload: zNoteMentionPayload.nullish(),
    uuid: z.uuid(),
    is_read: z.boolean(),
    read_at: z.iso.datetime().nullable(),
    created_at: z.iso.datetime()
});

/**
 * PaginatedResponse[CommentThreadResponse]
 */
export const zPaginatedResponseCommentThreadResponse = z.object({
    items: z.array(zCommentThreadResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int()
});

/**
 * PaginatedResponse[NotificationResponse]
 */
export const zPaginatedResponseNotificationResponse = z.object({
    items: z.array(zNotificationResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int()
});

/**
 * PendingItemQuotaSummary
 *
 * The parts of a quota's name, never its text: the front composes it (E7a §3).
 */
export const zPendingItemQuotaSummary = z.object({
    uuid: z.uuid(),
    fiscal_year: z.int(),
    incentive_type: zTaxIncentiveType.nullable(),
    project_titles: z.array(z.string()).default([])
});

/**
 * PendingItemContextResponse
 *
 * The uuids the front needs to build the destination with ``ROUTES``.
 *
 * **The backend never sends a URL.** An audit lives under its promoter and its
 * quota, a classification under its document: whatever the verb needs to
 * address is here as an identifier.
 */
export const zPendingItemContextResponse = z.object({
    investment_uuid: z.uuid().nullable(),
    document_uuid: z.uuid().nullable(),
    classification_uuid: z.uuid().nullable(),
    investor_uuid: z.uuid().nullable(),
    beneficiary_uuid: z.uuid().nullable(),
    investment_proposal_uuid: z.uuid().nullable(),
    fiscal_quota: zPendingItemQuotaSummary.nullable()
});

/**
 * PendingItemResponse
 *
 * One row of ``GET /pending-items``.
 *
 * ``code`` is the queue and the object uuid separated by a colon, and it is
 * what the three actions address.
 * ``due_at`` is the record's own deadline — in Pro only a reservation has
 * one — and ``since_at`` is when the condition started, which is what a row
 * without a deadline shows.
 */
export const zPendingItemResponse = z.object({
    code: z.string(),
    queue: zPendingQueue,
    domain: zPendingDomain,
    tone: zPendingTone,
    urgency: zPendingUrgency,
    object: zPendingItemObjectResponse,
    secondary: z.string().nullable(),
    due_at: z.iso.datetime().nullable(),
    since_at: z.iso.datetime().nullable(),
    amount: z.string().nullable(),
    count: z.int().nullable(),
    context: zPendingItemContextResponse,
    assignee: zPendingItemAssigneeResponse.nullable(),
    snooze_expires_at: z.iso.datetime().nullable()
});

/**
 * FilteredPaginatedResponse[PendingItemResponse]
 */
export const zFilteredPaginatedResponsePendingItemResponse = z.object({
    items: z.array(zPendingItemResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int(),
    total_unfiltered_count: z.int()
});

/**
 * ProjectCreateRequest
 *
 * Request model for creating a project
 */
export const zProjectCreateRequest = z.object({
    title: z.string(),
    tax_incentive_type: zTaxIncentiveType,
    subtype: zProjectSubtype,
    fiscal_quota_uuid: z.uuid(),
    description: z.string().nullish(),
    fundraising_date: z.iso.date().nullish(),
    production_start_date: z.iso.date().nullish(),
    production_end_date: z.iso.date().nullish(),
    fiscal_year: z.int().nullish(),
    city: z.string().nullish()
});

/**
 * ProjectDetailResponse
 *
 * Extended response model for project details including investors information.
 * Inherits all fields from ProjectResponse and adds investor data plus
 * financial enrichment sourced from the linked fiscal quota.
 */
export const zProjectDetailResponse = z.object({
    uuid: z.uuid(),
    title: z.string(),
    description: z.string().nullable(),
    tax_incentive_type: zTaxIncentiveType,
    subtype: zProjectSubtype,
    fundraising_date: z.iso.date().nullable(),
    production_start_date: z.iso.date().nullable(),
    production_end_date: z.iso.date().nullable(),
    fiscal_year: z.int().nullable(),
    city: z.string().nullable(),
    status: zProjectStatus,
    state: zProjectState.optional().default('running'),
    is_ready_for_investment: z.boolean(),
    has_poster: z.boolean(),
    posters_count: z.int().optional().default(0),
    cover_url: z.string().nullish(),
    beneficiary: zBeneficiarySummary,
    fiscal_quota_uuid: z.uuid().nullish(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    investors: z.array(zInvestorProjectSummary).optional().default([]),
    expected_profitability_percentage: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullish(),
    max_investment_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullish()
});

/**
 * ProjectResponse
 *
 * Response model for project data
 */
export const zProjectResponse = z.object({
    uuid: z.uuid(),
    title: z.string(),
    description: z.string().nullable(),
    tax_incentive_type: zTaxIncentiveType,
    subtype: zProjectSubtype,
    fundraising_date: z.iso.date().nullable(),
    production_start_date: z.iso.date().nullable(),
    production_end_date: z.iso.date().nullable(),
    fiscal_year: z.int().nullable(),
    city: z.string().nullable(),
    status: zProjectStatus,
    state: zProjectState.optional().default('running'),
    is_ready_for_investment: z.boolean(),
    has_poster: z.boolean(),
    posters_count: z.int().optional().default(0),
    cover_url: z.string().nullish(),
    beneficiary: zBeneficiarySummary,
    fiscal_quota_uuid: z.uuid().nullish(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * FilteredPaginatedResponse[ProjectResponse]
 */
export const zFilteredPaginatedResponseProjectResponse = z.object({
    items: z.array(zProjectResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int(),
    total_unfiltered_count: z.int()
});

/**
 * ListResponse[ProjectResponse]
 */
export const zListResponseProjectResponse = z.object({
    items: z.array(zProjectResponse),
    total_count: z.int()
});

/**
 * ProjectBulkCreateResponse
 *
 * Returns every created project so the client can refresh its caches
 * with the new entities without a follow-up GET.
 */
export const zProjectBulkCreateResponse = z.object({
    projects: z.array(zProjectResponse)
});

/**
 * ProjectUpdateRequest
 *
 * Request model for updating a project
 */
export const zProjectUpdateRequest = z.object({
    title: z.string().nullish(),
    description: z.string().nullish(),
    tax_incentive_type: zTaxIncentiveType.nullish(),
    subtype: zProjectSubtype.nullish(),
    status: zProjectStatus.nullish(),
    state: zProjectState.nullish(),
    fundraising_date: z.iso.date().nullish(),
    production_start_date: z.iso.date().nullish(),
    production_end_date: z.iso.date().nullish(),
    fiscal_year: z.int().nullish(),
    city: z.string().nullish(),
    fiscal_quota_uuid: z.uuid().nullish()
});

/**
 * TemplateAggregateValuesResponse
 *
 * The requested ``field:function`` pairs, and only those.
 *
 * A distribution is a count per value; the status counts are integers and
 * ``pct_active`` is a decimal string rounded to 2 decimals, null over an
 * empty set.
 */
export const zTemplateAggregateValuesResponse = z.object({
    'type:distribution': z.record(z.string(), z.int()).nullish(),
    'category:distribution': z.record(z.string(), z.int()).nullish(),
    'language:distribution': z.record(z.string(), z.int()).nullish(),
    'industry:distribution': z.record(z.string(), z.int()).nullish(),
    'origin:distribution': z.record(z.string(), z.int()).nullish(),
    'status:active': z.int().nullish(),
    'status:inactive': z.int().nullish(),
    'status:archived': z.int().nullish(),
    'status:pct_active': z.string().nullish()
});

/**
 * TemplateAggregatesResponse
 *
 * Footer aggregates of the templates list, computed over the whole filtered set.
 */
export const zTemplateAggregatesResponse = z.object({
    aggregates: zTemplateAggregateValuesResponse
});

/**
 * TemplateCategory
 *
 * Template categories for organizing templates in the UI
 */
export const zTemplateCategory = z.enum([
    'legal',
    'financial',
    'administrative',
    'commercial',
    'technical'
]);

/**
 * TemplateCompatibilityResponse
 *
 * Computed compatibility of a template with a document-generating act.
 *
 * ``unknown_keys`` — referenced keys missing from the catalog entirely
 * (stale template after a catalog change). ``unresolvable_keys`` —
 * catalogued keys the act's context cannot produce. ``missing_annexes``
 * — declared annex variants whose backing document does not exist yet
 * (only evaluated when the caller asks for annex checks); each has a
 * localizable code in ``missing_annex_codes``.
 */
export const zTemplateCompatibilityResponse = z.object({
    compatible: z.boolean(),
    unknown_keys: z.array(z.string()),
    unresolvable_keys: z.array(z.string()),
    required_annexes: z.array(z.string()),
    unsupported_annexes: z.array(z.string()),
    missing_annexes: z.array(z.string()),
    missing_annex_codes: z.array(z.string())
});

/**
 * TemplateImagePreviewRequest
 *
 * Payload for resolving an ImageBlock src back to a renderable URL.
 */
export const zTemplateImagePreviewRequest = z.object({
    src: z.string()
});

/**
 * TemplateImagePreviewResponse
 *
 * Signed URL the editor can drop into an <img> tag.
 */
export const zTemplateImagePreviewResponse = z.object({
    signed_url: z.string()
});

/**
 * TemplateImageUploadRequest
 *
 * Upload payload for an ImageBlock asset (data URI base64).
 *
 * Mirrors ``OrganizationUpdateRequest.logo`` — the frontend posts a
 * ``data:image/<ext>;base64,...`` string that the storage service parses,
 * validates and persists to GCS.
 */
export const zTemplateImageUploadRequest = z.object({
    data_uri: z.string()
});

/**
 * TemplateImageUploadResponse
 *
 * Response returned after a successful template image upload.
 */
export const zTemplateImageUploadResponse = z.object({
    src: z.string(),
    signed_url: z.string()
});

/**
 * TemplateIndustry
 *
 * Template industry categories for filtering
 */
export const zTemplateIndustry = z.enum([
    'music',
    'audiovisual',
    'general'
]);

/**
 * TemplateLanguage
 *
 * Template language support
 */
export const zTemplateLanguage = z.enum([
    'es',
    'en',
    'fr',
    'de'
]);

/**
 * TemplateOrigin
 *
 * Where a template comes from: the platform catalogue, or the organization.
 */
export const zTemplateOrigin = z.enum(['system', 'own']);

/**
 * TemplateType
 *
 * Template type enum for templates domain
 */
export const zTemplateType = z.enum([
    'contract',
    'nda',
    'proposal',
    'invoice',
    'agreement',
    'report',
    'certificate',
    'letter',
    'reservation_agreement'
]);

/**
 * TemplateCreateRequest
 *
 * Request schema for creating a new template.
 */
export const zTemplateCreateRequest = z.object({
    name: z.string(),
    description: z.string().nullish(),
    type: zTemplateType,
    category: zTemplateCategory,
    language: zTemplateLanguage.optional().default('es'),
    industry: zTemplateIndustry.optional().default('general'),
    settings: z.record(z.string(), z.unknown()).optional(),
    content: z.array(z.record(z.string(), z.unknown())).nullish()
});

/**
 * TemplateDetailResponse
 *
 * Full response with document content.
 */
export const zTemplateDetailResponse = z.object({
    uuid: z.uuid(),
    name: z.string(),
    description: z.string().nullable(),
    type: zTemplateType,
    category: zTemplateCategory,
    language: zTemplateLanguage,
    industry: zTemplateIndustry,
    is_system_template: z.boolean(),
    status: zEntityStatus,
    is_active: z.boolean(),
    version: z.string(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime().nullable(),
    settings: z.record(z.string(), z.unknown()),
    content: z.array(z.record(z.string(), z.unknown())).nullable()
});

/**
 * TemplateSummaryResponse
 *
 * Summary response for template list items.
 */
export const zTemplateSummaryResponse = z.object({
    uuid: z.uuid(),
    name: z.string(),
    description: z.string().nullable(),
    type: zTemplateType,
    category: zTemplateCategory,
    language: zTemplateLanguage,
    industry: zTemplateIndustry,
    is_system_template: z.boolean(),
    status: zEntityStatus,
    is_active: z.boolean(),
    version: z.string(),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime().nullable()
});

/**
 * FilteredPaginatedResponse[TemplateSummaryResponse]
 */
export const zFilteredPaginatedResponseTemplateSummaryResponse = z.object({
    items: z.array(zTemplateSummaryResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int(),
    total_unfiltered_count: z.int()
});

/**
 * TemplateUpdateRequest
 *
 * Request schema for updating a template (partial).
 */
export const zTemplateUpdateRequest = z.object({
    name: z.string().nullish(),
    description: z.string().nullish(),
    type: zTemplateType.nullish(),
    category: zTemplateCategory.nullish(),
    language: zTemplateLanguage.nullish(),
    industry: zTemplateIndustry.nullish(),
    settings: z.record(z.string(), z.unknown()).nullish(),
    content: z.array(z.record(z.string(), z.unknown())).nullish(),
    status: zEntityStatus.nullish()
});

/**
 * BulkUpdateTemplatesRequest
 *
 * The same PATCH applied to each template, e.g. ``{status: archived}``.
 */
export const zBulkUpdateTemplatesRequest = z.object({
    template_uuids: z.array(z.uuid()).min(1).max(200),
    data: zTemplateUpdateRequest
});

/**
 * UploadItem
 *
 * A single file's upload details within a session.
 *
 * `upload_url` is None for deferred sessions — the client requests it
 * later through the signed-urls endpoint.
 */
export const zUploadItem = z.object({
    classification_uuid: z.uuid(),
    filename: z.string(),
    upload_url: z.string().nullable(),
    gcs_path: z.string(),
    content_type: z.string()
});

/**
 * CreateUploadSessionResponse
 *
 * Response after creating an upload session.
 */
export const zCreateUploadSessionResponse = z.object({
    session_id: z.uuid(),
    expires_at: z.iso.datetime(),
    uploads: z.array(zUploadItem)
});

/**
 * UploadSessionStatus
 *
 * Status lifecycle for an upload session.
 */
export const zUploadSessionStatus = z.enum([
    'open',
    'processing',
    'completed',
    'partial',
    'expired'
]);

/**
 * UploadSessionStatusResponse
 *
 * Response for checking session progress.
 */
export const zUploadSessionStatusResponse = z.object({
    session_id: z.uuid(),
    status: zUploadSessionStatus,
    expected_count: z.int(),
    received_count: z.int(),
    completed_count: z.int(),
    failed_count: z.int(),
    needs_review_count: z.int(),
    created_at: z.iso.datetime(),
    expires_at: z.iso.datetime(),
    completed_at: z.iso.datetime().nullable()
});

/**
 * UsageMetricResponse
 *
 * One measured quantity in a domain usage report.
 */
export const zUsageMetricResponse = z.object({
    key: z.string(),
    label: z.string(),
    value: z.int(),
    unit: zQuotaUnit,
    cost_usd: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullish()
});

/**
 * DomainUsageReportResponse
 *
 * A domain's usage over a period for the admin panel.
 */
export const zDomainUsageReportResponse = z.object({
    domain: z.string(),
    metrics: z.array(zUsageMetricResponse),
    status_breakdown: z.record(z.string(), z.int()).nullish(),
    total_cost_usd: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullish()
});

/**
 * UserCreateRequest
 *
 * Request model for creating a new user
 */
export const zUserCreateRequest = z.object({
    email: z.email(),
    password: z.string().min(8),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    language: z.string().optional().default('en'),
    profile_picture: z.string().nullish()
});

/**
 * OrganizationSetupData
 *
 * Completion data for CREATE_ORG invitations - creates user and completes organization
 */
export const zOrganizationSetupData = z.object({
    type: z.literal('organization_setup'),
    user: zUserCreateRequest,
    org: zOrganizationUpdateRequest
});

/**
 * UserInvitationResponse
 *
 * Response model for user invitations with organization details
 */
export const zUserInvitationResponse = z.object({
    uuid: z.uuid(),
    organization: zOrganizationSummary,
    role: zOrganizationRole,
    status: zInvitationStatus,
    invitation_type: zInvitationType,
    expires_at: z.iso.datetime(),
    accepted_at: z.iso.datetime().nullish(),
    created_at: z.iso.datetime()
});

/**
 * ListResponse[UserInvitationResponse]
 */
export const zListResponseUserInvitationResponse = z.object({
    items: z.array(zUserInvitationResponse),
    total_count: z.int()
});

/**
 * UserPreferencesResponse
 *
 * Response model for user preferences
 */
export const zUserPreferencesResponse = z.object({
    language: z.string(),
    timezone: z.string(),
    prefers_dark_mode: z.boolean(),
    prefers_compact_view: z.boolean(),
    notifications_enabled: z.boolean(),
    notify_via_email: z.boolean(),
    notify_via_app: z.boolean()
});

/**
 * UserPreferencesUpdate
 *
 * Schema for user preferences update
 */
export const zUserPreferencesUpdate = z.object({
    language: z.string().nullish(),
    timezone: z.string().nullish(),
    prefers_dark_mode: z.boolean().nullish(),
    prefers_compact_view: z.boolean().nullish(),
    notifications_enabled: z.boolean().nullish(),
    notify_via_email: z.boolean().nullish(),
    notify_via_app: z.boolean().nullish()
});

/**
 * UserRegistrationData
 *
 * Completion data for JOIN_AS_NEW_USER invitations - creates user and membership.
 * For role=INVESTOR, the investor link is created automatically using the
 * investor_uuid embedded in the signed invitation token.
 */
export const zUserRegistrationData = z.object({
    type: z.literal('user_registration'),
    user: zUserCreateRequest
});

/**
 * InvitationCompletionRequest
 *
 * Request schema for completing an invitation
 */
export const zInvitationCompletionRequest = z.object({
    data: z.discriminatedUnion('type', [
        zOrganizationSetupData,
        zUserRegistrationData,
        zMembershipJoinData,
        zInvestorHubRegistrationData
    ])
});

/**
 * UserResponse
 *
 * Response model for user data
 */
export const zUserResponse = z.object({
    uuid: z.uuid(),
    email: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    profile_picture_signed_url: z.string().nullish(),
    is_active: z.boolean(),
    is_verified: z.boolean(),
    is_platform_admin: z.boolean(),
    created_at: z.iso.datetime().nullish(),
    updated_at: z.iso.datetime().nullish(),
    last_login_at: z.iso.datetime().nullish(),
    full_name: z.string(),
    preferences: zUserPreferencesResponse.nullish(),
    pending_email: z.string().nullish(),
    pending_email_requested_at: z.iso.datetime().nullish()
});

/**
 * InvitationCompletionResponse
 *
 * Response schema for invitation completion
 */
export const zInvitationCompletionResponse = z.object({
    auth: zAuthTokenResponse,
    user: zUserResponse,
    organization: zOrganizationSummary
});

/**
 * UserSummary
 *
 * Response model for user summary data
 */
export const zUserSummary = z.object({
    uuid: z.uuid(),
    email: z.string(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    full_name: z.string(),
    profile_picture_signed_url: z.string().nullish(),
    last_login_at: z.iso.datetime().nullish()
});

/**
 * InvestmentEventResponse
 *
 * Response model for investment event data
 */
export const zInvestmentEventResponse = z.object({
    uuid: z.uuid(),
    event_type: zInvestmentEventType,
    occurred_at: z.iso.datetime(),
    user: zUserSummary.nullish(),
    metadata: z.record(z.string(), z.unknown()).nullish(),
    created_at: z.iso.datetime()
});

/**
 * MembershipResponse
 *
 * Response model for membership data
 */
export const zMembershipResponse = z.object({
    uuid: z.uuid(),
    user: zUserSummary,
    organization: zOrganizationSummary,
    role: zOrganizationRole,
    is_default: z.boolean(),
    is_active: z.boolean(),
    joined_at: z.iso.datetime()
});

/**
 * ListResponse[MembershipResponse]
 */
export const zListResponseMembershipResponse = z.object({
    items: z.array(zMembershipResponse),
    total_count: z.int()
});

/**
 * OrganizationInvestmentEventResponse
 *
 * One line of ``GET /investments/events`` — the team's activity feed.
 *
 * The event, plus the reference of the investment it is about and its two
 * parties, so a line needs no second call. The backend names the records; the
 * front builds the link.
 */
export const zOrganizationInvestmentEventResponse = z.object({
    event: zInvestmentEventResponse,
    investment_uuid: z.uuid(),
    investment_reference: z.string(),
    investor_uuid: z.uuid().nullable(),
    investor_name: z.string().nullable(),
    beneficiary_uuid: z.uuid().nullable(),
    beneficiary_name: z.string().nullable()
});

/**
 * PaginatedResponse[OrganizationInvestmentEventResponse]
 */
export const zPaginatedResponseOrganizationInvestmentEventResponse = z.object({
    items: z.array(zOrganizationInvestmentEventResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int()
});

/**
 * UserUpdate
 *
 * Schema for user profile update
 */
export const zUserUpdate = z.object({
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    profile_picture: z.string().nullish(),
    preferences: zUserPreferencesUpdate.nullish()
});

/**
 * VoidContractRequest
 *
 * Request model for voiding contract
 */
export const zVoidContractRequest = z.object({
    document_uuid: z.string()
});

/**
 * VoidContractResponse
 *
 * Response model for void contract action
 */
export const zVoidContractResponse = z.object({
    document_voided: z.boolean(),
    signing_cancelled: z.boolean(),
    voided_at: z.iso.datetime()
});

/**
 * WorkerBreakdownResponse
 */
export const zWorkerBreakdownResponse = z.object({
    tax_id: z.string(),
    name: z.string(),
    position: z.string().nullable(),
    total_earnings: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    months: z.int()
});

/**
 * WorkforceAnalyticsResponse
 */
export const zWorkforceAnalyticsResponse = z.object({
    total_payroll: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/),
    worker_count: z.int(),
    workers: z.array(zWorkerBreakdownResponse)
});

/**
 * CulturalActivity
 */
export const zAppDomainBeneficiariesEnumsCulturalActivity = z.enum([
    'film',
    'documentary',
    'series',
    'theatre',
    'dance',
    'music_festival',
    'performing_arts',
    'audiovisual_production'
]);

/**
 * BeneficiaryAggregateValuesResponse
 *
 * Requested footer aggregates keyed ``field:function``; only the requested keys are present.
 *
 * Averages and percentages are rounded to 2 decimals; a statistic over an empty
 * set is null. ``volume`` is in euros; ``quota_occupied`` and ``status:pct_active``
 * are 0-100. Text ``empty`` counts null or blank values and ``unique`` ignores them.
 * ``sector:distribution`` counts one beneficiary once in each of its activities.
 */
export const zBeneficiaryAggregateValuesResponse = z.object({
    'total_projects_count:sum': z.int().nullish(),
    'total_projects_count:avg': z.string().nullish(),
    'total_projects_count:min': z.int().nullish(),
    'total_projects_count:max': z.int().nullish(),
    'volume:sum': z.string().nullish(),
    'volume:avg': z.string().nullish(),
    'volume:min': z.string().nullish(),
    'volume:max': z.string().nullish(),
    'quota_occupied:avg': z.string().nullish(),
    'quota_occupied:min': z.string().nullish(),
    'quota_occupied:max': z.string().nullish(),
    'primary_contact:filled': z.int().nullish(),
    'primary_contact:empty': z.int().nullish(),
    'primary_contact:unique': z.int().nullish(),
    'city:filled': z.int().nullish(),
    'city:empty': z.int().nullish(),
    'city:unique': z.int().nullish(),
    'email:filled': z.int().nullish(),
    'email:empty': z.int().nullish(),
    'email:unique': z.int().nullish(),
    'sector:distribution': z.record(z.string(), z.int()).nullish(),
    'tag:distribution': z.record(z.string(), z.int()).nullish(),
    'status:active': z.int().nullish(),
    'status:inactive': z.int().nullish(),
    'status:archived': z.int().nullish(),
    'status:pct_active': z.string().nullish()
});

/**
 * BeneficiaryAggregatesResponse
 *
 * Footer aggregates of the beneficiaries list, computed over the whole filtered set.
 */
export const zBeneficiaryAggregatesResponse = z.object({
    aggregates: zBeneficiaryAggregateValuesResponse
});

/**
 * BeneficiaryCreateRequest
 *
 * Request model for creating a beneficiary
 */
export const zBeneficiaryCreateRequest = z.object({
    name: z.string(),
    tax_id: z.string(),
    company_type: zCompanyType,
    main_activities: z.array(zAppDomainBeneficiariesEnumsCulturalActivity),
    constitution_date: z.iso.date().nullish(),
    address: z.string().nullish(),
    city: z.string().nullish(),
    state: z.string().nullish(),
    postal_code: z.string().nullish(),
    country: z.string().nullish(),
    phone: z.string().nullish(),
    email: z.string().nullish(),
    website: z.string().nullish(),
    business_purpose: z.string().max(2000).nullish(),
    cnae_code: z.string().max(10).nullish(),
    last_year_revenue: z.union([
        z.number().gte(0),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/)
    ]).nullish(),
    employee_count: z.int().gte(0).lte(1000000).nullish(),
    incentive_type: zTaxIncentiveType.nullish(),
    legal_representatives: z.array(zBeneficiaryLegalRepresentativeCreateRequest).optional(),
    bank_account: zBeneficiaryBankAccountCreateRequest.nullish()
});

/**
 * BeneficiaryResponse
 *
 * Response model for beneficiary data
 */
export const zBeneficiaryResponse = z.object({
    uuid: z.uuid(),
    name: z.string(),
    tax_id: z.string(),
    company_type: zCompanyType,
    main_activities: z.array(zAppDomainBeneficiariesEnumsCulturalActivity),
    status: zEntityStatus,
    constitution_date: z.iso.date().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    state: z.string().nullable(),
    postal_code: z.string().nullable(),
    country: z.string().nullable(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    website: z.string().nullable(),
    notes: z.string().nullable(),
    business_purpose: z.string().nullable(),
    cnae_code: z.string().nullable(),
    last_year_revenue: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).nullable(),
    employee_count: z.int().nullable(),
    incentive_type: zTaxIncentiveType.nullable(),
    signature_regime: zSignatureRegime.default('sole'),
    tags: z.array(zTagRefResponse),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime()
});

/**
 * BeneficiaryUpdateRequest
 *
 * Request model for updating a beneficiary
 */
export const zBeneficiaryUpdateRequest = z.object({
    name: z.string().nullish(),
    tax_id: z.string().nullish(),
    company_type: zCompanyType.nullish(),
    main_activities: z.array(zAppDomainBeneficiariesEnumsCulturalActivity).nullish(),
    status: zEntityStatus.nullish(),
    constitution_date: z.iso.date().nullish(),
    address: z.string().nullish(),
    city: z.string().nullish(),
    state: z.string().nullish(),
    postal_code: z.string().nullish(),
    country: z.string().nullish(),
    phone: z.string().nullish(),
    email: z.string().nullish(),
    website: z.string().nullish(),
    business_purpose: z.string().max(2000).nullish(),
    cnae_code: z.string().max(10).nullish(),
    last_year_revenue: z.union([
        z.number().gte(0),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/)
    ]).nullish(),
    employee_count: z.int().gte(0).lte(1000000).nullish(),
    incentive_type: zTaxIncentiveType.nullish(),
    signature_regime: zSignatureRegime.nullish()
});

/**
 * BeneficiaryWithDetailsResponse
 *
 * Response model for beneficiary with all nested details
 */
export const zBeneficiaryWithDetailsResponse = z.object({
    beneficiary: zBeneficiaryResponse,
    legal_representatives: z.array(zBeneficiaryLegalRepresentativeResponse),
    bank_accounts: z.array(zBeneficiaryBankAccountResponse),
    fiscal_quotas: z.array(zFiscalQuotaResponse),
    is_complete: z.boolean()
});

/**
 * BulkUpdateBeneficiariesRequest
 *
 * The same PATCH applied to each beneficiary, e.g. ``{status: inactive}``.
 */
export const zBulkUpdateBeneficiariesRequest = z.object({
    beneficiary_uuids: z.array(z.uuid()).min(1).max(200),
    data: zBeneficiaryUpdateRequest
});

/**
 * DocumentType
 *
 * Types of documents the classifier can process.
 */
export const zAppDomainClassificationsEnumsDocumentType = z.enum([
    'factura',
    'nomina',
    'presupuesto',
    'proforma',
    'albaran',
    'contrato',
    'comprobante_pago',
    'certificado',
    'rider',
    'desconocido'
]);

/**
 * ClassificationResponse
 *
 * Response for a single document classification.
 */
export const zClassificationResponse = z.object({
    uuid: z.uuid(),
    status: zClassificationStatus,
    document_type: zAppDomainClassificationsEnumsDocumentType.nullable(),
    source_filename: z.string(),
    parent_document_uuid: z.uuid().nullable(),
    parent_document_name: z.string().nullable(),
    extracted_fields: z.union([
        zInvoiceFields,
        zPayrollFields,
        zContractFields,
        zPaymentFields,
        zCertificateFields
    ]).nullable(),
    classification_result: zClassificationResultData.nullable(),
    expense_type: z.string().nullable(),
    expense_subtype: z.string().nullable(),
    fiscal_category: z.string().nullable(),
    eligible: z.boolean().nullable(),
    confidence: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    total_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    deductible_base_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    currency: z.string(),
    document_date: z.iso.date().nullable(),
    requires_review: z.boolean(),
    review_reasons: z.array(zReviewReason),
    review_flags: z.array(zReviewFlagResponse),
    disposition: zClassificationDisposition,
    review_action: zReviewAction.nullable(),
    reviewed_by_id: z.int().nullable(),
    reviewed_at: z.iso.datetime().nullable(),
    review_notes: z.string().nullable(),
    beneficiary_comment: z.string().nullable(),
    corrected_fields: z.record(z.string(), z.unknown()).nullable(),
    field_locks: z.array(zFieldLockResponse),
    processing_time_ms: z.number().nullable(),
    tokens_used: z.int(),
    created_at: z.iso.datetime(),
    processed_at: z.iso.datetime().nullable(),
    uploaded_by_user: zUserSummary.nullable(),
    reviewed_by_user: zUserSummary.nullable(),
    eligibility_decision: zEligibilityDecisionResponse.nullable()
});

/**
 * ClassificationSelectionRequest
 *
 * Every document of one quota that matches the audit list's filters.
 *
 * The list pages by 50, so a header «select all» can only name the rows it
 * has loaded; this payload names the whole match instead, and the server
 * resolves it in the request that acts on it.
 */
export const zClassificationSelectionRequest = z.object({
    fiscal_quota_uuid: z.uuid(),
    status: z.array(zClassificationStatus).nullish(),
    document_type: z.array(zAppDomainClassificationsEnumsDocumentType).nullish(),
    eligibility: zEligibility.nullish(),
    search: z.string().max(200).nullish()
});

/**
 * DocumentTypeCountResponse
 */
export const zDocumentTypeCountResponse = z.object({
    document_type: zAppDomainClassificationsEnumsDocumentType,
    count: z.int(),
    total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
});

/**
 * DocumentInventoryResponse
 */
export const zDocumentInventoryResponse = z.object({
    total_count: z.int(),
    by_type: z.array(zDocumentTypeCountResponse)
});

/**
 * ClassificationSummaryResponse
 */
export const zClassificationSummaryResponse = z.object({
    audit: zAuditResponse.nullable(),
    financials: zFinancialMetricsResponse,
    document_inventory: zDocumentInventoryResponse,
    conciliation: zConciliationMetricsResponse,
    monthly: z.array(zMonthlyBreakdownResponse),
    categories: z.array(zCategoryBreakdownResponse),
    pipeline_status: zPipelineStatusBreakdownResponse
});

/**
 * FilteredPaginatedResponse[ClassificationResponse]
 */
export const zFilteredPaginatedResponseClassificationResponse = z.object({
    items: z.array(zClassificationResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int(),
    total_unfiltered_count: z.int()
});

/**
 * ResolveDuplicateResponse
 *
 * Response from resolve-duplicate endpoint.
 */
export const zResolveDuplicateResponse = z.object({
    kept: zClassificationResponse,
    discarded: zClassificationResponse
});

/**
 * UpdateClassificationRequest
 *
 * Request to update classification data (extracted fields, categorization, qualification).
 */
export const zUpdateClassificationRequest = z.object({
    document_type: zAppDomainClassificationsEnumsDocumentType.nullish(),
    extracted_fields: z.record(z.string(), z.unknown()).nullish(),
    categorization: z.record(z.string(), z.unknown()).nullish(),
    qualification: z.record(z.string(), z.unknown()).nullish(),
    notes: z.string().max(2000).nullish(),
    beneficiary_comment: z.string().max(2000).nullish()
});

/**
 * DocumentType
 *
 * Unified document types enum - combines all document types across entity types.
 * Used for the unified documents table.
 */
export const zAppDomainDocumentsEnumsDocumentType = z.enum([
    'investment_proposal',
    'reservation_contract',
    'financing_contract',
    'communication_contract',
    'payment_receipt',
    'tax_submission_certificate',
    'national_id',
    'passport',
    'residence_permit',
    'tax_certificate',
    'income_statement',
    'wealth_declaration',
    'company_registration',
    'articles_of_association',
    'power_of_attorney',
    'bank_account_certificate',
    'iban_certificate',
    'kyc_form',
    'proof_of_address',
    'other',
    'tax_id_certificate',
    'census_certificate',
    'icaa_certificate',
    'inaem_certificate',
    'invoice',
    'payroll',
    'poster',
    'expense_audit'
]);

/**
 * AllowedTransitionResponse
 *
 * One destination the investment may move to, and the documents it still lacks.
 */
export const zAllowedTransitionResponse = z.object({
    state: zInvestmentState,
    missing_documents: z.array(zAppDomainDocumentsEnumsDocumentType).optional()
});

/**
 * Body_upload_beneficiary_document
 */
export const zBodyUploadBeneficiaryDocument = z.object({
    document: z.string(),
    document_type: zAppDomainDocumentsEnumsDocumentType,
    entity_type: zEntityType,
    entity_uuid: z.uuid(),
    title: z.string().nullish(),
    fiscal_quota_uuid: z.uuid().nullish(),
    share_with_investors: z.boolean().optional().default(false)
});

/**
 * Body_upload_investor_document
 */
export const zBodyUploadInvestorDocument = z.object({
    file: z.string(),
    doc_type: zAppDomainDocumentsEnumsDocumentType,
    title: z.string().nullish()
});

/**
 * Body_upload_organization_document
 */
export const zBodyUploadOrganizationDocument = z.object({
    document: z.string(),
    document_type: zAppDomainDocumentsEnumsDocumentType,
    title: z.string().nullish()
});

/**
 * Body_upload_project_document
 */
export const zBodyUploadProjectDocument = z.object({
    document: z.string(),
    document_type: zAppDomainDocumentsEnumsDocumentType,
    title: z.string().nullish()
});

/**
 * DocumentBlock
 *
 * The file primitive — shared across all document responses.
 */
export const zDocumentBlock = z.object({
    uuid: z.uuid(),
    doc_type: zAppDomainDocumentsEnumsDocumentType.nullish(),
    status: zDocumentStatus,
    name: z.string(),
    title: z.string().nullish(),
    size_bytes: z.int(),
    content_type: z.string(),
    fiscal_quota_uuid: z.uuid().nullish(),
    fiscal_quota_year: z.int().nullish(),
    shared_with_investors: z.boolean().optional().default(false),
    uploaded_at: z.iso.datetime().nullish(),
    uploaded_by_uuid: z.uuid().nullish(),
    uploaded_by: zDocumentUploader.nullish()
});

/**
 * ContractDetailsResponse
 *
 * Detailed contract response — composed from shared blocks + investment context.
 */
export const zContractDetailsResponse = z.object({
    document: zDocumentBlock,
    signature: zSignatureBlock,
    investment: zContractInvestmentContext,
    contract_type: zContractType,
    voided_at: z.iso.datetime().nullish(),
    signature_progress: zSignatureProgress
});

/**
 * DocumentUpdateRequest
 *
 * Request body for PATCH /{entity}/{id}/documents/{doc_id}.
 *
 * Fields follow a "send only what you want to change" contract: the
 * endpoint relies on ``model_fields_set`` (via :meth:`to_update_dict`)
 * to tell apart "not provided" from "explicitly set to null". So:
 *
 * - omit ``fiscal_quota_uuid`` → quota link stays as is.
 * - ``fiscal_quota_uuid=null`` → clear the link (move to "General").
 * - ``share_with_investors=false`` while currently shared → revoke the
 * grant for ``BENEFICIARY_INVESTORS``.
 * - ``share_with_investors=true`` while unscoped → rejected; sharing
 * requires the doc to be linked to a quota.
 */
export const zDocumentUpdateRequest = z.object({
    title: z.string().nullish(),
    description: z.string().nullish(),
    fiscal_quota_uuid: z.uuid().nullish(),
    share_with_investors: z.boolean().nullish(),
    doc_type: zAppDomainDocumentsEnumsDocumentType.nullish()
});

/**
 * DocumentWithReviewResponse
 *
 * Document with review — used for beneficiary, investor, org, and project documents.
 */
export const zDocumentWithReviewResponse = z.object({
    document: zDocumentBlock,
    review: zReviewBlock
});

/**
 * BankAccountDocumentGroupResponse
 *
 * Documents attached to a single bank account of a beneficiary.
 */
export const zBankAccountDocumentGroupResponse = z.object({
    bank_account_uuid: z.uuid(),
    bank_name: z.string().nullish(),
    iban_last4: z.string().nullish(),
    documents: z.array(zDocumentWithReviewResponse)
});

/**
 * FiscalQuotaDocumentGroupResponse
 *
 * Beneficiary-owned documents grouped under a single fiscal quota.
 *
 * The unscoped group (``fiscal_quota_uuid=None``) carries documents not
 * linked to any quota and is rendered as the "General" section. For
 * quota groups, the frontend builds the header label from
 * ``project_title`` (when present) and ``fiscal_year`` following the
 * same rule as ``FiscalQuotaCard``:
 *
 * - music quota (``project_title=None``): ``"Cuota {year}"``
 * - audiovisual quota: ``"{project_title} · {year}"``
 *
 * ``total`` is the count across all pages; ``documents`` only carries
 * the first page (up to ``per_group_limit`` items requested by the API).
 */
export const zFiscalQuotaDocumentGroupResponse = z.object({
    fiscal_quota_uuid: z.uuid().nullish(),
    fiscal_year: z.int().nullish(),
    project_uuid: z.uuid().nullish(),
    project_title: z.string().nullish(),
    total: z.int(),
    documents: z.array(zDocumentWithReviewResponse)
});

/**
 * BeneficiaryDocumentsByFiscalQuotaResponse
 *
 * Beneficiary-owned documents grouped by fiscal quota.
 *
 * The top-level ``incentive_type`` is propagated from the beneficiary so
 * the frontend can pick the right icon + header naming format without an
 * extra round-trip. Groups are ordered: unscoped first, then quotas DESC
 * by ``fiscal_year``.
 */
export const zBeneficiaryDocumentsByFiscalQuotaResponse = z.object({
    beneficiary_uuid: z.uuid(),
    incentive_type: zTaxIncentiveType.nullish(),
    groups: z.array(zFiscalQuotaDocumentGroupResponse)
});

/**
 * InvestmentDocumentResponse
 *
 * Investment document — review always present, signature optional (only contracts).
 */
export const zInvestmentDocumentResponse = z.object({
    document: zDocumentBlock,
    review: zReviewBlock,
    signature: zSignatureBlock.nullish()
});

/**
 * InvestmentDocumentGroupResponse
 *
 * Documents of a single investment with the metadata the UI needs to render
 * a section header (reference, state, amount, beneficiary name).
 */
export const zInvestmentDocumentGroupResponse = z.object({
    investment_uuid: z.uuid(),
    investment_reference: z.string(),
    investment_state: zInvestmentState,
    amount: z.string(),
    currency: z.string(),
    beneficiary_name: z.string(),
    fiscal_year: z.int().nullish(),
    documents: z.array(zInvestmentDocumentResponse)
});

/**
 * BeneficiaryPortfolioResponse
 *
 * Aggregated view of every document relevant to a beneficiary.
 *
 * The document set is paginated at the flat level (``total_count`` /
 * ``limit`` / ``offset``); sections are rebuilt from whichever documents
 * fall on the current page.
 */
export const zBeneficiaryPortfolioResponse = z.object({
    beneficiary_uuid: z.uuid(),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int(),
    owned: z.array(zDocumentWithReviewResponse),
    from_bank_accounts: z.array(zBankAccountDocumentGroupResponse),
    from_investments: z.array(zInvestmentDocumentGroupResponse)
});

/**
 * InvestmentResponse
 *
 * Response model for investment summary data
 */
export const zInvestmentResponse = z.object({
    uuid: z.uuid(),
    amount: z.string(),
    return_percentage: z.string(),
    deduction: z.string(),
    currency: z.string(),
    state: zInvestmentState,
    reservation_expires_at: z.iso.datetime().nullish(),
    notes: z.string().nullish(),
    created_at: z.iso.datetime().nullish(),
    updated_at: z.iso.datetime().nullish(),
    allowed_transitions: z.array(zAllowedTransitionResponse).optional(),
    investor: zInvestorSummary,
    beneficiary: zBeneficiarySummary,
    quota: zFiscalQuotaSummary
});

/**
 * InvestmentWithDetailsResponse
 *
 * Response model for investment with all nested details
 */
export const zInvestmentWithDetailsResponse = z.object({
    investment: zInvestmentResponse,
    events: z.array(zInvestmentEventResponse),
    documents: z.array(zInvestmentDocumentResponse),
    binding: zInvestmentBindingResponse
});

/**
 * FilteredPaginatedResponse[InvestmentWithDetailsResponse]
 */
export const zFilteredPaginatedResponseInvestmentWithDetailsResponse = z.object({
    items: z.array(zInvestmentWithDetailsResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int(),
    total_unfiltered_count: z.int()
});

/**
 * InvestmentWriteResponse
 *
 * The investment as ``POST`` and ``PATCH`` wrote it, with the advisory warnings of the write.
 */
export const zInvestmentWriteResponse = z.object({
    uuid: z.uuid(),
    amount: z.string(),
    return_percentage: z.string(),
    deduction: z.string(),
    currency: z.string(),
    state: zInvestmentState,
    reservation_expires_at: z.iso.datetime().nullish(),
    notes: z.string().nullish(),
    created_at: z.iso.datetime().nullish(),
    updated_at: z.iso.datetime().nullish(),
    allowed_transitions: z.array(zAllowedTransitionResponse).optional(),
    investor: zInvestorSummary,
    beneficiary: zBeneficiarySummary,
    quota: zFiscalQuotaSummary,
    warnings: z.array(zInvestmentWarningResponse)
});

/**
 * InvestorPortfolioResponse
 *
 * Aggregated view of every document relevant to an investor.
 *
 * The document set is paginated at the flat level (``total_count`` /
 * ``limit`` / ``offset``); sections are rebuilt from whichever documents
 * fall on the current page.
 */
export const zInvestorPortfolioResponse = z.object({
    investor_uuid: z.uuid(),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int(),
    owned: z.array(zDocumentWithReviewResponse),
    from_investments: z.array(zInvestmentDocumentGroupResponse)
});

/**
 * PaginatedResponse[DocumentWithReviewResponse]
 */
export const zPaginatedResponseDocumentWithReviewResponse = z.object({
    items: z.array(zDocumentWithReviewResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int()
});

/**
 * PaginatedResponse[InvestmentDocumentResponse]
 */
export const zPaginatedResponseInvestmentDocumentResponse = z.object({
    items: z.array(zInvestmentDocumentResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int()
});

/**
 * QuotaReportResponse
 *
 * One report of a fiscal quota (A7).
 *
 * A report is not a new table: it is a document of the quota. ``download_url``
 * is signed on the way out, and is ``null`` when the blob cannot be signed —
 * the row is still listed rather than taking the collection down.
 */
export const zQuotaReportResponse = z.object({
    document_uuid: z.uuid(),
    doc_type: zAppDomainDocumentsEnumsDocumentType,
    name: z.string(),
    title: z.string().nullish(),
    content_type: z.string(),
    size_bytes: z.int(),
    generated_at: z.iso.datetime(),
    generated_by_id: z.int().nullish(),
    download_url: z.string().nullish()
});

/**
 * QuotaReportsResponse
 *
 * ``GET /fiscal-quotas/{uuid}/reports`` — newest first.
 */
export const zQuotaReportsResponse = z.object({
    items: z.array(zQuotaReportResponse),
    total_count: z.int()
});

/**
 * CulturalActivity
 *
 * Cultural activity types for investor interests
 */
export const zAppDomainInvestorsEnumsCulturalActivity = z.enum([
    'film',
    'documentary',
    'series',
    'theatre',
    'dance',
    'music_festival',
    'performing_arts',
    'audiovisual_production'
]);

/**
 * CompanyCreateRequest
 *
 * Request schema for creating a company investor
 */
export const zCompanyCreateRequest = z.object({
    company_name: z.string().max(255),
    tax_id: z.string().max(32),
    legal_rep_first_name: z.string().max(120).nullish(),
    legal_rep_last_name: z.string().max(160).nullish(),
    legal_rep_national_id: z.string().max(32).nullish(),
    website: z.string().max(255).nullish(),
    signature_regime: zSignatureRegime.optional().default('sole'),
    email: z.email().nullish(),
    phone: z.string().max(50).nullish(),
    address: z.string().nullish(),
    city: z.string().max(120).nullish(),
    postal_code: z.string().max(20).nullish(),
    country: z.string().max(2).nullish(),
    communication_language: z.string().max(2).optional().default('es'),
    taxable_income_base: z.string().nullish(),
    potential_investment_amount: z.string().nullish(),
    cultural_interests: z.array(zAppDomainInvestorsEnumsCulturalActivity).optional().default([]),
    legal_representatives: z.array(zInvestorLegalRepresentativeCreateRequest).optional().default([])
});

/**
 * CompanyDetailResponse
 *
 * The company investor's Detail: the record and its ``money`` of the fiscal year, the same as its Row
 */
export const zCompanyDetailResponse = z.object({
    uuid: z.uuid(),
    organization_id: z.int(),
    type: z.literal('company').default('company'),
    status: zEntityStatus,
    company_name: z.string(),
    tax_id: z.string(),
    legal_rep_first_name: z.string().nullable(),
    legal_rep_last_name: z.string().nullable(),
    legal_rep_national_id: z.string().nullable(),
    website: z.string().nullable(),
    signature_regime: zSignatureRegime.default('sole'),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    postal_code: z.string().nullable(),
    country: z.string().nullable(),
    communication_language: z.string(),
    notes: z.string().nullable(),
    taxable_income_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    potential_investment_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    cultural_interests: z.array(zAppDomainInvestorsEnumsCulturalActivity).default([]),
    legal_representatives: z.array(zInvestorLegalRepresentativeResponse).default([]),
    display_name: z.string(),
    legal_representative_name: z.string().nullable(),
    full_address: z.string().nullable(),
    tax_identifier: z.string(),
    hub_status: zHubStatus.default('none'),
    hub_invitation_uuid: z.uuid().nullable(),
    tags: z.array(zTagRefResponse).default([]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime().nullable(),
    money: zInvestorMoneyResponse
});

/**
 * CompanyResponse
 *
 * Response schema for company investor data
 */
export const zCompanyResponse = z.object({
    uuid: z.uuid(),
    organization_id: z.int(),
    type: z.literal('company').default('company'),
    status: zEntityStatus,
    company_name: z.string(),
    tax_id: z.string(),
    legal_rep_first_name: z.string().nullable(),
    legal_rep_last_name: z.string().nullable(),
    legal_rep_national_id: z.string().nullable(),
    website: z.string().nullable(),
    signature_regime: zSignatureRegime.default('sole'),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    postal_code: z.string().nullable(),
    country: z.string().nullable(),
    communication_language: z.string(),
    notes: z.string().nullable(),
    taxable_income_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    potential_investment_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    cultural_interests: z.array(zAppDomainInvestorsEnumsCulturalActivity).default([]),
    legal_representatives: z.array(zInvestorLegalRepresentativeResponse).default([]),
    display_name: z.string(),
    legal_representative_name: z.string().nullable(),
    full_address: z.string().nullable(),
    tax_identifier: z.string(),
    hub_status: zHubStatus.default('none'),
    hub_invitation_uuid: z.uuid().nullable(),
    tags: z.array(zTagRefResponse).default([]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime().nullable()
});

/**
 * CompanyUpdateRequest
 *
 * Request schema for updating a company investor
 */
export const zCompanyUpdateRequest = z.object({
    status: zEntityStatus.nullish(),
    company_name: z.string().max(255).nullish(),
    tax_id: z.string().max(32).nullish(),
    legal_rep_first_name: z.string().max(120).nullish(),
    legal_rep_last_name: z.string().max(160).nullish(),
    legal_rep_national_id: z.string().max(32).nullish(),
    website: z.string().max(255).nullish(),
    signature_regime: zSignatureRegime.nullish(),
    first_name: z.string().nullish(),
    last_name: z.string().nullish(),
    national_id: z.string().nullish(),
    birth_date: z.iso.date().nullish(),
    profession: z.string().nullish(),
    email: z.email().nullish(),
    phone: z.string().max(50).nullish(),
    address: z.string().nullish(),
    city: z.string().max(120).nullish(),
    postal_code: z.string().max(20).nullish(),
    country: z.string().max(2).nullish(),
    communication_language: z.string().max(2).nullish(),
    taxable_income_base: z.string().nullish(),
    potential_investment_amount: z.string().nullish(),
    cultural_interests: z.array(zAppDomainInvestorsEnumsCulturalActivity).nullish()
});

/**
 * IndividualCreateRequest
 *
 * Request schema for creating an individual investor
 */
export const zIndividualCreateRequest = z.object({
    first_name: z.string().max(120),
    last_name: z.string().max(160),
    national_id: z.string().max(32),
    birth_date: z.iso.date().nullish(),
    profession: z.string().max(160).nullish(),
    email: z.email().nullish(),
    phone: z.string().max(50).nullish(),
    address: z.string().nullish(),
    city: z.string().max(120).nullish(),
    postal_code: z.string().max(20).nullish(),
    country: z.string().max(2).nullish(),
    communication_language: z.string().max(2).optional().default('es'),
    taxable_income_base: z.string().nullish(),
    potential_investment_amount: z.string().nullish(),
    cultural_interests: z.array(zAppDomainInvestorsEnumsCulturalActivity).optional().default([])
});

/**
 * IndividualDetailResponse
 *
 * The individual investor's Detail: the record and its ``money`` of the fiscal year, the same as its Row
 */
export const zIndividualDetailResponse = z.object({
    uuid: z.uuid(),
    organization_id: z.int(),
    type: z.literal('individual').default('individual'),
    status: zEntityStatus,
    first_name: z.string(),
    last_name: z.string(),
    national_id: z.string(),
    birth_date: z.iso.date().nullable(),
    profession: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    postal_code: z.string().nullable(),
    country: z.string().nullable(),
    communication_language: z.string(),
    notes: z.string().nullable(),
    taxable_income_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    potential_investment_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    cultural_interests: z.array(zAppDomainInvestorsEnumsCulturalActivity).default([]),
    display_name: z.string(),
    full_name: z.string(),
    full_address: z.string().nullable(),
    tax_identifier: z.string(),
    hub_status: zHubStatus.default('none'),
    hub_invitation_uuid: z.uuid().nullable(),
    tags: z.array(zTagRefResponse).default([]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime().nullable(),
    money: zInvestorMoneyResponse
});

/**
 * IndividualResponse
 *
 * Response schema for individual investor data
 */
export const zIndividualResponse = z.object({
    uuid: z.uuid(),
    organization_id: z.int(),
    type: z.literal('individual').default('individual'),
    status: zEntityStatus,
    first_name: z.string(),
    last_name: z.string(),
    national_id: z.string(),
    birth_date: z.iso.date().nullable(),
    profession: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    postal_code: z.string().nullable(),
    country: z.string().nullable(),
    communication_language: z.string(),
    notes: z.string().nullable(),
    taxable_income_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    potential_investment_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    cultural_interests: z.array(zAppDomainInvestorsEnumsCulturalActivity).default([]),
    display_name: z.string(),
    full_name: z.string(),
    full_address: z.string().nullable(),
    tax_identifier: z.string(),
    hub_status: zHubStatus.default('none'),
    hub_invitation_uuid: z.uuid().nullable(),
    tags: z.array(zTagRefResponse).default([]),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime().nullable()
});

/**
 * IndividualUpdateRequest
 *
 * Request schema for updating an individual investor
 */
export const zIndividualUpdateRequest = z.object({
    status: zEntityStatus.nullish(),
    first_name: z.string().max(120).nullish(),
    last_name: z.string().max(160).nullish(),
    national_id: z.string().max(32).nullish(),
    birth_date: z.iso.date().nullish(),
    profession: z.string().max(160).nullish(),
    company_name: z.string().nullish(),
    tax_id: z.string().nullish(),
    legal_rep_first_name: z.string().nullish(),
    legal_rep_last_name: z.string().nullish(),
    website: z.string().nullish(),
    email: z.email().nullish(),
    phone: z.string().max(50).nullish(),
    address: z.string().nullish(),
    city: z.string().max(120).nullish(),
    postal_code: z.string().max(20).nullish(),
    country: z.string().max(2).nullish(),
    communication_language: z.string().max(2).nullish(),
    taxable_income_base: z.string().nullish(),
    potential_investment_amount: z.string().nullish(),
    cultural_interests: z.array(zAppDomainInvestorsEnumsCulturalActivity).nullish()
});

/**
 * InvestorProfileResponse
 *
 * Investor profile for Hub - public fields visible to investor.
 * Excludes: internal notes, audit fields, organization_id
 */
export const zInvestorProfileResponse = z.object({
    uuid: z.uuid(),
    type: zInvestorType,
    status: zEntityStatus,
    display_name: z.string(),
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
    national_id: z.string().nullable(),
    birth_date: z.iso.date().nullable(),
    profession: z.string().nullable(),
    company_name: z.string().nullable(),
    tax_id: z.string().nullable(),
    legal_rep_first_name: z.string().nullable(),
    legal_rep_last_name: z.string().nullable(),
    legal_rep_national_id: z.string().nullable(),
    website: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    postal_code: z.string().nullable(),
    country: z.string().nullable(),
    communication_language: z.string().default('es'),
    full_address: z.string().nullable(),
    taxable_income_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    potential_investment_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    cultural_interests: z.array(zAppDomainInvestorsEnumsCulturalActivity).default([])
});

/**
 * InvestorProfileUpdateRequest
 *
 * Update request for Hub profile - full editing capabilities.
 * Excludes: type (immutable), status (admin-controlled), notes (internal).
 */
export const zInvestorProfileUpdateRequest = z.object({
    first_name: z.string().max(120).nullish(),
    last_name: z.string().max(120).nullish(),
    national_id: z.string().max(20).nullish(),
    birth_date: z.iso.date().nullish(),
    profession: z.string().max(120).nullish(),
    company_name: z.string().max(255).nullish(),
    tax_id: z.string().max(20).nullish(),
    legal_rep_first_name: z.string().max(120).nullish(),
    legal_rep_last_name: z.string().max(120).nullish(),
    legal_rep_national_id: z.string().max(20).nullish(),
    website: z.string().max(255).nullish(),
    email: z.email().nullish(),
    phone: z.string().max(50).nullish(),
    address: z.string().nullish(),
    city: z.string().max(120).nullish(),
    postal_code: z.string().max(20).nullish(),
    country: z.string().max(2).nullish(),
    communication_language: z.string().max(2).nullish(),
    taxable_income_base: z.string().nullish(),
    potential_investment_amount: z.string().nullish(),
    cultural_interests: z.array(zAppDomainInvestorsEnumsCulturalActivity).nullish()
});

/**
 * InvestorWithInvestmentSummaryResponse
 *
 * The investors list Row: the investor, its investments' count and its ``money`` of the fiscal year
 */
export const zInvestorWithInvestmentSummaryResponse = z.object({
    uuid: z.uuid(),
    type: zInvestorType,
    status: zEntityStatus,
    first_name: z.string().nullable(),
    last_name: z.string().nullable(),
    company_name: z.string().nullable(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    city: z.string().nullable(),
    country: z.string().nullable(),
    taxable_income_base: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    potential_investment_amount: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/).nullable(),
    cultural_interests: z.array(zAppDomainInvestorsEnumsCulturalActivity).default([]),
    number_investments: z.int(),
    money: zInvestorMoneyResponse,
    tags: z.array(zTagRefResponse).default([]),
    display_name: z.string(),
    tax_identifier: z.string().nullable(),
    created_at: z.iso.datetime()
});

/**
 * PaginatedResponse[InvestorWithInvestmentSummaryResponse]
 */
export const zPaginatedResponseInvestorWithInvestmentSummaryResponse = z.object({
    items: z.array(zInvestorWithInvestmentSummaryResponse),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int()
});

/**
 * DeductionMetricsResponse
 *
 * Response model for deduction metrics
 */
export const zAppSchemasBeneficiariesDeductionMetricsResponse = z.object({
    total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    reserved: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    completed: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    available: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    used: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    utilization_percentage: z.number(),
    revised: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/)
});

/**
 * BeneficiaryCurrentYearQuotaSummary
 *
 * Summary model for beneficiary current year fiscal quota with nested metrics
 */
export const zBeneficiaryCurrentYearQuotaSummary = z.object({
    fiscal_year: z.int(),
    deduction: zAppSchemasBeneficiariesDeductionMetricsResponse,
    investment: zInvestmentMetricsResponse
});

/**
 * BeneficiaryResponseWithStats
 *
 * Response model for beneficiary data with statistics
 */
export const zBeneficiaryResponseWithStats = z.object({
    uuid: z.uuid(),
    name: z.string(),
    tax_id: z.string(),
    company_type: zCompanyType,
    main_activities: z.array(zAppDomainBeneficiariesEnumsCulturalActivity),
    status: zEntityStatus,
    constitution_date: z.iso.date().nullable(),
    address: z.string().nullable(),
    city: z.string().nullable(),
    state: z.string().nullable(),
    postal_code: z.string().nullable(),
    country: z.string().nullable(),
    phone: z.string().nullable(),
    email: z.string().nullable(),
    website: z.string().nullable(),
    notes: z.string().nullable(),
    business_purpose: z.string().nullable(),
    cnae_code: z.string().nullable(),
    last_year_revenue: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).nullable(),
    employee_count: z.int().nullable(),
    incentive_type: zTaxIncentiveType.nullable(),
    signature_regime: zSignatureRegime.default('sole'),
    tags: z.array(zTagRefResponse),
    created_at: z.iso.datetime(),
    updated_at: z.iso.datetime(),
    total_projects_count: z.int(),
    current_year_quota: zBeneficiaryCurrentYearQuotaSummary.nullable(),
    has_available_quota: z.boolean(),
    has_current_year_quota: z.boolean(),
    primary_contact: zBeneficiaryPrimaryContactResponse.nullable()
});

/**
 * PaginatedResponse[BeneficiaryResponseWithStats]
 */
export const zPaginatedResponseBeneficiaryResponseWithStats = z.object({
    items: z.array(zBeneficiaryResponseWithStats),
    total_count: z.int(),
    limit: z.int(),
    offset: z.int()
});

/**
 * DeductionMetricsResponse
 *
 * Response model for fiscal deduction metrics.
 */
export const zAppSchemasDashboardDeductionMetricsResponse = z.object({
    total: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    reserved: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    completed: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    available: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/),
    utilization_rate: z.number(),
    revised_from_projects: z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d{0,2}0*$/).nullish()
});

/**
 * BeneficiaryQuotaMetricsResponse
 *
 * Response model for beneficiary quota metrics.
 * Business concept: "Cupo de Inversión" (Supply Side)
 */
export const zBeneficiaryQuotaMetricsResponse = z.object({
    deduction: zAppSchemasDashboardDeductionMetricsResponse,
    investment_capacity: zInvestmentCapacityMetricsResponse
});

/**
 * DashboardMetricsResponse
 *
 * Main response model for dashboard metrics endpoint.
 *
 * Structured around three business perspectives:
 * - beneficiary_quota: Supply side (Cupo de Inversión)
 * - investor_capacity: Demand side (Capacidad de Inversión)
 * - investments: Transactions (Inversión)
 */
export const zDashboardMetricsResponse = z.object({
    beneficiary_quota: zBeneficiaryQuotaMetricsResponse,
    investor_capacity: zInvestorCapacityMetricsResponse,
    investments: zInvestmentsMetricsResponse,
    contracts: zContractsMetricsResponse,
    metadata: zDashboardMetadataResponse
});

export const zListActivityQuery = z.object({
    cursor: z.string().max(200).nullish(),
    actor: z.array(z.string()).nullish(),
    category: z.array(zActivityCategory).nullish(),
    object_type: z.array(zEntityType).nullish(),
    object_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    fiscal_quota_uuid: z.array(z.uuid()).nullish(),
    investment_uuid: z.array(z.uuid()).nullish(),
    period: z.string().nullish(),
    occurred_from: z.iso.datetime().nullish(),
    occurred_to: z.iso.datetime().nullish(),
    search: z.string().max(255).nullish()
});

/**
 * Successful Response
 */
export const zListActivityResponse = zListResponseActivityEventResponse;

export const zAggregateActivityQuery = z.object({
    actor: z.array(z.string()).nullish(),
    category: z.array(zActivityCategory).nullish(),
    object_type: z.array(zEntityType).nullish(),
    object_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    fiscal_quota_uuid: z.array(z.uuid()).nullish(),
    investment_uuid: z.array(z.uuid()).nullish(),
    period: z.string().nullish(),
    occurred_from: z.iso.datetime().nullish(),
    occurred_to: z.iso.datetime().nullish(),
    search: z.string().max(255).nullish()
});

/**
 * Successful Response
 */
export const zAggregateActivityResponse = zActivityAggregatesResponse;

export const zPreviewActivityExportQuery = z.object({
    actor: z.array(z.string()).nullish(),
    category: z.array(zActivityCategory).nullish(),
    object_type: z.array(zEntityType).nullish(),
    object_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    fiscal_quota_uuid: z.array(z.uuid()).nullish(),
    investment_uuid: z.array(z.uuid()).nullish(),
    period: z.string().nullish(),
    occurred_from: z.iso.datetime().nullish(),
    occurred_to: z.iso.datetime().nullish(),
    search: z.string().max(255).nullish()
});

/**
 * Successful Response
 */
export const zPreviewActivityExportResponse = zExportPreviewResponse;

export const zExportActivityQuery = z.object({
    format: zExportFormat.optional().default('csv'),
    columns: z.string().nullish(),
    actor: z.array(z.string()).nullish(),
    category: z.array(zActivityCategory).nullish(),
    object_type: z.array(zEntityType).nullish(),
    object_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    fiscal_quota_uuid: z.array(z.uuid()).nullish(),
    investment_uuid: z.array(z.uuid()).nullish(),
    period: z.string().nullish(),
    occurred_from: z.iso.datetime().nullish(),
    occurred_to: z.iso.datetime().nullish(),
    search: z.string().max(255).nullish()
});

export const zListCommentThreadsQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(60),
    offset: z.int().gte(0).optional().default(0),
    status: z.enum(['open', 'resolved']).nullish().default('open'),
    is_read: z.boolean().nullish(),
    subject_type: zEntityType.nullish(),
    subject_uuid: z.array(z.uuid()).max(20).nullish()
});

/**
 * Successful Response
 */
export const zListCommentThreadsResponse = zPaginatedResponseCommentThreadResponse;

export const zCreateCommentThreadBody = zCommentThreadCreateRequest;

/**
 * Successful Response
 */
export const zCreateCommentThreadResponse = zCommentThreadDetailResponse;

export const zCommentSummaryQuery = z.object({
    subject_type: zEntityType.nullish(),
    subject_uuid: z.array(z.uuid()).max(20).nullish()
});

/**
 * Successful Response
 */
export const zCommentSummaryResponse2 = zCommentSummaryResponse;

export const zDeleteCommentThreadPath = z.object({
    thread_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteCommentThreadResponse = z.void();

export const zGetCommentThreadPath = z.object({
    thread_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetCommentThreadResponse = zCommentThreadDetailResponse;

export const zReplyToCommentThreadBody = zCommentBodyRequest;

export const zReplyToCommentThreadPath = z.object({
    thread_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReplyToCommentThreadResponse = zCommentThreadDetailResponse;

export const zDeleteCommentMessagePath = z.object({
    message_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteCommentMessageResponse = z.void();

export const zEditCommentMessageBody = zCommentBodyRequest;

export const zEditCommentMessagePath = z.object({
    message_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zEditCommentMessageResponse = z.void();

export const zResolveCommentThreadPath = z.object({
    thread_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zResolveCommentThreadResponse = z.void();

export const zReopenCommentThreadPath = z.object({
    thread_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReopenCommentThreadResponse = z.void();

export const zMuteCommentThreadPath = z.object({
    thread_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zMuteCommentThreadResponse = z.void();

export const zUnmuteCommentThreadPath = z.object({
    thread_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUnmuteCommentThreadResponse = z.void();

export const zReactToCommentMessageBody = zCommentReactionRequest;

export const zReactToCommentMessagePath = z.object({
    message_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReactToCommentMessageResponse = z.void();

export const zRemoveCommentReactionPath = z.object({
    message_uuid: z.uuid(),
    emoji_code: z.string()
});

/**
 * Successful Response
 */
export const zRemoveCommentReactionResponse = z.void();

export const zListNotesQuery = z.object({
    search: z.string().max(255).nullish(),
    sort: z.string().optional().default('updated_at:desc'),
    cursor: z.string().max(4096).nullish(),
    limit: z.int().gte(1).lte(100).optional().default(60),
    holder_type: zEntityType,
    holder_uuid: z.uuid(),
    include_descendants: z.boolean().optional().default(false),
    author_uuid: z.array(z.uuid()).max(100).nullish()
});

/**
 * Successful Response
 */
export const zListNotesResponse = zNoteListResponse;

export const zCreateNoteBody = zNoteCreateRequest;

/**
 * Successful Response
 */
export const zCreateNoteResponse = zNoteResponse;

export const zAggregateNotesQuery = z.object({
    holder_type: zEntityType,
    holder_uuid: z.uuid(),
    include_descendants: z.boolean().optional().default(false),
    author_uuid: z.array(z.uuid()).max(100).nullish()
});

/**
 * Successful Response
 */
export const zAggregateNotesResponse = zNoteAggregatesResponse;

export const zDeleteNotePath = z.object({
    note_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteNoteResponse = z.void();

export const zGetNotePath = z.object({
    note_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetNoteResponse = zNoteResponse;

export const zSaveNoteBody = zNoteSaveRequest;

export const zSaveNotePath = z.object({
    note_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zSaveNoteResponse = zNoteSavedResponse;

export const zAuthLoginUserBody = zAuthLoginRequest;

/**
 * Successful Response
 */
export const zAuthLoginUserResponse = zAuthTokenResponse;

export const zAuthRefreshTokenBody = zAuthRefreshRequest;

/**
 * Successful Response
 */
export const zAuthRefreshTokenResponse = zAuthTokenResponse;

export const zAuthLogoutBody = zAuthLogoutRequest;

/**
 * Successful Response
 */
export const zAuthLogoutResponse = z.void();

/**
 * Successful Response
 */
export const zSendVerifyEmailResponse = z.void();

export const zSendForgotPasswordEmailBody = zAuthResetPasswordRequest;

/**
 * Successful Response
 */
export const zSendForgotPasswordEmailResponse = z.void();

export const zResetPasswordBody = zAuthForgotPasswordRequest;

/**
 * Successful Response
 */
export const zResetPasswordResponse = z.void();

export const zChangePasswordBody = zAuthChangePasswordRequest;

/**
 * Successful Response
 */
export const zChangePasswordResponse = z.void();

export const zSwitchOrganizationBody = zAuthSwitchOrganizationRequest;

/**
 * Successful Response
 */
export const zSwitchOrganizationResponse = zAuthTokenResponse;

export const zRevokeOtherSessionsBody = zAuthRevokeOtherSessionsRequest;

/**
 * Successful Response
 */
export const zRevokeOtherSessionsResponse = zAuthRevokeOtherSessionsResponse;

export const zConfirmEmailChangeBody = zAuthConfirmEmailChangeRequest;

/**
 * Successful Response
 */
export const zConfirmEmailChangeResponse = z.void();

export const zConfirmEmailVerificationBody = zAuthVerifyEmailRequest;

/**
 * Successful Response
 */
export const zConfirmEmailVerificationResponse = z.void();

/**
 * Successful Response
 */
export const zGetMeResponse = zUserResponse;

export const zUpdateMeBody = zUserUpdate;

/**
 * Successful Response
 */
export const zUpdateMeResponse = zUserResponse;

export const zRequestEmailChangeBody = zEmailChangeRequestBody;

/**
 * Successful Response
 */
export const zRequestEmailChangeResponse = zEmailChangeAcceptedResponse;

/**
 * Successful Response
 */
export const zCancelEmailChangeResponse = z.void();

/**
 * Successful Response
 */
export const zGetMyMembershipsResponse = zListResponseMembershipResponse;

/**
 * Successful Response
 */
export const zGetMyInvitationsResponse = zListResponseUserInvitationResponse;

export const zSetDefaultMembershipBody = zSetDefaultOrganizationRequest;

/**
 * Successful Response
 */
export const zSetDefaultMembershipResponse = z.void();

/**
 * Successful Response
 */
export const zMentionableUsersResponse = zListResponseCommentPersonResponse;

/**
 * Response Handle Docusign Webhook
 *
 * Successful Response
 */
export const zHandleDocusignWebhookResponse = z.record(z.string(), z.unknown());

/**
 * Response Handle Docuseal Webhook
 *
 * Successful Response
 */
export const zHandleDocusealWebhookResponse = z.record(z.string(), z.unknown());

/**
 * Successful Response
 */
export const zDeleteAllNotificationsResponse = z.void();

export const zGetNotificationsQuery = z.object({
    is_read: z.boolean().nullish(),
    notification_type: zNotificationType.nullish(),
    search: z.string().nullish(),
    created_from: z.iso.datetime().nullish(),
    created_to: z.iso.datetime().nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0)
});

/**
 * Successful Response
 */
export const zGetNotificationsResponse = zPaginatedResponseNotificationResponse;

/**
 * Successful Response
 */
export const zGetNotificationStatsResponse = zNotificationStatsResponse;

export const zDeleteNotificationPath = z.object({
    notification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteNotificationResponse = z.void();

export const zGetNotificationPath = z.object({
    notification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetNotificationResponse = zNotificationResponse;

export const zMarkAsReadPath = z.object({
    notification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zMarkAsReadResponse = z.void();

export const zMarkAsUnreadPath = z.object({
    notification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zMarkAsUnreadResponse = z.void();

/**
 * Successful Response
 */
export const zMarkAllAsReadResponse = z.void();

/**
 * Successful Response
 */
export const zGetCurrentOrganizationResponse = zOrganizationResponse;

export const zUpdateOrganizationBody = zOrganizationUpdateRequest;

/**
 * Successful Response
 */
export const zUpdateOrganizationResponse = zOrganizationResponse;

export const zListOrganizationDocumentsQuery = z.object({
    document_type: zAppDomainDocumentsEnumsDocumentType.nullish(),
    status: zDocumentStatus.nullish(),
    search: z.string().nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0)
});

/**
 * Successful Response
 */
export const zListOrganizationDocumentsResponse = zPaginatedResponseDocumentWithReviewResponse;

export const zUploadOrganizationDocumentBody = zBodyUploadOrganizationDocument;

/**
 * Successful Response
 */
export const zUploadOrganizationDocumentResponse = zDocumentWithReviewResponse;

export const zDeleteOrganizationDocumentPath = z.object({
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteOrganizationDocumentResponse = z.void();

export const zGetOrganizationDocumentPath = z.object({
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetOrganizationDocumentResponse = zDocumentWithReviewResponse;

export const zUpdateOrganizationDocumentBody = zDocumentUpdateRequest;

export const zUpdateOrganizationDocumentPath = z.object({
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateOrganizationDocumentResponse = zDocumentWithReviewResponse;

export const zDownloadOrganizationDocumentPath = z.object({
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDownloadOrganizationDocumentResponse = zDocumentDownloadResponse;

export const zReviewOrganizationDocumentBody = zReviewUpdateRequest;

export const zReviewOrganizationDocumentPath = z.object({
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReviewOrganizationDocumentResponse = zDocumentWithReviewResponse;

/**
 * Successful Response
 */
export const zGetInvitationsResponse = zListResponseInvitationResponse;

export const zCreateInvitationBody = zInvitationCreateRequest;

/**
 * Successful Response
 */
export const zCreateInvitationResponse = zInvitationResponse;

export const zVerifyInvitationQuery = z.object({
    token: z.string(),
    invitation_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zVerifyInvitationResponse = zInvitationResponse;

/**
 * Body
 */
export const zResendInvitationBody = zInvitationMessageRequest.nullable();

export const zResendInvitationPath = z.object({
    invitation_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zResendInvitationResponse = zInvitationResponse;

export const zCompleteInvitationBody = zInvitationCompletionRequest;

export const zCompleteInvitationPath = z.object({
    invitation_uuid: z.uuid()
});

export const zCompleteInvitationQuery = z.object({
    token: z.string()
});

/**
 * Successful Response
 */
export const zCompleteInvitationResponse = zInvitationCompletionResponse;

export const zRevokeInvitationPath = z.object({
    invitation_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zRevokeInvitationResponse = z.void();

/**
 * Successful Response
 */
export const zGetMembersResponse = zListResponseMembershipResponse;

export const zRemoveMembershipPath = z.object({
    membership_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zRemoveMembershipResponse = z.void();

export const zUpdateMembershipBody = zMembershipUpdateRequest;

export const zUpdateMembershipPath = z.object({
    membership_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateMembershipResponse = zMembershipResponse;

export const zGetBeneficiariesQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'available',
        'created_at',
        'name',
        'quota_occupied',
        'sector',
        'total_projects_count',
        'volume'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0),
    status: z.array(zEntityStatus).nullish(),
    sector: z.array(zAppDomainBeneficiariesEnumsCulturalActivity).nullish(),
    incentive_type: z.array(zTaxIncentiveType).nullish(),
    company_type: z.array(zCompanyType).nullish(),
    tag: z.array(z.uuid()).nullish(),
    has_current_year_quota: z.boolean().nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetBeneficiariesResponse = zPaginatedResponseBeneficiaryResponseWithStats;

export const zCreateBeneficiaryBody = zBeneficiaryCreateRequest;

/**
 * Successful Response
 */
export const zCreateBeneficiaryResponse = zBeneficiaryResponse;

export const zGetBeneficiaryAggregatesQuery = z.object({
    aggregates: z.string(),
    status: z.array(zEntityStatus).nullish(),
    sector: z.array(zAppDomainBeneficiariesEnumsCulturalActivity).nullish(),
    incentive_type: z.array(zTaxIncentiveType).nullish(),
    company_type: z.array(zCompanyType).nullish(),
    tag: z.array(z.uuid()).nullish(),
    has_current_year_quota: z.boolean().nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetBeneficiaryAggregatesResponse = zBeneficiaryAggregatesResponse;

export const zGetBeneficiaryMetricsQuery = z.object({
    status: z.array(zEntityStatus).nullish(),
    sector: z.array(zAppDomainBeneficiariesEnumsCulturalActivity).nullish(),
    incentive_type: z.array(zTaxIncentiveType).nullish(),
    company_type: z.array(zCompanyType).nullish(),
    tag: z.array(z.uuid()).nullish(),
    has_current_year_quota: z.boolean().nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetBeneficiaryMetricsResponse = zBeneficiaryMetricsResponse;

export const zPreviewBeneficiariesExportQuery = z.object({
    status: z.array(zEntityStatus).nullish(),
    sector: z.array(zAppDomainBeneficiariesEnumsCulturalActivity).nullish(),
    incentive_type: z.array(zTaxIncentiveType).nullish(),
    company_type: z.array(zCompanyType).nullish(),
    tag: z.array(z.uuid()).nullish(),
    has_current_year_quota: z.boolean().nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zPreviewBeneficiariesExportResponse = zExportPreviewResponse;

export const zExportBeneficiariesQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'available',
        'created_at',
        'name',
        'quota_occupied',
        'sector',
        'total_projects_count',
        'volume'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    format: zExportFormat.optional().default('csv'),
    columns: z.string().nullish(),
    status: z.array(zEntityStatus).nullish(),
    sector: z.array(zAppDomainBeneficiariesEnumsCulturalActivity).nullish(),
    incentive_type: z.array(zTaxIncentiveType).nullish(),
    company_type: z.array(zCompanyType).nullish(),
    tag: z.array(z.uuid()).nullish(),
    has_current_year_quota: z.boolean().nullish(),
    search: z.string().nullish()
});

export const zBulkUpdateBeneficiariesBody = zBulkUpdateBeneficiariesRequest;

/**
 * Successful Response
 */
export const zBulkUpdateBeneficiariesResponse = zBulkActionResponse;

export const zBulkDeleteBeneficiariesBody = zBulkBeneficiariesRequest;

/**
 * Successful Response
 */
export const zBulkDeleteBeneficiariesResponse = zBulkActionResponse;

export const zDeleteBeneficiaryPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteBeneficiaryResponse = z.void();

export const zGetBeneficiaryDetailsPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetBeneficiaryDetailsResponse = zBeneficiaryWithDetailsResponse;

export const zUpdateBeneficiaryBody = zBeneficiaryUpdateRequest;

export const zUpdateBeneficiaryPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateBeneficiaryResponse = zBeneficiaryResponse;

export const zReplaceBeneficiaryTagsBody = zEntityTagsUpdateRequest;

export const zReplaceBeneficiaryTagsPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReplaceBeneficiaryTagsResponse = zEntityTagsResponse;

export const zListLegalRepresentativesPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zListLegalRepresentativesResponse = zListResponseBeneficiaryLegalRepresentativeResponse;

export const zCreateLegalRepresentativeBody = zBeneficiaryLegalRepresentativeCreateRequest;

export const zCreateLegalRepresentativePath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zCreateLegalRepresentativeResponse = zBeneficiaryLegalRepresentativeResponse;

export const zDeleteLegalRepresentativePath = z.object({
    beneficiary_uuid: z.uuid(),
    representative_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteLegalRepresentativeResponse = z.void();

export const zUpdateLegalRepresentativeBody = zBeneficiaryLegalRepresentativeUpdateRequest;

export const zUpdateLegalRepresentativePath = z.object({
    beneficiary_uuid: z.uuid(),
    representative_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateLegalRepresentativeResponse = zBeneficiaryLegalRepresentativeResponse;

export const zSetPrimaryLegalRepresentativePath = z.object({
    beneficiary_uuid: z.uuid(),
    representative_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zSetPrimaryLegalRepresentativeResponse = zBeneficiaryLegalRepresentativeResponse;

export const zListBankAccountsPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zListBankAccountsResponse = zListResponseBeneficiaryBankAccountResponse;

export const zCreateBankAccountBody = zBeneficiaryBankAccountCreateRequest;

export const zCreateBankAccountPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zCreateBankAccountResponse = zBeneficiaryBankAccountResponse;

export const zDeleteBankAccountPath = z.object({
    beneficiary_uuid: z.uuid(),
    bank_account_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteBankAccountResponse = z.void();

export const zUpdateBankAccountBody = zBeneficiaryBankAccountUpdateRequest;

export const zUpdateBankAccountPath = z.object({
    beneficiary_uuid: z.uuid(),
    bank_account_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateBankAccountResponse = zBeneficiaryBankAccountResponse;

export const zSetPrimaryBankAccountPath = z.object({
    beneficiary_uuid: z.uuid(),
    bank_account_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zSetPrimaryBankAccountResponse = zBeneficiaryBankAccountResponse;

export const zListFiscalQuotasPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zListFiscalQuotasResponse = zListResponseFiscalQuotaResponse;

export const zCreateFiscalQuotaBody = zFiscalQuotaCreateRequest;

export const zCreateFiscalQuotaPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zCreateFiscalQuotaResponse = zFiscalQuotaResponse;

export const zDeleteFiscalQuotaPath = z.object({
    beneficiary_uuid: z.uuid(),
    fiscal_quota_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteFiscalQuotaResponse = z.void();

export const zUpdateFiscalQuotaBody = zFiscalQuotaUpdateRequest;

export const zUpdateFiscalQuotaPath = z.object({
    beneficiary_uuid: z.uuid(),
    fiscal_quota_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateFiscalQuotaResponse = zFiscalQuotaResponse;

export const zGetFiscalYearSummaryPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zGetFiscalYearSummaryQuery = z.object({
    fiscal_year: z.int()
});

/**
 * Successful Response
 */
export const zGetFiscalYearSummaryResponse = zFiscalYearSummaryResponse;

export const zPreviewFiscalQuotaConsolidationPath = z.object({
    beneficiary_uuid: z.uuid(),
    fiscal_quota_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zPreviewFiscalQuotaConsolidationResponse = zConsolidationPreviewResponse;

export const zCommitFiscalQuotaConsolidationBody = zConsolidationCommitRequest;

export const zCommitFiscalQuotaConsolidationPath = z.object({
    beneficiary_uuid: z.uuid(),
    fiscal_quota_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zCommitFiscalQuotaConsolidationResponse = zFiscalQuotaResponse;

export const zReopenFiscalQuotaConsolidationPath = z.object({
    beneficiary_uuid: z.uuid(),
    fiscal_quota_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReopenFiscalQuotaConsolidationResponse = zFiscalQuotaResponse;

export const zListBeneficiaryDocumentsPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zListBeneficiaryDocumentsQuery = z.object({
    document_type: zAppDomainDocumentsEnumsDocumentType.nullish(),
    status: zDocumentStatus.nullish(),
    fiscal_quota_uuid: z.uuid().nullish(),
    search: z.string().nullish(),
    limit: z.int().gte(1).lte(500).optional().default(200),
    offset: z.int().gte(0).optional().default(0)
});

/**
 * Successful Response
 */
export const zListBeneficiaryDocumentsResponse = zBeneficiaryPortfolioResponse;

export const zUploadBeneficiaryDocumentBody = zBodyUploadBeneficiaryDocument;

export const zUploadBeneficiaryDocumentPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUploadBeneficiaryDocumentResponse = zDocumentWithReviewResponse;

export const zListBeneficiaryDocumentsByFiscalQuotaPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zListBeneficiaryDocumentsByFiscalQuotaQuery = z.object({
    document_type: zAppDomainDocumentsEnumsDocumentType.nullish(),
    status: zDocumentStatus.nullish(),
    review_status: zReviewStatus.nullish(),
    search: z.string().nullish(),
    per_group_limit: z.int().gte(1).lte(100).optional().default(20)
});

/**
 * Successful Response
 */
export const zListBeneficiaryDocumentsByFiscalQuotaResponse = zBeneficiaryDocumentsByFiscalQuotaResponse;

export const zDeleteBeneficiaryDocumentPath = z.object({
    beneficiary_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteBeneficiaryDocumentResponse = z.void();

export const zGetBeneficiaryDocumentPath = z.object({
    beneficiary_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetBeneficiaryDocumentResponse = zDocumentWithReviewResponse;

export const zUpdateBeneficiaryDocumentBody = zDocumentUpdateRequest;

export const zUpdateBeneficiaryDocumentPath = z.object({
    beneficiary_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateBeneficiaryDocumentResponse = zDocumentWithReviewResponse;

export const zDownloadBeneficiaryDocumentPath = z.object({
    beneficiary_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDownloadBeneficiaryDocumentResponse = zDocumentDownloadResponse;

export const zReviewBeneficiaryDocumentBody = zReviewUpdateRequest;

export const zReviewBeneficiaryDocumentPath = z.object({
    beneficiary_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReviewBeneficiaryDocumentResponse = zDocumentWithReviewResponse;

export const zGetProjectsQuery = z.object({
    state: z.array(zProjectState).nullish(),
    status: z.array(zProjectStatus).nullish(),
    subtype: z.array(zProjectSubtype).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    fiscal_quota_uuid: z.array(z.uuid()).nullish(),
    fiscal_year: z.array(z.int()).nullish(),
    search: z.string().nullish(),
    sort: z.string().nullish(),
    sort_by: z.enum([
        'created_at',
        'fiscal_year',
        'fundraising_deadline',
        'incentive',
        'state',
        'status',
        'title'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0)
});

/**
 * Successful Response
 */
export const zGetProjectsResponse = zFilteredPaginatedResponseProjectResponse;

export const zDeleteProjectPath = z.object({
    project_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteProjectResponse = z.void();

export const zGetProjectPath = z.object({
    project_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetProjectResponse = zProjectDetailResponse;

export const zUpdateProjectBody = zProjectUpdateRequest;

export const zUpdateProjectPath = z.object({
    project_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateProjectResponse = zProjectResponse;

export const zGetBeneficiaryProjectsPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zGetBeneficiaryProjectsQuery = z.object({
    state: z.array(zProjectState).nullish()
});

/**
 * Successful Response
 */
export const zGetBeneficiaryProjectsResponse = zListResponseProjectResponse;

export const zCreateProjectForBeneficiaryBody = zProjectCreateRequest;

export const zCreateProjectForBeneficiaryPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zCreateProjectForBeneficiaryResponse = zProjectResponse;

export const zCreateProjectsBulkForBeneficiaryBody = zProjectBulkCreateRequest;

export const zCreateProjectsBulkForBeneficiaryPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zCreateProjectsBulkForBeneficiaryResponse = zProjectBulkCreateResponse;

export const zListProjectPostersPath = z.object({
    project_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zListProjectPostersResponse = zMediaListResponse;

export const zAddProjectPosterBody = zBodyAddProjectPoster;

export const zAddProjectPosterPath = z.object({
    project_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zAddProjectPosterResponse = zDocumentWithReviewResponse;

export const zDeleteProjectPosterByUuidPath = z.object({
    project_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteProjectPosterByUuidResponse = z.void();

export const zSetProjectCoverBody = zProjectCoverRequest;

export const zSetProjectCoverPath = z.object({
    project_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zSetProjectCoverResponse = z.void();

export const zDeleteProjectPosterPath = z.object({
    project_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteProjectPosterResponse = z.void();

export const zGetProjectPosterPath = z.object({
    project_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetProjectPosterResponse = zDocumentDownloadResponse;

export const zCreateProjectPosterBody = zBodyCreateProjectPoster;

export const zCreateProjectPosterPath = z.object({
    project_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zCreateProjectPosterResponse = zDocumentWithReviewResponse;

export const zListProjectDocumentsPath = z.object({
    project_uuid: z.uuid()
});

export const zListProjectDocumentsQuery = z.object({
    document_type: zAppDomainDocumentsEnumsDocumentType.nullish(),
    status: zDocumentStatus.nullish(),
    search: z.string().nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0)
});

/**
 * Successful Response
 */
export const zListProjectDocumentsResponse = zPaginatedResponseDocumentWithReviewResponse;

export const zUploadProjectDocumentBody = zBodyUploadProjectDocument;

export const zUploadProjectDocumentPath = z.object({
    project_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUploadProjectDocumentResponse = zDocumentWithReviewResponse;

export const zDeleteProjectDocumentPath = z.object({
    project_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteProjectDocumentResponse = z.void();

export const zGetProjectDocumentPath = z.object({
    project_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetProjectDocumentResponse = zDocumentWithReviewResponse;

export const zUpdateProjectDocumentBody = zDocumentUpdateRequest;

export const zUpdateProjectDocumentPath = z.object({
    project_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateProjectDocumentResponse = zDocumentWithReviewResponse;

export const zDownloadProjectDocumentPath = z.object({
    project_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDownloadProjectDocumentResponse = zDocumentDownloadResponse;

export const zReviewProjectDocumentBody = zReviewUpdateRequest;

export const zReviewProjectDocumentPath = z.object({
    project_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReviewProjectDocumentResponse = zDocumentWithReviewResponse;

export const zGetInvestorMetricsQuery = z.object({
    status: z.array(zEntityStatus).nullish(),
    investor_type: z.array(zInvestorType).nullish(),
    tag: z.array(z.uuid()).nullish(),
    search: z.string().nullish(),
    uuid: z.array(z.uuid()).nullish(),
    fiscal_year: z.int().nullish()
});

/**
 * Successful Response
 */
export const zGetInvestorMetricsResponse = zInvestorMetricsResponse;

export const zListInvestorsQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'created_at',
        'money.available',
        'money.investment.committed',
        'money.potential',
        'name',
        'number_investments',
        'type'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    limit: z.int().gte(1).lte(100).optional().default(10),
    offset: z.int().gte(0).optional().default(0),
    status: z.array(zEntityStatus).nullish(),
    investor_type: z.array(zInvestorType).nullish(),
    tag: z.array(z.uuid()).nullish(),
    search: z.string().nullish(),
    uuid: z.array(z.uuid()).nullish(),
    fiscal_year: z.int().nullish()
});

/**
 * Successful Response
 */
export const zListInvestorsResponse = zPaginatedResponseInvestorWithInvestmentSummaryResponse;

export const zGetInvestorAggregatesQuery = z.object({
    aggregates: z.string(),
    status: z.array(zEntityStatus).nullish(),
    investor_type: z.array(zInvestorType).nullish(),
    tag: z.array(z.uuid()).nullish(),
    search: z.string().nullish(),
    uuid: z.array(z.uuid()).nullish(),
    fiscal_year: z.int().nullish()
});

/**
 * Successful Response
 */
export const zGetInvestorAggregatesResponse = zInvestorAggregatesResponse;

export const zPreviewInvestorsExportQuery = z.object({
    status: z.array(zEntityStatus).nullish(),
    investor_type: z.array(zInvestorType).nullish(),
    tag: z.array(z.uuid()).nullish(),
    search: z.string().nullish(),
    uuid: z.array(z.uuid()).nullish(),
    fiscal_year: z.int().nullish()
});

/**
 * Successful Response
 */
export const zPreviewInvestorsExportResponse = zExportPreviewResponse;

export const zExportInvestorsQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'created_at',
        'money.available',
        'money.investment.committed',
        'money.potential',
        'name',
        'number_investments',
        'type'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    format: zExportFormat.optional().default('csv'),
    columns: z.string().nullish(),
    status: z.array(zEntityStatus).nullish(),
    investor_type: z.array(zInvestorType).nullish(),
    tag: z.array(z.uuid()).nullish(),
    search: z.string().nullish(),
    uuid: z.array(z.uuid()).nullish(),
    fiscal_year: z.int().nullish()
});

export const zCreateIndividualInvestorBody = zIndividualCreateRequest;

/**
 * Successful Response
 */
export const zCreateIndividualInvestorResponse = zIndividualResponse;

export const zGetInvestorMusicDeductionSummaryPath = z.object({
    investor_uuid: z.uuid()
});

export const zGetInvestorMusicDeductionSummaryQuery = z.object({
    fiscal_year: z.int()
});

/**
 * Successful Response
 */
export const zGetInvestorMusicDeductionSummaryResponse = zInvestorMusicDeductionSummaryResponse;

export const zGetIndividualInvestorPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetIndividualInvestorResponse = zIndividualResponse;

export const zUpdateIndividualInvestorBody = zIndividualUpdateRequest;

export const zUpdateIndividualInvestorPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateIndividualInvestorResponse = zIndividualResponse;

export const zCreateCompanyInvestorBody = zCompanyCreateRequest;

/**
 * Successful Response
 */
export const zCreateCompanyInvestorResponse = zCompanyResponse;

export const zGetCompanyInvestorPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetCompanyInvestorResponse = zCompanyResponse;

export const zUpdateCompanyInvestorBody = zCompanyUpdateRequest;

export const zUpdateCompanyInvestorPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateCompanyInvestorResponse = zCompanyResponse;

export const zBulkActivateInvestorsBody = zBulkInvestorsRequest;

/**
 * Successful Response
 */
export const zBulkActivateInvestorsResponse = zBulkActionResponse;

export const zBulkDeactivateInvestorsBody = zBulkInvestorsRequest;

/**
 * Successful Response
 */
export const zBulkDeactivateInvestorsResponse = zBulkActionResponse;

export const zBulkArchiveInvestorsBody = zBulkInvestorsRequest;

/**
 * Successful Response
 */
export const zBulkArchiveInvestorsResponse = zBulkActionResponse;

export const zBulkDeleteInvestorsBody = zBulkInvestorsRequest;

/**
 * Successful Response
 */
export const zBulkDeleteInvestorsResponse = zBulkActionResponse;

export const zDeleteInvestorPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteInvestorResponse = z.void();

export const zGetInvestorPath = z.object({
    investor_uuid: z.uuid()
});

export const zGetInvestorQuery = z.object({
    fiscal_year: z.int().nullish()
});

/**
 * Response Get Investor
 *
 * Successful Response
 */
export const zGetInvestorResponse = z.discriminatedUnion('type', [
    zIndividualDetailResponse,
    zCompanyDetailResponse
]);

export const zActivateInvestorPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zActivateInvestorResponse = zInvestorOperationResponse;

export const zDeactivateInvestorPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeactivateInvestorResponse = zInvestorOperationResponse;

export const zArchiveInvestorPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zArchiveInvestorResponse = zInvestorOperationResponse;

export const zListInvestorLegalRepresentativesPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zListInvestorLegalRepresentativesResponse = zListResponseInvestorLegalRepresentativeResponse;

export const zCreateInvestorLegalRepresentativeBody = zInvestorLegalRepresentativeCreateRequest;

export const zCreateInvestorLegalRepresentativePath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zCreateInvestorLegalRepresentativeResponse = zInvestorLegalRepresentativeResponse;

export const zDeleteInvestorLegalRepresentativePath = z.object({
    investor_uuid: z.uuid(),
    representative_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteInvestorLegalRepresentativeResponse = z.void();

export const zUpdateInvestorLegalRepresentativeBody = zInvestorLegalRepresentativeUpdateRequest;

export const zUpdateInvestorLegalRepresentativePath = z.object({
    investor_uuid: z.uuid(),
    representative_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateInvestorLegalRepresentativeResponse = zInvestorLegalRepresentativeResponse;

export const zSetPrimaryInvestorLegalRepresentativePath = z.object({
    investor_uuid: z.uuid(),
    representative_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zSetPrimaryInvestorLegalRepresentativeResponse = zInvestorLegalRepresentativeResponse;

export const zReplaceInvestorTagsBody = zEntityTagsUpdateRequest;

export const zReplaceInvestorTagsPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReplaceInvestorTagsResponse = zEntityTagsResponse;

/**
 * Body
 */
export const zInviteInvestorToHubBody = zInvitationMessageRequest.nullable();

export const zInviteInvestorToHubPath = z.object({
    investor_uuid: z.uuid()
});

export const zInviteInvestorToHubQuery = z.object({
    lang: z.string().nullish()
});

/**
 * Successful Response
 */
export const zInviteInvestorToHubResponse = zInvitationResponse;

export const zRevokeInvestorHubAccessPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zRevokeInvestorHubAccessResponse = z.void();

export const zListInvestorDocumentsPath = z.object({
    investor_uuid: z.uuid()
});

export const zListInvestorDocumentsQuery = z.object({
    document_type: zAppDomainDocumentsEnumsDocumentType.nullish(),
    status: zDocumentStatus.nullish(),
    fiscal_quota_uuid: z.uuid().nullish(),
    search: z.string().nullish(),
    limit: z.int().gte(1).lte(500).optional().default(200),
    offset: z.int().gte(0).optional().default(0)
});

/**
 * Successful Response
 */
export const zListInvestorDocumentsResponse = zInvestorPortfolioResponse;

export const zUploadInvestorDocumentBody = zBodyUploadInvestorDocument;

export const zUploadInvestorDocumentPath = z.object({
    investor_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUploadInvestorDocumentResponse = zDocumentWithReviewResponse;

export const zDeleteInvestorDocumentPath = z.object({
    investor_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteInvestorDocumentResponse = z.void();

export const zGetInvestorDocumentPath = z.object({
    investor_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetInvestorDocumentResponse = zDocumentWithReviewResponse;

export const zUpdateInvestorDocumentBody = zDocumentUpdateRequest;

export const zUpdateInvestorDocumentPath = z.object({
    investor_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateInvestorDocumentResponse = zDocumentWithReviewResponse;

export const zDownloadInvestorDocumentPath = z.object({
    investor_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDownloadInvestorDocumentResponse = zDocumentDownloadResponse;

export const zReviewInvestorDocumentBody = zReviewUpdateRequest;

export const zReviewInvestorDocumentPath = z.object({
    investor_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReviewInvestorDocumentResponse = zDocumentWithReviewResponse;

export const zListProposalsQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'created_at',
        'expires_at',
        'fiscal_year',
        'investor_name',
        'status',
        'taxable_base'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0),
    investor_uuid: z.array(z.uuid()).nullish(),
    status: z.array(zInvestmentProposalDisplayStatus).nullish(),
    fiscal_year: z.array(z.int()).nullish()
});

/**
 * Successful Response
 */
export const zListProposalsResponse = zPaginatedResponseInvestmentProposalResponse;

export const zCreateProposalBody = zInvestmentProposalCreateRequest;

/**
 * Successful Response
 */
export const zCreateProposalResponse = zInvestmentProposalResponse;

export const zDeleteProposalPath = z.object({
    proposal_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteProposalResponse = z.void();

export const zGetProposalPath = z.object({
    proposal_uuid: z.uuid()
});

export const zGetProposalQuery = z.object({
    token: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetProposalResponse = zInvestmentProposalResponse;

export const zResendProposalPath = z.object({
    proposal_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zResendProposalResponse = zInvestmentProposalResponse;

export const zCreateInvestmentFromProposalBody = zInvestmentTermsRequest;

export const zCreateInvestmentFromProposalPath = z.object({
    proposal_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zCreateInvestmentFromProposalResponse = zInvestmentResponse;

export const zAcceptProposalPath = z.object({
    proposal_uuid: z.uuid()
});

export const zAcceptProposalQuery = z.object({
    token: z.string()
});

/**
 * Successful Response
 */
export const zAcceptProposalResponse = z.void();

export const zDeclineProposalPath = z.object({
    proposal_uuid: z.uuid()
});

export const zDeclineProposalQuery = z.object({
    token: z.string()
});

/**
 * Successful Response
 */
export const zDeclineProposalResponse = z.void();

export const zExtendReservationBody = zExtendReservationRequest;

export const zExtendReservationPath = z.object({
    investment_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zExtendReservationResponse2 = zExtendReservationResponse;

export const zSendReservationContractBody = zSendReservationContractRequest;

export const zSendReservationContractPath = z.object({
    investment_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zSendReservationContractResponse2 = zSendReservationContractResponse;

export const zPreviewReservationContractBody = zPreviewReservationContractRequest;

export const zPreviewReservationContractPath = z.object({
    investment_uuid: z.uuid()
});

export const zResendDocumentPath = z.object({
    investment_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zResendDocumentResponse2 = zResendDocumentResponse;

export const zSendFinancingContractBody = zSendFinancingContractRequest;

export const zSendFinancingContractPath = z.object({
    investment_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zSendFinancingContractResponse2 = zSendFinancingContractResponse;

export const zPreviewFinancingContractBody = zPreviewFinancingContractRequest;

export const zPreviewFinancingContractPath = z.object({
    investment_uuid: z.uuid()
});

export const zSendCommunicationContractBody = zSendCommunicationContractRequest;

export const zSendCommunicationContractPath = z.object({
    investment_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zSendCommunicationContractResponse2 = zSendCommunicationContractResponse;

export const zRetryContractDispatchPath = z.object({
    investment_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zRetryContractDispatchResponse2 = zRetryContractDispatchResponse;

export const zPreviewCommunicationContractBody = zPreviewCommunicationContractRequest;

export const zPreviewCommunicationContractPath = z.object({
    investment_uuid: z.uuid()
});

export const zVoidContractBody = zVoidContractRequest;

export const zVoidContractPath = z.object({
    investment_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zVoidContractResponse2 = zVoidContractResponse;

export const zDownloadAeatDocumentsBody = zDownloadAeatDocumentsRequest;

export const zDownloadAeatDocumentsPath = z.object({
    investment_uuid: z.uuid()
});

export const zListInvestmentsQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'amount',
        'beneficiary_name',
        'created_at',
        'investor_name',
        'return_percentage',
        'state'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0),
    state: z.array(zInvestmentState).nullish(),
    investor_type: z.array(zInvestorType).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    fiscal_quota_uuid: z.array(z.uuid()).nullish(),
    search: z.string().nullish(),
    amount_min: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    amount_max: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    fiscal_year: z.array(z.int()).nullish()
});

/**
 * Successful Response
 */
export const zListInvestmentsResponse = zFilteredPaginatedResponseInvestmentWithDetailsResponse;

export const zCreateInvestmentBody = zInvestmentCreateRequest;

/**
 * Successful Response
 */
export const zCreateInvestmentResponse = zInvestmentWriteResponse;

export const zGetInvestmentAggregatesQuery = z.object({
    aggregates: z.string(),
    state: z.array(zInvestmentState).nullish(),
    investor_type: z.array(zInvestorType).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    fiscal_quota_uuid: z.array(z.uuid()).nullish(),
    search: z.string().nullish(),
    amount_min: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    amount_max: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    fiscal_year: z.array(z.int()).nullish()
});

/**
 * Successful Response
 */
export const zGetInvestmentAggregatesResponse = zInvestmentAggregatesResponse;

export const zListOrganizationInvestmentEventsQuery = z.object({
    limit: z.int().gte(1).lte(200).optional().default(20),
    offset: z.int().gte(0).optional().default(0)
});

/**
 * Successful Response
 */
export const zListOrganizationInvestmentEventsResponse = zPaginatedResponseOrganizationInvestmentEventResponse;

export const zPreviewInvestmentsExportQuery = z.object({
    state: z.array(zInvestmentState).nullish(),
    investor_type: z.array(zInvestorType).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    fiscal_quota_uuid: z.array(z.uuid()).nullish(),
    search: z.string().nullish(),
    amount_min: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    amount_max: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    fiscal_year: z.array(z.int()).nullish()
});

/**
 * Successful Response
 */
export const zPreviewInvestmentsExportResponse = zExportPreviewResponse;

export const zExportInvestmentsQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'amount',
        'beneficiary_name',
        'created_at',
        'investor_name',
        'return_percentage',
        'state'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    format: zExportFormat.optional().default('csv'),
    columns: z.string().nullish(),
    state: z.array(zInvestmentState).nullish(),
    investor_type: z.array(zInvestorType).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    fiscal_quota_uuid: z.array(z.uuid()).nullish(),
    search: z.string().nullish(),
    amount_min: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    amount_max: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    fiscal_year: z.array(z.int()).nullish()
});

export const zDeleteInvestmentPath = z.object({
    investment_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteInvestmentResponse = z.void();

export const zGetInvestmentPath = z.object({
    investment_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetInvestmentResponse = zInvestmentWithDetailsResponse;

export const zUpdateInvestmentBody = zInvestmentUpdateRequest;

export const zUpdateInvestmentPath = z.object({
    investment_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateInvestmentResponse = zInvestmentWriteResponse;

export const zBulkUpdateInvestmentsBody = zBulkUpdateInvestmentsRequest;

/**
 * Successful Response
 */
export const zBulkUpdateInvestmentsResponse = zBulkActionResponse;

export const zListInvestmentDocumentsPath = z.object({
    investment_uuid: z.uuid()
});

export const zListInvestmentDocumentsQuery = z.object({
    document_type: zAppDomainDocumentsEnumsDocumentType.nullish(),
    status: zDocumentStatus.nullish(),
    search: z.string().nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0)
});

/**
 * Successful Response
 */
export const zListInvestmentDocumentsResponse = zPaginatedResponseInvestmentDocumentResponse;

export const zUploadInvestmentDocumentBody = zBodyUploadInvestmentDocument;

export const zUploadInvestmentDocumentPath = z.object({
    investment_uuid: z.uuid()
});

export const zUploadInvestmentDocumentQuery = z.object({
    document_type: zAppDomainDocumentsEnumsDocumentType,
    title: z.string().nullish()
});

/**
 * Successful Response
 */
export const zUploadInvestmentDocumentResponse = zInvestmentDocumentResponse;

export const zDeleteInvestmentDocumentPath = z.object({
    investment_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteInvestmentDocumentResponse = z.void();

export const zGetInvestmentDocumentPath = z.object({
    investment_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetInvestmentDocumentResponse = zInvestmentDocumentResponse;

export const zUpdateInvestmentDocumentBody = zDocumentUpdateRequest;

export const zUpdateInvestmentDocumentPath = z.object({
    investment_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateInvestmentDocumentResponse = zInvestmentDocumentResponse;

export const zDownloadInvestmentDocumentPath = z.object({
    investment_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDownloadInvestmentDocumentResponse = zDocumentDownloadResponse;

export const zReviewInvestmentDocumentBody = zReviewUpdateRequest;

export const zReviewInvestmentDocumentPath = z.object({
    investment_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReviewInvestmentDocumentResponse = zInvestmentDocumentResponse;

export const zListAllFiscalQuotasQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'beneficiary_name',
        'fiscal_year',
        'investments_count',
        'money.estimate.available',
        'money.estimate.capacity',
        'money.investment.committed',
        'state'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0),
    fiscal_year: z.array(z.int()).nullish(),
    state: z.array(zFiscalQuotaState).nullish(),
    incentive_type: z.array(zTaxIncentiveType).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zListAllFiscalQuotasResponse = zFilteredPaginatedResponseFiscalQuotaListItemResponse;

export const zGetFiscalQuotaAggregatesQuery = z.object({
    aggregates: z.string(),
    fiscal_year: z.array(z.int()).nullish(),
    state: z.array(zFiscalQuotaState).nullish(),
    incentive_type: z.array(zTaxIncentiveType).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetFiscalQuotaAggregatesResponse = zFiscalQuotaAggregatesResponse;

export const zPreviewFiscalQuotasExportQuery = z.object({
    fiscal_year: z.array(z.int()).nullish(),
    state: z.array(zFiscalQuotaState).nullish(),
    incentive_type: z.array(zTaxIncentiveType).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zPreviewFiscalQuotasExportResponse = zExportPreviewResponse;

export const zExportFiscalQuotasQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'beneficiary_name',
        'fiscal_year',
        'investments_count',
        'money.estimate.available',
        'money.estimate.capacity',
        'money.investment.committed',
        'state'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    format: zExportFormat.optional().default('csv'),
    columns: z.string().nullish(),
    fiscal_year: z.array(z.int()).nullish(),
    state: z.array(zFiscalQuotaState).nullish(),
    incentive_type: z.array(zTaxIncentiveType).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    search: z.string().nullish()
});

export const zGetFiscalQuotaPath = z.object({
    fiscal_quota_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetFiscalQuotaResponse = zFiscalQuotaDetailResponse;

export const zBulkDeleteFiscalQuotasBody = zBulkFiscalQuotasRequest;

/**
 * Successful Response
 */
export const zBulkDeleteFiscalQuotasResponse = zBulkActionResponse;

export const zGenerateExpenseAuditBody = zGenerateExpenseAuditRequest;

export const zGenerateExpenseAuditPath = z.object({
    fiscal_quota_uuid: z.uuid()
});

export const zListFiscalQuotaReportsPath = z.object({
    fiscal_quota_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zListFiscalQuotaReportsResponse = zQuotaReportsResponse;

export const zDeleteFiscalQuotaReportPath = z.object({
    fiscal_quota_uuid: z.uuid(),
    document_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteFiscalQuotaReportResponse = z.void();

export const zPreviewExpenseAuditBody = zPreviewExpenseAuditRequest;

export const zPreviewExpenseAuditPath = z.object({
    fiscal_quota_uuid: z.uuid()
});

export const zListContractsQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'beneficiary_name',
        'contract_type',
        'created_at',
        'investment_amount',
        'investor_name',
        'sent_at',
        'status',
        'uploaded_at'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0),
    status: z.array(zContractDisplayStatus).nullish(),
    contract_type: z.array(zContractType).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    document_uuid: z.uuid().nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zListContractsResponse = zFilteredPaginatedResponseContractSummary;

export const zGetContractStatsQuery = z.object({
    status: z.array(zContractDisplayStatus).nullish(),
    contract_type: z.array(zContractType).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    document_uuid: z.uuid().nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetContractStatsResponse = zContractStatsResponse;

export const zGetContractAggregatesQuery = z.object({
    aggregates: z.string(),
    status: z.array(zContractDisplayStatus).nullish(),
    contract_type: z.array(zContractType).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    document_uuid: z.uuid().nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetContractAggregatesResponse = zContractAggregatesResponse;

export const zPreviewContractsExportQuery = z.object({
    status: z.array(zContractDisplayStatus).nullish(),
    contract_type: z.array(zContractType).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    document_uuid: z.uuid().nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zPreviewContractsExportResponse = zExportPreviewResponse;

export const zExportContractsQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'beneficiary_name',
        'contract_type',
        'created_at',
        'investment_amount',
        'investor_name',
        'sent_at',
        'status',
        'uploaded_at'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    format: zExportFormat.optional().default('csv'),
    columns: z.string().nullish(),
    status: z.array(zContractDisplayStatus).nullish(),
    contract_type: z.array(zContractType).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    document_uuid: z.uuid().nullish(),
    search: z.string().nullish()
});

export const zBulkResendContractsBody = zBulkContractsRequest;

/**
 * Successful Response
 */
export const zBulkResendContractsResponse = zBulkActionResponse;

export const zGetContractDetailsPath = z.object({
    contract_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetContractDetailsResponse = zContractDetailsResponse;

export const zGetContractDocumentPath = z.object({
    contract_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetContractDocumentResponse = zDocumentDownloadResponse;

export const zListTagsQuery = z.object({
    search: z.string().nullish(),
    sort: z.string().nullish()
});

/**
 * Successful Response
 */
export const zListTagsResponse = zListResponseTagResponse;

export const zCreateTagBody = zTagCreateRequest;

/**
 * Successful Response
 */
export const zCreateTagResponse = zTagResponse;

export const zDeleteTagPath = z.object({
    tag_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteTagResponse = z.void();

export const zUpdateTagBody = zTagUpdateRequest;

export const zUpdateTagPath = z.object({
    tag_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateTagResponse = zTagResponse;

export const zListTemplatesQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'category',
        'created_at',
        'name',
        'type',
        'updated_at'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0),
    type: z.array(zTemplateType).nullish(),
    category: z.array(zTemplateCategory).nullish(),
    language: z.array(zTemplateLanguage).nullish(),
    industry: z.array(zTemplateIndustry).nullish(),
    status: z.array(zEntityStatus).nullish(),
    origin: z.array(zTemplateOrigin).nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zListTemplatesResponse = zFilteredPaginatedResponseTemplateSummaryResponse;

export const zCreateTemplateBody = zTemplateCreateRequest;

/**
 * Successful Response
 */
export const zCreateTemplateResponse = zTemplateDetailResponse;

export const zGetTemplateAggregatesQuery = z.object({
    aggregates: z.string(),
    type: z.array(zTemplateType).nullish(),
    category: z.array(zTemplateCategory).nullish(),
    language: z.array(zTemplateLanguage).nullish(),
    industry: z.array(zTemplateIndustry).nullish(),
    status: z.array(zEntityStatus).nullish(),
    origin: z.array(zTemplateOrigin).nullish(),
    search: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetTemplateAggregatesResponse = zTemplateAggregatesResponse;

export const zBulkUpdateTemplatesBody = zBulkUpdateTemplatesRequest;

/**
 * Successful Response
 */
export const zBulkUpdateTemplatesResponse = zBulkActionResponse;

export const zBulkDuplicateTemplatesBody = zBulkDuplicateTemplatesRequest;

/**
 * Successful Response
 */
export const zBulkDuplicateTemplatesResponse = zBulkActionResponse;

export const zBulkDeleteTemplatesBody = zBulkTemplatesRequest;

/**
 * Successful Response
 */
export const zBulkDeleteTemplatesResponse = zBulkActionResponse;

export const zDeleteTemplatePath = z.object({
    template_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteTemplateResponse = z.void();

export const zGetTemplatePath = z.object({
    template_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetTemplateResponse = zTemplateDetailResponse;

export const zUpdateTemplateBody = zTemplateUpdateRequest;

export const zUpdateTemplatePath = z.object({
    template_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateTemplateResponse = zTemplateDetailResponse;

export const zDuplicateTemplateBody = zDuplicateTemplateRequest;

export const zDuplicateTemplatePath = z.object({
    template_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDuplicateTemplateResponse = zTemplateDetailResponse;

export const zUploadTemplateImageBody = zTemplateImageUploadRequest;

export const zUploadTemplateImagePath = z.object({
    template_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUploadTemplateImageResponse = zTemplateImageUploadResponse;

export const zGetTemplateImagePreviewBody = zTemplateImagePreviewRequest;

export const zGetTemplateImagePreviewPath = z.object({
    template_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetTemplateImagePreviewResponse = zTemplateImagePreviewResponse;

export const zPreviewTemplatePath = z.object({
    template_uuid: z.uuid()
});

export const zGetTemplateCompatibilityPath = z.object({
    template_uuid: z.uuid()
});

export const zGetTemplateCompatibilityQuery = z.object({
    action: zCompatibilityAction.nullish(),
    investment_uuid: z.uuid().nullish(),
    include_annexes: z.boolean().optional().default(false)
});

/**
 * Successful Response
 */
export const zGetTemplateCompatibilityResponse = zTemplateCompatibilityResponse;

export const zGetCatalogQuery = z.object({
    groups: z.string().nullish()
});

/**
 * Successful Response
 */
export const zGetCatalogResponse = zCatalogResponse;

export const zGetDashboardMetricsQuery = z.object({
    beneficiary_uuid: z.uuid().nullish(),
    fiscal_year: z.int().nullish()
});

/**
 * Successful Response
 */
export const zGetDashboardMetricsResponse = zDashboardMetricsResponse;

export const zGetInvestmentMetricsQuery = z.object({
    group_by: z.string().regex(/^(state|beneficiary|investor)$/).optional().default('state'),
    state: z.array(zInvestmentState).nullish(),
    investor_type: z.array(zInvestorType).nullish(),
    investor_uuid: z.array(z.uuid()).nullish(),
    beneficiary_uuid: z.array(z.uuid()).nullish(),
    fiscal_quota_uuid: z.array(z.uuid()).nullish(),
    search: z.string().nullish(),
    amount_min: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    amount_max: z.union([
        z.number(),
        z.string().regex(/^(?!^[-+.]*$)[+-]?0*\d*\.?\d*$/)
    ]).nullish(),
    fiscal_year: z.array(z.int()).nullish()
});

/**
 * Successful Response
 */
export const zGetInvestmentMetricsResponse = zInvestmentAggregationResponse;

export const zListPendingItemsQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'assignee',
        'domain',
        'due_at',
        'queue',
        'urgency'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0),
    domain: z.array(zPendingDomain).nullish(),
    queue: z.array(zPendingQueue).nullish(),
    urgency: z.array(zPendingUrgency).nullish(),
    assignee: z.array(z.string()).nullish(),
    due_from: z.iso.date().nullish(),
    due_to: z.iso.date().nullish(),
    search: z.string().nullish(),
    include: z.array(z.string()).nullish()
});

/**
 * Successful Response
 */
export const zListPendingItemsResponse = zFilteredPaginatedResponsePendingItemResponse;

/**
 * Successful Response
 */
export const zGetPendingItemsSummaryResponse = zPendingItemsSummaryResponse;

export const zGetPendingItemAggregatesQuery = z.object({
    aggregates: z.string(),
    domain: z.array(zPendingDomain).nullish(),
    queue: z.array(zPendingQueue).nullish(),
    urgency: z.array(zPendingUrgency).nullish(),
    assignee: z.array(z.string()).nullish(),
    due_from: z.iso.date().nullish(),
    due_to: z.iso.date().nullish(),
    search: z.string().nullish(),
    include: z.array(z.string()).nullish()
});

/**
 * Successful Response
 */
export const zGetPendingItemAggregatesResponse = zPendingItemAggregatesResponse;

export const zPreviewPendingItemsExportQuery = z.object({
    domain: z.array(zPendingDomain).nullish(),
    queue: z.array(zPendingQueue).nullish(),
    urgency: z.array(zPendingUrgency).nullish(),
    assignee: z.array(z.string()).nullish(),
    due_from: z.iso.date().nullish(),
    due_to: z.iso.date().nullish(),
    search: z.string().nullish(),
    include: z.array(z.string()).nullish()
});

/**
 * Successful Response
 */
export const zPreviewPendingItemsExportResponse = zExportPreviewResponse;

export const zExportPendingItemsQuery = z.object({
    sort: z.string().nullish(),
    sort_by: z.enum([
        'assignee',
        'domain',
        'due_at',
        'queue',
        'urgency'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    format: zExportFormat.optional().default('csv'),
    columns: z.string().nullish(),
    domain: z.array(zPendingDomain).nullish(),
    queue: z.array(zPendingQueue).nullish(),
    urgency: z.array(zPendingUrgency).nullish(),
    assignee: z.array(z.string()).nullish(),
    due_from: z.iso.date().nullish(),
    due_to: z.iso.date().nullish(),
    search: z.string().nullish(),
    include: z.array(z.string()).nullish()
});

export const zBulkAssignPendingItemsBody = zBulkAssignPendingItemsRequest;

/**
 * Successful Response
 */
export const zBulkAssignPendingItemsResponse = zBulkActionResponse;

export const zBulkSnoozePendingItemsBody = zBulkSnoozePendingItemsRequest;

/**
 * Successful Response
 */
export const zBulkSnoozePendingItemsResponse = zBulkActionResponse;

export const zBulkDismissPendingItemsBody = zBulkPendingItemsRequest;

/**
 * Successful Response
 */
export const zBulkDismissPendingItemsResponse = zBulkActionResponse;

export const zAssignPendingItemBody = zAssignPendingItemRequest.default({});

export const zAssignPendingItemPath = z.object({
    pending_item_code: z.string()
});

/**
 * Successful Response
 */
export const zAssignPendingItemResponse = zPendingItemStateResponse;

export const zSnoozePendingItemBody = zSnoozePendingItemRequest.default({});

export const zSnoozePendingItemPath = z.object({
    pending_item_code: z.string()
});

/**
 * Successful Response
 */
export const zSnoozePendingItemResponse = zPendingItemStateResponse;

export const zDismissPendingItemPath = z.object({
    pending_item_code: z.string()
});

/**
 * Successful Response
 */
export const zDismissPendingItemResponse = zPendingItemStateResponse;

/**
 * Successful Response
 */
export const zGetOrgEntitlementsResponse = zListResponseModuleEntitlementResponse;

export const zCreateUploadSessionBody = zCreateUploadSessionRequest;

export const zCreateUploadSessionPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zCreateUploadSessionResponse2 = zCreateUploadSessionResponse;

export const zSignUploadBatchBody = zSignUploadBatchRequest;

export const zSignUploadBatchPath = z.object({
    beneficiary_uuid: z.uuid(),
    session_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zSignUploadBatchResponse2 = zSignUploadBatchResponse;

export const zGetUploadSessionStatusPath = z.object({
    beneficiary_uuid: z.uuid(),
    session_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetUploadSessionStatusResponse = zUploadSessionStatusResponse;

export const zListClassificationsPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zListClassificationsQuery = z.object({
    status: z.array(zClassificationStatus).nullish(),
    document_type: z.array(zAppDomainClassificationsEnumsDocumentType).nullish(),
    search: z.string().nullish(),
    eligible: z.boolean().nullish(),
    expense_type: z.string().nullish(),
    eligibility: zEligibility.nullish(),
    requires_review: z.boolean().nullish(),
    rule_id: z.string().nullish(),
    fiscal_quota_uuid: z.uuid().nullish(),
    fiscal_category: z.array(z.string()).nullish(),
    parent_document_uuid: z.uuid().nullish(),
    month: z.array(z.int()).nullish(),
    sort_by: z.enum([
        'created_at',
        'document_date',
        'document_type',
        'filename',
        'status',
        'total_amount'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    sort: z.string().nullish(),
    limit: z.int().gte(1).lte(500).optional().default(50),
    offset: z.int().gte(0).optional().default(0)
});

/**
 * Successful Response
 */
export const zListClassificationsResponse = zFilteredPaginatedResponseClassificationResponse;

export const zPreviewClassificationsExportPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zPreviewClassificationsExportQuery = z.object({
    status: z.array(zClassificationStatus).nullish(),
    document_type: z.array(zAppDomainClassificationsEnumsDocumentType).nullish(),
    search: z.string().nullish(),
    eligibility: zEligibility.nullish(),
    requires_review: z.boolean().nullish(),
    rule_id: z.string().nullish(),
    fiscal_quota_uuid: z.uuid().nullish(),
    fiscal_category: z.array(z.string()).nullish(),
    expense_type: z.string().nullish(),
    parent_document_uuid: z.uuid().nullish(),
    month: z.array(z.int()).nullish(),
    uuids: z.array(z.uuid()).nullish()
});

/**
 * Successful Response
 */
export const zPreviewClassificationsExportResponse = zExportPreviewResponse;

export const zExportClassificationsPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zExportClassificationsQuery = z.object({
    status: z.array(zClassificationStatus).nullish(),
    document_type: z.array(zAppDomainClassificationsEnumsDocumentType).nullish(),
    search: z.string().nullish(),
    eligibility: zEligibility.nullish(),
    requires_review: z.boolean().nullish(),
    rule_id: z.string().nullish(),
    fiscal_quota_uuid: z.uuid().nullish(),
    fiscal_category: z.array(z.string()).nullish(),
    expense_type: z.string().nullish(),
    parent_document_uuid: z.uuid().nullish(),
    month: z.array(z.int()).nullish(),
    uuids: z.array(z.uuid()).nullish(),
    sort: z.string().nullish(),
    sort_by: z.enum([
        'created_at',
        'document_date',
        'document_type',
        'filename',
        'status',
        'total_amount'
    ]).nullish(),
    sort_direction: z.enum(['asc', 'desc']).nullish(),
    format: zExportFormat.optional().default('csv'),
    columns: z.string().nullish()
});

export const zGetClassificationStatsPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zGetClassificationStatsQuery = z.object({
    status: z.array(zClassificationStatus).nullish(),
    document_type: z.array(zAppDomainClassificationsEnumsDocumentType).nullish(),
    search: z.string().nullish(),
    eligible: z.boolean().nullish(),
    expense_type: z.string().nullish(),
    eligibility: zEligibility.nullish(),
    requires_review: z.boolean().nullish(),
    rule_id: z.string().nullish(),
    fiscal_quota_uuid: z.uuid().nullish(),
    fiscal_category: z.array(z.string()).nullish(),
    month: z.array(z.int()).nullish()
});

/**
 * Response Get Classification Stats
 *
 * Successful Response
 */
export const zGetClassificationStatsResponse = z.record(z.string(), z.int());

export const zListRuleIdsPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zListRuleIdsQuery = z.object({
    search: z.string().nullish(),
    limit: z.int().gte(1).lte(200).optional().default(50)
});

/**
 * Successful Response
 */
export const zListRuleIdsResponse = zRuleIdsResponse;

export const zGetClassificationSummaryPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zGetClassificationSummaryQuery = z.object({
    fiscal_quota_uuid: z.uuid().nullish(),
    status: zClassificationStatus.nullish(),
    document_type: z.array(zAppDomainClassificationsEnumsDocumentType).nullish(),
    eligible: z.boolean().nullish(),
    expense_type: z.string().nullish(),
    eligibility: zEligibility.nullish(),
    fiscal_category: z.array(z.string()).nullish(),
    month: z.array(z.int()).nullish()
});

/**
 * Successful Response
 */
export const zGetClassificationSummaryResponse = zClassificationSummaryResponse;

export const zGetClassificationPipelineStatusPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetClassificationPipelineStatusResponse = zPipelineStatusBreakdownResponse;

export const zGetSuppliersAnalyticsPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zGetSuppliersAnalyticsQuery = z.object({
    fiscal_quota_uuid: z.uuid().nullish(),
    expense_type: z.string().nullish(),
    eligibility: zEligibility.nullish(),
    fiscal_category: z.array(z.string()).nullish(),
    document_type: z.array(zAppDomainClassificationsEnumsDocumentType).nullish(),
    month: z.array(z.int()).nullish()
});

/**
 * Successful Response
 */
export const zGetSuppliersAnalyticsResponse = zSuppliersAnalyticsResponse;

export const zGetTaxBreakdownPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zGetTaxBreakdownQuery = z.object({
    fiscal_quota_uuid: z.uuid().nullish(),
    expense_type: z.string().nullish(),
    eligibility: zEligibility.nullish(),
    fiscal_category: z.array(z.string()).nullish(),
    document_type: z.array(zAppDomainClassificationsEnumsDocumentType).nullish(),
    month: z.array(z.int()).nullish()
});

/**
 * Successful Response
 */
export const zGetTaxBreakdownResponse = zTaxBreakdownAnalyticsResponse;

export const zGetWorkforceAnalyticsPath = z.object({
    beneficiary_uuid: z.uuid()
});

export const zGetWorkforceAnalyticsQuery = z.object({
    fiscal_quota_uuid: z.uuid().nullish(),
    eligibility: zEligibility.nullish(),
    fiscal_category: z.array(z.string()).nullish(),
    document_type: z.array(zAppDomainClassificationsEnumsDocumentType).nullish(),
    month: z.array(z.int()).nullish()
});

/**
 * Successful Response
 */
export const zGetWorkforceAnalyticsResponse = zWorkforceAnalyticsResponse;

export const zDeleteClassificationPath = z.object({
    beneficiary_uuid: z.uuid(),
    classification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zDeleteClassificationResponse = z.void();

export const zGetClassificationPath = z.object({
    beneficiary_uuid: z.uuid(),
    classification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetClassificationResponse = zClassificationResponse;

export const zUpdateClassificationBody = zUpdateClassificationRequest;

export const zUpdateClassificationPath = z.object({
    beneficiary_uuid: z.uuid(),
    classification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zUpdateClassificationResponse = zClassificationResponse;

export const zGetClassificationFilePath = z.object({
    beneficiary_uuid: z.uuid(),
    classification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetClassificationFileResponse = zDocumentDownloadResponse;

export const zReviewClassificationBody = zReviewClassificationRequest;

export const zReviewClassificationPath = z.object({
    beneficiary_uuid: z.uuid(),
    classification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReviewClassificationResponse = zClassificationResponse;

export const zResolveDuplicateBody = zResolveDuplicateRequest;

export const zResolveDuplicatePath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zResolveDuplicateResponse2 = zResolveDuplicateResponse;

export const zBulkDeleteClassificationsBody = zBulkClassificationsRequest;

export const zBulkDeleteClassificationsPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zBulkDeleteClassificationsResponse = zBulkActionResponse;

export const zBulkReclassifyClassificationsBody = zBulkClassificationsRequest;

export const zBulkReclassifyClassificationsPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zBulkReclassifyClassificationsResponse = zBulkActionResponse;

export const zBulkDeleteMatchingClassificationsBody = zClassificationSelectionRequest;

export const zBulkDeleteMatchingClassificationsPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zBulkDeleteMatchingClassificationsResponse = zBulkActionResponse;

export const zBulkReclassifyMatchingClassificationsBody = zClassificationSelectionRequest;

export const zBulkReclassifyMatchingClassificationsPath = z.object({
    beneficiary_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zBulkReclassifyMatchingClassificationsResponse = zBulkActionResponse;

export const zGetClassificationLocksPath = z.object({
    beneficiary_uuid: z.uuid(),
    classification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetClassificationLocksResponse = zClassificationLocksResponse;

export const zReplaceClassificationLocksBody = zReplaceFieldLocksRequest;

export const zReplaceClassificationLocksPath = z.object({
    beneficiary_uuid: z.uuid(),
    classification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReplaceClassificationLocksResponse = zClassificationResponse;

export const zResolveReviewFlagBody = zResolveReviewFlagRequest;

export const zResolveReviewFlagPath = z.object({
    beneficiary_uuid: z.uuid(),
    classification_uuid: z.uuid(),
    flag_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zResolveReviewFlagResponse = zClassificationResponse;

/**
 * Payload
 */
export const zReclassifyClassificationBody = zReclassifyClassificationRequest.nullable();

export const zReclassifyClassificationPath = z.object({
    beneficiary_uuid: z.uuid(),
    classification_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zReclassifyClassificationResponse = zClassificationResponse;

/**
 * Successful Response
 */
export const zGetDashboardStatsResponse = zAdminDashboardStats;

export const zListUsersQuery = z.object({
    limit: z.int().gte(1).lte(1000).optional().default(100),
    offset: z.int().gte(0).optional().default(0),
    is_active: z.boolean().nullish(),
    is_platform_admin: z.boolean().nullish()
});

/**
 * Response List Users
 *
 * Successful Response
 */
export const zListUsersResponse = z.array(zUserResponse);

export const zGetUserByUuidPath = z.object({
    user_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetUserByUuidResponse = zUserResponse;

export const zToggleUserStatusPath = z.object({
    user_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zToggleUserStatusResponse = zUserResponse;

export const zGetUserMembershipsPath = z.object({
    user_uuid: z.uuid()
});

/**
 * Response Get User Memberships
 *
 * Successful Response
 */
export const zGetUserMembershipsResponse = z.array(zMembershipResponse);

export const zSendResetPasswordEmailPath = z.object({
    user_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zSendResetPasswordEmailResponse = zMessageResponse;

/**
 * Response List All Organizations
 *
 * Successful Response
 */
export const zListAllOrganizationsResponse = z.array(zOrganizationResponse);

export const zCreateOrganizationBody = zOrganizationCreateRequest;

/**
 * Successful Response
 */
export const zCreateOrganizationResponse = zOrganizationResponse;

export const zAdminDeleteOrganizationPath = z.object({
    organization_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zAdminDeleteOrganizationResponse = z.void();

export const zGetOrganizationByUuidPath = z.object({
    organization_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGetOrganizationByUuidResponse = zOrganizationResponse;

export const zAdminUpdateOrganizationBody = zOrganizationUpdateRequest;

export const zAdminUpdateOrganizationPath = z.object({
    organization_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zAdminUpdateOrganizationResponse = zOrganizationResponse;

export const zAdminInviteUserBody = zInvitationCreateRequest;

export const zAdminInviteUserPath = z.object({
    organization_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zAdminInviteUserResponse = zInvitationResponse;

export const zListInvitationsPath = z.object({
    organization_uuid: z.uuid()
});

/**
 * Response List Invitations
 *
 * Successful Response
 */
export const zListInvitationsResponse = z.array(zInvitationResponse);

export const zAdminDeleteOrganizationInvitationPath = z.object({
    organization_uuid: z.uuid(),
    invitation_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zAdminDeleteOrganizationInvitationResponse = z.void();

export const zListMembersPath = z.object({
    organization_uuid: z.uuid()
});

/**
 * Response List Members
 *
 * Successful Response
 */
export const zListMembersResponse = z.array(zMembershipResponse);

export const zAdminDeleteMembershipPath = z.object({
    membership_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zAdminDeleteMembershipResponse = z.void();

export const zAdminUpdateMembershipBody = zMembershipUpdateRequest;

export const zAdminUpdateMembershipPath = z.object({
    membership_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zAdminUpdateMembershipResponse = zMembershipResponse;

export const zAdminCreateInvitationBody = zAdminInvitationCreateRequest;

/**
 * Successful Response
 */
export const zAdminCreateInvitationResponse = zInvitationResponse;

export const zAdminResendInvitationPath = z.object({
    invitation_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zAdminResendInvitationResponse = zInvitationResponse;

export const zAdminDeleteInvitationPath = z.object({
    invitation_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zAdminDeleteInvitationResponse = z.void();

export const zListEntitlementsPath = z.object({
    organization_uuid: z.uuid()
});

/**
 * Response List Entitlements
 *
 * Successful Response
 */
export const zListEntitlementsResponse = z.array(zAdminEntitlementResponse);

export const zGrantEntitlementBody = zAdminEntitlementCreateRequest;

export const zGrantEntitlementPath = z.object({
    organization_uuid: z.uuid()
});

/**
 * Successful Response
 */
export const zGrantEntitlementResponse = zAdminEntitlementResponse;

export const zUpdateEntitlementBody = zAdminEntitlementUpdateRequest;

export const zUpdateEntitlementPath = z.object({
    organization_uuid: z.uuid(),
    module_code: zModuleCode
});

/**
 * Successful Response
 */
export const zUpdateEntitlementResponse = zAdminEntitlementResponse;

export const zResetEntitlementQuotaPath = z.object({
    organization_uuid: z.uuid(),
    module_code: zModuleCode
});

/**
 * Successful Response
 */
export const zResetEntitlementQuotaResponse = zAdminEntitlementResponse;

export const zGetOrganizationUsagePath = z.object({
    organization_uuid: z.uuid()
});

export const zGetOrganizationUsageQuery = z.object({
    from: z.iso.datetime().nullish(),
    to: z.iso.datetime().nullish()
});

/**
 * Response Get Organization Usage
 *
 * Successful Response
 */
export const zGetOrganizationUsageResponse = z.array(zDomainUsageReportResponse);

/**
 * Successful Response
 */
export const zListMyProfilesResponse = zHubProfilesResponse;

export const zGetMyProfileQuery = z.object({
    investor_uuid: z.uuid().nullish()
});

/**
 * Successful Response
 */
export const zGetMyProfileResponse = zInvestorProfileResponse;

export const zUpdateMyProfileBody = zInvestorProfileUpdateRequest;

export const zUpdateMyProfileQuery = z.object({
    investor_uuid: z.uuid().nullish()
});

/**
 * Successful Response
 */
export const zUpdateMyProfileResponse = zInvestorProfileResponse;

export const zListMyInvestmentsQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(10),
    offset: z.int().gte(0).optional().default(0),
    investor_uuid: z.uuid().nullish()
});

/**
 * Successful Response
 */
export const zListMyInvestmentsResponse = zPaginatedResponseHubInvestmentResponse;

export const zGetMyInvestmentPath = z.object({
    investment_uuid: z.uuid()
});

export const zGetMyInvestmentQuery = z.object({
    investor_uuid: z.uuid().nullish()
});

/**
 * Successful Response
 */
export const zGetMyInvestmentResponse = zHubInvestmentDetailResponse;

export const zGetMyDashboardQuery = z.object({
    investor_uuid: z.uuid().nullish()
});

/**
 * Successful Response
 */
export const zGetMyDashboardResponse = zHubDashboardSummary;

export const zGetMyPendingActionsQuery = z.object({
    expiring_days: z.int().gte(1).lte(30).optional().default(7),
    investor_uuid: z.uuid().nullish()
});

/**
 * Successful Response
 */
export const zGetMyPendingActionsResponse = zHubPendingActionsResponse;

export const zGetMyDocumentsPortfolioQuery = z.object({
    document_type: zAppDomainDocumentsEnumsDocumentType.nullish(),
    status: zDocumentStatus.nullish(),
    fiscal_quota_uuid: z.uuid().nullish(),
    search: z.string().nullish(),
    limit: z.int().gte(1).lte(500).optional().default(200),
    offset: z.int().gte(0).optional().default(0),
    investor_uuid: z.uuid().nullish()
});

/**
 * Successful Response
 */
export const zGetMyDocumentsPortfolioResponse = zInvestorPortfolioResponse;

export const zListMyInvestmentDocumentsPath = z.object({
    investment_uuid: z.uuid()
});

export const zListMyInvestmentDocumentsQuery = z.object({
    limit: z.int().gte(1).lte(500).optional().default(100),
    offset: z.int().gte(0).optional().default(0),
    investor_uuid: z.uuid().nullish()
});

/**
 * Successful Response
 */
export const zListMyInvestmentDocumentsResponse = zPaginatedResponseInvestmentDocumentResponse;

export const zDownloadMyInvestmentDocumentPath = z.object({
    investment_uuid: z.uuid(),
    document_uuid: z.uuid()
});

export const zDownloadMyInvestmentDocumentQuery = z.object({
    investor_uuid: z.uuid().nullish()
});

/**
 * Successful Response
 */
export const zDownloadMyInvestmentDocumentResponse = zDocumentDownloadResponse;

export const zGetDocumentSigningUrlBody = zHubSigningUrlRequest;

export const zGetDocumentSigningUrlPath = z.object({
    investment_uuid: z.uuid(),
    document_uuid: z.uuid()
});

export const zGetDocumentSigningUrlQuery = z.object({
    investor_uuid: z.uuid().nullish()
});

/**
 * Successful Response
 */
export const zGetDocumentSigningUrlResponse = zHubSigningUrlResponse;

export const zUploadPaymentReceiptBody = zBodyUploadPaymentReceipt;

export const zUploadPaymentReceiptPath = z.object({
    investment_uuid: z.uuid()
});

export const zUploadPaymentReceiptQuery = z.object({
    investor_uuid: z.uuid().nullish()
});

/**
 * Successful Response
 */
export const zUploadPaymentReceiptResponse = zDocumentWithReviewResponse;
